export const CITIES = [
    {
        code: "05028001",
        name: "Abano Terme",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03098001",
        name: "Abbadia Cerreto",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03097001",
        name: "Abbadia Lariana",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "09052001",
        name: "Abbadia San Salvatore",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "20095001",
        name: "Abbasanta",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "13068001",
        name: "Abbateggio",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "03015002",
        name: "Abbiategrasso",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "09047023",
        name: "Abetone Cutigliano",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "17076001",
        name: "Abriola",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "19088001",
        name: "Acate",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "16071001",
        name: "Accadia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "01004001",
        name: "Acceglio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "17077001",
        name: "Accettura",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "13066001",
        name: "Acciano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "12057001",
        name: "Accumoli",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "17076002",
        name: "Acerenza",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15065001",
        name: "Acerno",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15063001",
        name: "Acerra",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "19087001",
        name: "Aci Bonaccorsi",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19087002",
        name: "Aci Castello",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19087003",
        name: "Aci Catena",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19087005",
        name: "Aci Sant'Antonio",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19087004",
        name: "Acireale",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "12060001",
        name: "Acquafondata",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "18078001",
        name: "Acquaformosa",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03017001",
        name: "Acquafredda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "11041001",
        name: "Acqualagna",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "03019001",
        name: "Acquanegra Cremonese",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03020001",
        name: "Acquanegra sul Chiese",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "12056001",
        name: "Acquapendente",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "18078002",
        name: "Acquappesa",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18102001",
        name: "Acquaro",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "11044001",
        name: "Acquasanta Terme",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "10055001",
        name: "Acquasparta",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "14070001",
        name: "Acquaviva Collecroce",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "14094001",
        name: "Acquaviva d'Isernia",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "16072001",
        name: "Acquaviva delle Fonti",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "11044002",
        name: "Acquaviva Picena",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "19085001",
        name: "Acquaviva Platani",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "19083107",
        name: "Acquedolci",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01006001",
        name: "Acqui Terme",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18078003",
        name: "Acri",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12060002",
        name: "Acuto",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "16072002",
        name: "Adelfia",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "19087006",
        name: "Adrano",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "03016001",
        name: "Adrara San Martino",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016002",
        name: "Adrara San Rocco",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05029001",
        name: "Adria",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "03017002",
        name: "Adro",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05023001",
        name: "Affi",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "12058001",
        name: "Affile",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15063002",
        name: "Afragola",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "18080001",
        name: "Africo",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "08033001",
        name: "Agazzano",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "15063003",
        name: "Agerola",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "20090001",
        name: "Aggius",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "19086001",
        name: "Agira",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "09047002",
        name: "Agliana",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "01005001",
        name: "Agliano Terme",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001001",
        name: "Agliè",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20090062",
        name: "Aglientu",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "05028002",
        name: "Agna",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03019002",
        name: "Agnadello",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18080002",
        name: "Agnana Calabra",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "14094002",
        name: "Agnone",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "03017003",
        name: "Agnosine",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05025001",
        name: "Agordo",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "12058002",
        name: "Agosta",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03012001",
        name: "Agra",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03108001",
        name: "Agrate Brianza",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "01003001",
        name: "Agrate Conturbia",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "19084001",
        name: "Agrigento",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "15065002",
        name: "Agropoli",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "11042001",
        name: "Agugliano",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "05024001",
        name: "Agugliaro",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03108002",
        name: "Aicurzio",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "20095002",
        name: "Aidomaggiore",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "19086002",
        name: "Aidone",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "13066002",
        name: "Aielli",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "18078004",
        name: "Aiello Calabro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "06030001",
        name: "Aiello del Friuli",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15064001",
        name: "Aiello del Sabato",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18078005",
        name: "Aieta",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15061001",
        name: "Ailano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01096001",
        name: "Ailoche",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01001002",
        name: "Airasca",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15062001",
        name: "Airola",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "07008001",
        name: "Airole",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "03097002",
        name: "Airuno",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01004002",
        name: "Aisone",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "04022001",
        name: "Ala",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20090002",
        name: "Alà dei Sardi",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01001003",
        name: "Ala di Stura",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018001",
        name: "Alagna",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01002002",
        name: "Alagna Valsesia",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "13068002",
        name: "Alanno",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "05025002",
        name: "Alano di Piave",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "07009001",
        name: "Alassio",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "12060003",
        name: "Alatri",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01004003",
        name: "Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13067001",
        name: "Alba Adriatica",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "20095003",
        name: "Albagiara",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "03015005",
        name: "Albairate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "15065003",
        name: "Albanella",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "17076003",
        name: "Albano di Lucania",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "12058003",
        name: "Albano Laziale",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03016003",
        name: "Albano Sant'Alessandro",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01002003",
        name: "Albano Vercellese",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03018002",
        name: "Albaredo Arnaboldi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05023002",
        name: "Albaredo d'Adige",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03014001",
        name: "Albaredo per San Marco",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "08034001",
        name: "Albareto",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "01004004",
        name: "Albaretto della Torre",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03013003",
        name: "Albavilla",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "07009002",
        name: "Albenga",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01006002",
        name: "Albera Ligure",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16072003",
        name: "Alberobello",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "16071002",
        name: "Alberona",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03013004",
        name: "Albese con Cassano",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05024002",
        name: "Albettone",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "18079002",
        name: "Albi",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "04022002",
        name: "Albiano",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001004",
        name: "Albiano d'Ivrea",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03108003",
        name: "Albiate",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "18078006",
        name: "Albidona",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "05028003",
        name: "Albignasego",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "08035001",
        name: "Albinea",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "03016004",
        name: "Albino",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013005",
        name: "Albiolo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "07009004",
        name: "Albisola Superiore",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "07009003",
        name: "Albissola Marina",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03012002",
        name: "Albizzate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03018003",
        name: "Albonese",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03014002",
        name: "Albosaggia",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01005002",
        name: "Albugnano",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03018004",
        name: "Albuzzano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19081001",
        name: "Alcamo",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "19083001",
        name: "Alcara li Fusi",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "04022003",
        name: "Aldeno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04021001",
        name: "Aldino",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20095004",
        name: "Ales",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01006003",
        name: "Alessandria",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18078007",
        name: "Alessandria del Carretto",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19084002",
        name: "Alessandria della Rocca",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "16075002",
        name: "Alessano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "16075003",
        name: "Alezio",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "15065004",
        name: "Alfano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13066003",
        name: "Alfedena",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03017004",
        name: "Alfianello",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01006004",
        name: "Alfiano Natta",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "08039001",
        name: "Alfonsine",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "20090003",
        name: "Alghero",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03016248",
        name: "Algua",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19083002",
        name: "Alì",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19083003",
        name: "Alì Terme",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19082001",
        name: "Alia",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "17077002",
        name: "Aliano",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "01006005",
        name: "Alice Bel Colle",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01002004",
        name: "Alice Castello",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "15061002",
        name: "Alife",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "19082002",
        name: "Alimena",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "19082003",
        name: "Aliminusa",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "20095005",
        name: "Allai",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "05025003",
        name: "Alleghe",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "02007001",
        name: "Allein",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "10055002",
        name: "Allerona",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "16075004",
        name: "Alliste",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "12058004",
        name: "Allumiere",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01006192",
        name: "Alluvioni Piovera",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03016005",
        name: "Almè",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016006",
        name: "Almenno San Bartolomeo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016007",
        name: "Almenno San Salvatore",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001006",
        name: "Almese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05024003",
        name: "Alonte",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05025072",
        name: "Alpago",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "01001007",
        name: "Alpette",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001008",
        name: "Alpignano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08033002",
        name: "Alseno",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03013006",
        name: "Alserio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "08033049",
        name: "Alta Val Tidone",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03013253",
        name: "Alta Valle Intelvi",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "16072004",
        name: "Altamura",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "07009005",
        name: "Altare",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "04022235",
        name: "Altavalle",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15064002",
        name: "Altavilla Irpina",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "19082004",
        name: "Altavilla Milicia",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "01006007",
        name: "Altavilla Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15065005",
        name: "Altavilla Silentina",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05024004",
        name: "Altavilla Vicentina",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "11109001",
        name: "Altidona",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "18078008",
        name: "Altilia",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13069001",
        name: "Altino",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "05024005",
        name: "Altissimo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05026001",
        name: "Altivole",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01004005",
        name: "Alto",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08037062",
        name: "Alto Reno Terme",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "01002170",
        name: "Alto Sermenza",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "19082005",
        name: "Altofonte",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "18078009",
        name: "Altomonte",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "09046001",
        name: "Altopascio",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "04022236",
        name: "Altopiano della Vigolana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "10055003",
        name: "Alviano",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "15061003",
        name: "Alvignano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "12060004",
        name: "Alvito",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "03016008",
        name: "Alzano Lombardo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01006008",
        name: "Alzano Scrivia",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03013007",
        name: "Alzate Brianza",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "15065006",
        name: "Amalfi",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "11109002",
        name: "Amandola",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "18078010",
        name: "Amantea",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "06030002",
        name: "Amaro",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "18079003",
        name: "Amaroni",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "12060005",
        name: "Amaseno",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "18079004",
        name: "Amato",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "12057002",
        name: "Amatrice",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03016009",
        name: "Ambivere",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04022237",
        name: "Amblar-Don",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07011001",
        name: "Ameglia",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "10055004",
        name: "Amelia",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "18078011",
        name: "Amendolara",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01003002",
        name: "Ameno",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "15062002",
        name: "Amorosi",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "06030003",
        name: "Ampezzo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15063004",
        name: "Anacapri",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "12060006",
        name: "Anagni",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "13067002",
        name: "Ancarano",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "11042002",
        name: "Ancona",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "18079005",
        name: "Andali",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "04022005",
        name: "Andalo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03014003",
        name: "Andalo Valtellino",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01001009",
        name: "Andezeno",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07009006",
        name: "Andora",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01096002",
        name: "Andorno Micca",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "16075005",
        name: "Andrano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01001010",
        name: "Andrate",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "06093001",
        name: "Andreis",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15064003",
        name: "Andretta",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "16110001",
        name: "Andria",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "04021002",
        name: "Andriano",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20090004",
        name: "Anela",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03017005",
        name: "Anfo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03012003",
        name: "Angera",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "09051001",
        name: "Anghiari",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "05023003",
        name: "Angiari",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03017006",
        name: "Angolo Terme",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15065007",
        name: "Angri",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01001011",
        name: "Angrogna",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12058005",
        name: "Anguillara Sabazia",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05028004",
        name: "Anguillara Veneta",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03019003",
        name: "Annicco",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03097003",
        name: "Annone di Brianza",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "05027001",
        name: "Annone Veneto",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "18080003",
        name: "Anoia",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03016010",
        name: "Antegnate",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04021003",
        name: "Anterivo",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "02007002",
        name: "Antey-Saint-André",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "12058006",
        name: "Anticoli Corrado",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01005003",
        name: "Antignano",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "19083004",
        name: "Antillo",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "18080004",
        name: "Antonimina",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "12057003",
        name: "Antrodoco",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "01103001",
        name: "Antrona Schieranco",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "13066004",
        name: "Anversa degli Abruzzi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03013009",
        name: "Anzano del Parco",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "16071003",
        name: "Anzano di Puglia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "17076004",
        name: "Anzi",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "12058007",
        name: "Anzio",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01103002",
        name: "Anzola d'Ossola",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "08037001",
        name: "Anzola dell'Emilia",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "02007003",
        name: "Aosta",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "11041002",
        name: "Apecchio",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "15062003",
        name: "Apice",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "11043002",
        name: "Apiro",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "15062004",
        name: "Apollosa",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03013010",
        name: "Appiano Gentile",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04021004",
        name: "Appiano sulla strada del vino",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11043003",
        name: "Appignano",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "11044005",
        name: "Appignano del Tronto",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "03014004",
        name: "Aprica",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "07008002",
        name: "Apricale",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "16071004",
        name: "Apricena",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "18078012",
        name: "Aprigliano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12059001",
        name: "Aprilia",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "15065008",
        name: "Aquara",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "07008003",
        name: "Aquila d'Arroscia",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "06030004",
        name: "Aquileia",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15064004",
        name: "Aquilonia",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "12060007",
        name: "Aquino",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "16075006",
        name: "Aradeo",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "19084003",
        name: "Aragona",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "01005004",
        name: "Aramengo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "06093002",
        name: "Arba",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20095006",
        name: "Arborea",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01002006",
        name: "Arborio",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "20111001",
        name: "Arbus",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "05026002",
        name: "Arcade",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "12060008",
        name: "Arce",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "03016011",
        name: "Arcene",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "11042003",
        name: "Arcevia",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "13069002",
        name: "Archi",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "09053001",
        name: "Arcidosso",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "12058008",
        name: "Arcinazzo Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03012004",
        name: "Arcisate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "04022006",
        name: "Arco",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07011002",
        name: "Arcola",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "05023004",
        name: "Arcole",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03015007",
        name: "Arconate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03108004",
        name: "Arcore",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "05024006",
        name: "Arcugnano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "20090005",
        name: "Ardara",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20095007",
        name: "Ardauli",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "12058117",
        name: "Ardea",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03014005",
        name: "Ardenno",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03016012",
        name: "Ardesio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "18080005",
        name: "Ardore",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18102002",
        name: "Arena",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "03018005",
        name: "Arena Po",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "07010001",
        name: "Arenzano",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03015009",
        name: "Arese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "09051002",
        name: "Arezzo",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "03013011",
        name: "Argegno",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "08037002",
        name: "Argelato",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "08038001",
        name: "Argenta",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "01004006",
        name: "Argentera",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004007",
        name: "Arguello",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18079007",
        name: "Argusto",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "13069003",
        name: "Ari",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15064005",
        name: "Ariano Irpino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "05029002",
        name: "Ariano nel Polesine",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "12058009",
        name: "Ariccia",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "13069004",
        name: "Arielli",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15061004",
        name: "Arienzo",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01001012",
        name: "Arignano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20091001",
        name: "Aritzo",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "01103003",
        name: "Arizzano",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "12056002",
        name: "Arlena di Castro",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03015010",
        name: "Arluno",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01003006",
        name: "Armeno",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "17076005",
        name: "Armento",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "07008004",
        name: "Armo",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "20111002",
        name: "Armungia",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "02007004",
        name: "Arnad",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "12060009",
        name: "Arnara",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "07009007",
        name: "Arnasco",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "16075007",
        name: "Arnesano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01103004",
        name: "Arola",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01003008",
        name: "Arona",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03013012",
        name: "Arosio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "15062005",
        name: "Arpaia",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15062006",
        name: "Arpaise",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "12060010",
        name: "Arpino",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "05028005",
        name: "Arquà Petrarca",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05029003",
        name: "Arquà Polesine",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "11044006",
        name: "Arquata del Tronto",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "01006009",
        name: "Arquata Scrivia",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05028006",
        name: "Arre",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "10055005",
        name: "Arrone",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "03012005",
        name: "Arsago Seprio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05025004",
        name: "Arsiè",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05024007",
        name: "Arsiero",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "13067003",
        name: "Arsita",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "12058010",
        name: "Arsoli",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "06030005",
        name: "Arta Terme",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06030006",
        name: "Artegna",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12058011",
        name: "Artena",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03017007",
        name: "Artogne",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "02007005",
        name: "Arvier",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "20090006",
        name: "Arzachena",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03016013",
        name: "Arzago d'Adda",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "20091002",
        name: "Arzana",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "15063005",
        name: "Arzano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "05028007",
        name: "Arzergrande",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05024008",
        name: "Arzignano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "15065009",
        name: "Ascea",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "09052002",
        name: "Asciano",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "11044007",
        name: "Ascoli Piceno",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "16071005",
        name: "Ascoli Satriano",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "12057004",
        name: "Ascrea",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "05024009",
        name: "Asiago",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05024010",
        name: "Asigliano Veneto",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01002007",
        name: "Asigliano Vercellese",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03020002",
        name: "Asola",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "05026003",
        name: "Asolo",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03015011",
        name: "Assago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "20092003",
        name: "Assemini",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "10054001",
        name: "Assisi",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03013013",
        name: "Asso",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "20095008",
        name: "Assolo",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "19086003",
        name: "Assoro",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "01005005",
        name: "Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "20095009",
        name: "Asuni",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "13066005",
        name: "Ateleta",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "17076006",
        name: "Atella",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15065010",
        name: "Atena Lucana",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13069005",
        name: "Atessa",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "12060011",
        name: "Atina",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15065011",
        name: "Atrani",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13067004",
        name: "Atri",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "15064006",
        name: "Atripalda",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "10055006",
        name: "Attigliano",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "06030007",
        name: "Attimis",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20091003",
        name: "Atzara",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "19089001",
        name: "Augusta",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "15065012",
        name: "Auletta",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "09045001",
        name: "Aulla",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "01103005",
        name: "Aurano",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "07008005",
        name: "Aurigo",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "05025005",
        name: "Auronzo di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "12060012",
        name: "Ausonia",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "20091004",
        name: "Austis",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "07010002",
        name: "Avegno",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "04021005",
        name: "Avelengo",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15064007",
        name: "Avella",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15064008",
        name: "Avellino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03016014",
        name: "Averara",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "15061005",
        name: "Aversa",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "16073001",
        name: "Avetrana",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "13066006",
        name: "Avezzano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "06093004",
        name: "Aviano",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03016015",
        name: "Aviatico",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001013",
        name: "Avigliana",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "17076007",
        name: "Avigliano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "10055033",
        name: "Avigliano Umbro",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "04022007",
        name: "Avio",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "02007006",
        name: "Avise",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "19089002",
        name: "Avola",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "01006010",
        name: "Avolasca",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "02007007",
        name: "Ayas",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007008",
        name: "Aymavilles",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "01001014",
        name: "Azeglio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03019004",
        name: "Azzanello",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01005006",
        name: "Azzano d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "06093005",
        name: "Azzano Decimo",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03017008",
        name: "Azzano Mella",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03016016",
        name: "Azzano San Paolo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03012006",
        name: "Azzate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012007",
        name: "Azzio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03016017",
        name: "Azzone",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01103006",
        name: "Baceno",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "15063006",
        name: "Bacoli",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "07008006",
        name: "Badalucco",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "20090081",
        name: "Badesi",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "04021006",
        name: "Badia",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05023005",
        name: "Badia Calavena",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03018006",
        name: "Badia Pavese",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05029004",
        name: "Badia Polesine",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "09051003",
        name: "Badia Tedalda",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "18079008",
        name: "Badolato",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18080006",
        name: "Bagaladi",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19082006",
        name: "Bagheria",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "08039002",
        name: "Bagnacavallo",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "18080007",
        name: "Bagnara Calabra",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "08039003",
        name: "Bagnara di Romagna",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "03018007",
        name: "Bagnaria",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "06030008",
        name: "Bagnaria Arsa",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01004008",
        name: "Bagnasco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03016018",
        name: "Bagnatica",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "09046002",
        name: "Bagni di Lucca",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "09048001",
        name: "Bagno a Ripoli",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "08040001",
        name: "Bagno di Romagna",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "14094003",
        name: "Bagnoli del Trigno",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "05028008",
        name: "Bagnoli di Sopra",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "15064009",
        name: "Bagnoli Irpino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03019005",
        name: "Bagnolo Cremasco",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "16075008",
        name: "Bagnolo del Salento",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "05029005",
        name: "Bagnolo di Po",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "08035002",
        name: "Bagnolo in Piano",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "03017009",
        name: "Bagnolo Mella",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01004009",
        name: "Bagnolo Piemonte",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03020003",
        name: "Bagnolo San Vito",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "09045002",
        name: "Bagnone",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "12056003",
        name: "Bagnoregio",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03017010",
        name: "Bagolino",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15061006",
        name: "Baia e Latina",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15064010",
        name: "Baiano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01001015",
        name: "Bairo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08035003",
        name: "Baiso",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "07008007",
        name: "Bajardo",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01001016",
        name: "Balangero",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01005007",
        name: "Baldichieri d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001017",
        name: "Baldissero Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004010",
        name: "Baldissero d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001018",
        name: "Baldissero Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19082007",
        name: "Balestrate",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "07009008",
        name: "Balestrino",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03097004",
        name: "Ballabio",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "20111003",
        name: "Ballao",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01001019",
        name: "Balme",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002008",
        name: "Balmuccia",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01002009",
        name: "Balocco",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "13066007",
        name: "Balsorano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "17076008",
        name: "Balvano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "01006011",
        name: "Balzola",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "20090007",
        name: "Banari",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01001020",
        name: "Banchette",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01103007",
        name: "Bannio Anzino",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "17076009",
        name: "Banzi",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "05028009",
        name: "Baone",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "20095010",
        name: "Baradili",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "17076010",
        name: "Baragiano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "14070002",
        name: "Baranello",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "15063007",
        name: "Barano d'Ischia",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03015250",
        name: "Baranzate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03012008",
        name: "Barasso",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "20095011",
        name: "Baratili San Pietro",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01001021",
        name: "Barbania",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "11042004",
        name: "Barbara",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "05024124",
        name: "Barbarano Mossano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "12056004",
        name: "Barbarano Romano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "01004011",
        name: "Barbaresco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017011",
        name: "Barbariga",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03016019",
        name: "Barbata",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "09048002",
        name: "Barberino di Mugello",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "09048054",
        name: "Barberino Tavarnelle",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "03018008",
        name: "Barbianello",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "04021007",
        name: "Barbiano",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05028010",
        name: "Barbona",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "19083005",
        name: "Barcellona Pozzo di Gotto",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "06093006",
        name: "Barcis",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "02007009",
        name: "Bard",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03012009",
        name: "Bardello",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "08034002",
        name: "Bardi",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "07009009",
        name: "Bardineto",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "05023006",
        name: "Bardolino",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01001022",
        name: "Bardonecchia",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03015012",
        name: "Bareggio",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01003012",
        name: "Barengo",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "20095012",
        name: "Baressa",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "13066008",
        name: "Barete",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "09046003",
        name: "Barga",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "07010003",
        name: "Bargagli",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01004012",
        name: "Barge",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017012",
        name: "Barghe",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "16072006",
        name: "Bari",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "20091005",
        name: "Bari Sardo",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03016020",
        name: "Bariano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08037003",
        name: "Baricella",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "17076011",
        name: "Barile",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "13066009",
        name: "Barisciano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03108005",
        name: "Barlassina",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "16110002",
        name: "Barletta",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "03013015",
        name: "Barni",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01004013",
        name: "Barolo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001023",
        name: "Barone Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15065013",
        name: "Baronissi",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19086004",
        name: "Barrafranca",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "20111004",
        name: "Barrali",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "13066010",
        name: "Barrea",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "20111005",
        name: "Barumini",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03097005",
        name: "Barzago",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03016021",
        name: "Barzana",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03097006",
        name: "Barzanò",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03097007",
        name: "Barzio",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01006012",
        name: "Basaluzzo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018009",
        name: "Bascapè",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "10055007",
        name: "Baschi",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "13067005",
        name: "Basciano",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "04022009",
        name: "Baselga di Pinè",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15062007",
        name: "Baselice",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03015014",
        name: "Basiano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "19083006",
        name: "Basicò",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03015015",
        name: "Basiglio",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "06030009",
        name: "Basiliano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03017013",
        name: "Bassano Bresciano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05024012",
        name: "Bassano del Grappa",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "12056006",
        name: "Bassano in Teverina",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "12056005",
        name: "Bassano Romano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "12059002",
        name: "Bassiano",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "01006013",
        name: "Bassignana",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01004014",
        name: "Bastia Mondovì",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "10054002",
        name: "Bastia Umbra",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03018011",
        name: "Bastida Pancarana",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "08036001",
        name: "Bastiglia",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "05028011",
        name: "Battaglia Terme",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01004015",
        name: "Battifollo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15065014",
        name: "Battipaglia",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03018012",
        name: "Battuda",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19082008",
        name: "Baucina",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "20095013",
        name: "Bauladu",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20091006",
        name: "Baunei",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "01103008",
        name: "Baveno",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03012010",
        name: "Bedero Valcuvia",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03017014",
        name: "Bedizzole",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04022011",
        name: "Bedollo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08034003",
        name: "Bedonia",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "03016022",
        name: "Bedulita",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01103009",
        name: "Bee",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01001024",
        name: "Beinasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004016",
        name: "Beinette",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18079009",
        name: "Belcastro",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "05023007",
        name: "Belfiore",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "11041005",
        name: "Belforte all'Isauro",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11043004",
        name: "Belforte del Chienti",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "01006014",
        name: "Belforte Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018013",
        name: "Belgioioso",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01103010",
        name: "Belgirate",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "17076012",
        name: "Bella",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03013250",
        name: "Bellagio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03097008",
        name: "Bellano",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "13067006",
        name: "Bellante",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "08099001",
        name: "Bellaria-Igea Marina",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "12058012",
        name: "Bellegra",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01004017",
        name: "Bellino",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03015016",
        name: "Bellinzago Lombardo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01003016",
        name: "Bellinzago Novarese",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "15065158",
        name: "Bellizzi",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15061007",
        name: "Bellona",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15065015",
        name: "Bellosguardo",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05025006",
        name: "Belluno",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03108006",
        name: "Bellusco",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "18078013",
        name: "Belmonte Calabro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12060013",
        name: "Belmonte Castello",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "14094004",
        name: "Belmonte del Sannio",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "12057005",
        name: "Belmonte in Sabina",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "19082009",
        name: "Belmonte Mezzagno",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "11109003",
        name: "Belmonte Piceno",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "19087007",
        name: "Belpasso",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "18078014",
        name: "Belsito",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18101001",
        name: "Belvedere di Spinello",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "01004018",
        name: "Belvedere Langhe",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18078015",
        name: "Belvedere Marittimo",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "11042005",
        name: "Belvedere Ostrense",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01005008",
        name: "Belveglio",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "20091007",
        name: "Belvì",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03014006",
        name: "Bema",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03013021",
        name: "Bene Lario",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01004019",
        name: "Bene Vagienna",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18080008",
        name: "Benestare",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "20090008",
        name: "Benetutti",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01004020",
        name: "Benevello",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15062008",
        name: "Benevento",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "01096003",
        name: "Benna",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "08037005",
        name: "Bentivoglio",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03016023",
        name: "Berbenno",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03014007",
        name: "Berbenno di Valtellina",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "08034004",
        name: "Berceto",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "20090009",
        name: "Berchidda",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03013022",
        name: "Beregazzo con Figliaro",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03018014",
        name: "Bereguardo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01006015",
        name: "Bergamasco",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03016024",
        name: "Bergamo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05029006",
        name: "Bergantino",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "07009010",
        name: "Bergeggi",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01004021",
        name: "Bergolo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017015",
        name: "Berlingo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "17077003",
        name: "Bernalda",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "03108007",
        name: "Bernareggio",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03015019",
        name: "Bernate Ticino",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01004022",
        name: "Bernezzo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08040003",
        name: "Bertinoro",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "06030010",
        name: "Bertiolo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03098002",
        name: "Bertonico",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "01005009",
        name: "Berzano di San Pietro",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01006016",
        name: "Berzano di Tortona",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03017016",
        name: "Berzo Demo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017017",
        name: "Berzo Inferiore",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03016025",
        name: "Berzo San Fermo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03108008",
        name: "Besana in Brianza",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03012011",
        name: "Besano",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03015022",
        name: "Besate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "04022013",
        name: "Besenello",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08033003",
        name: "Besenzone",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03012012",
        name: "Besnate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012013",
        name: "Besozzo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "20090010",
        name: "Bessude",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "08033004",
        name: "Bettola",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "10054003",
        name: "Bettona",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01103011",
        name: "Beura-Cardezza",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "10054004",
        name: "Bevagna",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "07011003",
        name: "Beverino",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "05023008",
        name: "Bevilacqua",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "19087008",
        name: "Biancavilla",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "18078016",
        name: "Bianchi",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18080009",
        name: "Bianco",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01003018",
        name: "Biandrate",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03012014",
        name: "Biandronno",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03016026",
        name: "Bianzano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01002011",
        name: "Bianzè",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03014008",
        name: "Bianzone",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03108009",
        name: "Biassono",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "08035004",
        name: "Bibbiano",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "09051004",
        name: "Bibbiena",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "09049001",
        name: "Bibbona",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "01001025",
        name: "Bibiana",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16071006",
        name: "Biccari",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "06030011",
        name: "Bicinicco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20095014",
        name: "Bidonì",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01096004",
        name: "Biella",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03017018",
        name: "Bienno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04022015",
        name: "Bieno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "09050001",
        name: "Bientina",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "03013023",
        name: "Binago",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03015024",
        name: "Binasco",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "16072008",
        name: "Binetto",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "01096005",
        name: "Bioglio",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "02007010",
        name: "Bionaz",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03017019",
        name: "Bione",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20091008",
        name: "Birori",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "15064011",
        name: "Bisaccia",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "19082010",
        name: "Bisacquino",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "16110003",
        name: "Bisceglie",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "13066011",
        name: "Bisegna",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "13067007",
        name: "Bisenti",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "18078017",
        name: "Bisignano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01006017",
        name: "Bistagno",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03012015",
        name: "Bisuschio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "16072010",
        name: "Bitetto",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "16072011",
        name: "Bitonto",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "16072012",
        name: "Bitritto",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "20091009",
        name: "Bitti",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "19084004",
        name: "Bivona",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "18080010",
        name: "Bivongi",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03013024",
        name: "Bizzarone",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04022017",
        name: "Bleggio Superiore",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03016027",
        name: "Blello",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12056007",
        name: "Blera",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03013025",
        name: "Blessagno",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03013026",
        name: "Blevio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "19082082",
        name: "Blufi",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "05028012",
        name: "Boara Pisani",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "08033005",
        name: "Bobbio",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "01001026",
        name: "Bobbio Pellice",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01003019",
        name: "Boca",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "18078018",
        name: "Bocchigliero",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01002014",
        name: "Boccioleto",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "04022018",
        name: "Bocenago",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03012016",
        name: "Bodio Lomnago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03098003",
        name: "Boffalora d'Adda",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03015026",
        name: "Boffalora sopra Ticino",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "07010004",
        name: "Bogliasco",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01103012",
        name: "Bognanco",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01003021",
        name: "Bogogno",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "07009011",
        name: "Boissano",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "14070003",
        name: "Bojano",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "07011004",
        name: "Bolano",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "03016028",
        name: "Bolgare",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03015027",
        name: "Bollate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01001027",
        name: "Bollengo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08037006",
        name: "Bologna",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "13068003",
        name: "Bolognano",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "19082011",
        name: "Bolognetta",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "11043005",
        name: "Bolognola",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "20091010",
        name: "Bolotana",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "12056008",
        name: "Bolsena",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03016029",
        name: "Boltiere",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04021008",
        name: "Bolzano",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01003022",
        name: "Bolzano Novarese",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "05024013",
        name: "Bolzano Vicentino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "12056009",
        name: "Bomarzo",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "13069006",
        name: "Bomba",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "19085002",
        name: "Bompensiere",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "19082012",
        name: "Bompietro",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "08036002",
        name: "Bomporto",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "20095015",
        name: "Bonarcado",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "07011005",
        name: "Bonassola",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "03016030",
        name: "Bonate Sopra",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016031",
        name: "Bonate Sotto",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05023009",
        name: "Bonavigo",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "08038003",
        name: "Bondeno",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "04022021",
        name: "Bondone",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15062009",
        name: "Bonea",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "14070004",
        name: "Bonefro",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03019006",
        name: "Bonemerse",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18078019",
        name: "Bonifati",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15064012",
        name: "Bonito",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "20090011",
        name: "Bonnanaro",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20090012",
        name: "Bono",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20090013",
        name: "Bonorva",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01004023",
        name: "Bonvicino",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "12057006",
        name: "Borbona",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "05025007",
        name: "Borca di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "06030012",
        name: "Bordano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "07008008",
        name: "Bordighera",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "03019007",
        name: "Bordolano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "08034005",
        name: "Bore",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "08035005",
        name: "Boretto",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "03018015",
        name: "Borgarello",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001028",
        name: "Borgaro Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19082013",
        name: "Borgetto",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "07008009",
        name: "Borghetto d'Arroscia",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01006018",
        name: "Borghetto di Borbera",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "07011006",
        name: "Borghetto di Vara",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "03098004",
        name: "Borghetto Lodigiano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "07009012",
        name: "Borghetto Santo Spirito",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "08040004",
        name: "Borghi",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "18079011",
        name: "Borgia",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "01001029",
        name: "Borgiallo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07009013",
        name: "Borgio Verezzi",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "09046004",
        name: "Borgo a Mozzano",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "04022238",
        name: "Borgo Chiese",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01002015",
        name: "Borgo d'Ale",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "04022252",
        name: "Borgo d'Anaunia",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03016032",
        name: "Borgo di Terzo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04022239",
        name: "Borgo Lares",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03020072",
        name: "Borgo Mantovano",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "11041006",
        name: "Borgo Pace",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "03018016",
        name: "Borgo Priolo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01004025",
        name: "Borgo San Dalmazzo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017020",
        name: "Borgo San Giacomo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03098005",
        name: "Borgo San Giovanni",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "09048004",
        name: "Borgo San Lorenzo",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "01006020",
        name: "Borgo San Martino",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018018",
        name: "Borgo San Siro",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01003025",
        name: "Borgo Ticino",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "08037007",
        name: "Borgo Tossignano",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "08034006",
        name: "Borgo Val di Taro",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "05025074",
        name: "Borgo Valbelluna",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "04022022",
        name: "Borgo Valsugana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "12057008",
        name: "Borgo Velino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "05028107",
        name: "Borgo Veneto",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01002017",
        name: "Borgo Vercelli",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03020071",
        name: "Borgo Virgilio",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03020073",
        name: "Borgocarbonara",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01001030",
        name: "Borgofranco d'Ivrea",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01003023",
        name: "Borgolavezzaro",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01004024",
        name: "Borgomale",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01003024",
        name: "Borgomanero",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "07008010",
        name: "Borgomaro",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01001031",
        name: "Borgomasino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01103078",
        name: "Borgomezzavalle",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01001032",
        name: "Borgone Susa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08033006",
        name: "Borgonovo Val Tidone",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "01006019",
        name: "Borgoratto Alessandrino",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018017",
        name: "Borgoratto Mormorolo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05028013",
        name: "Borgoricco",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "12057007",
        name: "Borgorose",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03017021",
        name: "Borgosatollo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01002016",
        name: "Borgosesia",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "07009014",
        name: "Bormida",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03014009",
        name: "Bormio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03018019",
        name: "Bornasco",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03017022",
        name: "Borno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20095016",
        name: "Boroneddu",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20091011",
        name: "Borore",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "13069007",
        name: "Borrello",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01096006",
        name: "Borriana",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "05026004",
        name: "Borso del Grappa",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "20091012",
        name: "Bortigali",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20090014",
        name: "Bortigiadas",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20090015",
        name: "Borutta",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "07010005",
        name: "Borzonasca",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "20095079",
        name: "Bosa",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "05029007",
        name: "Bosaro",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "05023010",
        name: "Boschi Sant'Anna",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "05023011",
        name: "Bosco Chiesanuova",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01006021",
        name: "Bosco Marengo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01001033",
        name: "Bosconero",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15063008",
        name: "Boscoreale",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15063009",
        name: "Boscotrecase",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01004026",
        name: "Bosia",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01006022",
        name: "Bosio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03097009",
        name: "Bosisio Parini",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03018020",
        name: "Bosnasco",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03016033",
        name: "Bossico",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01004027",
        name: "Bossolasco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18079012",
        name: "Botricello",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "16075009",
        name: "Botrugno",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03016034",
        name: "Bottanuco",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03017023",
        name: "Botticino",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20090016",
        name: "Bottidda",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "18080011",
        name: "Bova",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18080013",
        name: "Bova Marina",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18080012",
        name: "Bovalino",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03017024",
        name: "Bovegno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01004028",
        name: "Boves",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017025",
        name: "Bovezzo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "12060014",
        name: "Boville Ernica",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "16071007",
        name: "Bovino",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03108010",
        name: "Bovisio-Masciago",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "05028014",
        name: "Bovolenta",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05023012",
        name: "Bovolone",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01006023",
        name: "Bozzole",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03020007",
        name: "Bozzolo",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01004029",
        name: "Bra",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03016035",
        name: "Bracca",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12058013",
        name: "Bracciano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15065016",
        name: "Bracigliano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "04021009",
        name: "Braies",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03018021",
        name: "Brallo di Pregola",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "18080014",
        name: "Brancaleone",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03017026",
        name: "Brandico",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01001034",
        name: "Brandizzo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03016036",
        name: "Branzi",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03017027",
        name: "Braone",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03012017",
        name: "Brebbia",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05026005",
        name: "Breda di Piave",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03012018",
        name: "Bregano",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05024014",
        name: "Breganze",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03013028",
        name: "Bregnano",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016037",
        name: "Brembate",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016038",
        name: "Brembate di Sopra",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03098006",
        name: "Brembio",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03018022",
        name: "Breme",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05024015",
        name: "Brendola",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03013029",
        name: "Brenna",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04021010",
        name: "Brennero",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03017028",
        name: "Breno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03012019",
        name: "Brenta",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05023013",
        name: "Brentino Belluno",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04022025",
        name: "Brentonico",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05023014",
        name: "Brenzone sul Garda",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "08035006",
        name: "Brescello",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "03017029",
        name: "Brescia",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04022026",
        name: "Bresimo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03018023",
        name: "Bressana Bottarone",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "04021011",
        name: "Bressanone",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05024016",
        name: "Bressanvido",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03015032",
        name: "Bresso",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03012020",
        name: "Brezzo di Bedero",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01004030",
        name: "Briaglia",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18102003",
        name: "Briatico",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "01001035",
        name: "Bricherasio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03013030",
        name: "Brienno",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "17076013",
        name: "Brienza",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "01004031",
        name: "Briga Alta",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01003026",
        name: "Briga Novarese",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03016040",
        name: "Brignano Gera d'Adda",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01006024",
        name: "Brignano-Frascata",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16074001",
        name: "Brindisi",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "17076014",
        name: "Brindisi Montagna",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03012021",
        name: "Brinzio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01003027",
        name: "Briona",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03017030",
        name: "Brione",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03108011",
        name: "Briosco",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "08039004",
        name: "Brisighella",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "03012022",
        name: "Brissago-Valtravaglia",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "02007011",
        name: "Brissogne",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "13068004",
        name: "Brittoli",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "03097010",
        name: "Brivio",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "12060015",
        name: "Broccostella",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "05024017",
        name: "Brogliano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "18102004",
        name: "Brognaturo",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "19083007",
        name: "Brolo",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01004032",
        name: "Brondello",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03018024",
        name: "Broni",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19087009",
        name: "Bronte",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "04021012",
        name: "Bronzolo",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004033",
        name: "Brossasco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001036",
        name: "Brosso",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01103013",
        name: "Brovello-Carpugnino",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01001037",
        name: "Brozolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03108012",
        name: "Brugherio",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "05028015",
        name: "Brugine",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "07011007",
        name: "Brugnato",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "06093007",
        name: "Brugnera",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001038",
        name: "Bruino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03016041",
        name: "Brumano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013032",
        name: "Brunate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03012023",
        name: "Brunello",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "04021013",
        name: "Brunico",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01005010",
        name: "Bruno",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03016042",
        name: "Brusaporto",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001039",
        name: "Brusasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15063010",
        name: "Brusciano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03012024",
        name: "Brusimpiano",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01096007",
        name: "Brusnengo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "02007012",
        name: "Brusson",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "01001040",
        name: "Bruzolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18080015",
        name: "Bruzzano Zeffirio",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03015035",
        name: "Bubbiano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01005011",
        name: "Bubbio",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "19089003",
        name: "Buccheri",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "13069008",
        name: "Bucchianico",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15062010",
        name: "Bucciano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03015036",
        name: "Buccinasco",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "15065017",
        name: "Buccino",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "09051005",
        name: "Bucine",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "20090017",
        name: "Buddusò",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "06093008",
        name: "Budoia",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20090091",
        name: "Budoni",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "08037008",
        name: "Budrio",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "20111006",
        name: "Buggerru",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "09047003",
        name: "Buggiano",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "03014010",
        name: "Buglio in Monte",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "13066012",
        name: "Bugnara",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03012025",
        name: "Buguggiate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "06030013",
        name: "Buja",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03097011",
        name: "Bulciago",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03013034",
        name: "Bulgarograsso",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "20090018",
        name: "Bultei",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20090019",
        name: "Bulzi",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "15065018",
        name: "Buonabitacolo",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15062011",
        name: "Buonalbergo",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "09052003",
        name: "Buonconvento",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "18078020",
        name: "Buonvicino",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03108013",
        name: "Burago di Molgora",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "20111007",
        name: "Burcei",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "19084005",
        name: "Burgio",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "20090020",
        name: "Burgos",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01001041",
        name: "Buriasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001042",
        name: "Burolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002021",
        name: "Buronzo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "20095017",
        name: "Busachi",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "07010006",
        name: "Busalla",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01001043",
        name: "Busano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004034",
        name: "Busca",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03015038",
        name: "Buscate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "19089004",
        name: "Buscemi",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "19081002",
        name: "Buseto Palizzolo",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "03108051",
        name: "Busnago",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03015040",
        name: "Bussero",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "08034007",
        name: "Busseto",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "13068005",
        name: "Bussi sul Tirino",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "14070005",
        name: "Busso",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "05023015",
        name: "Bussolengo",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01001044",
        name: "Bussoleno",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03012026",
        name: "Busto Arsizio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03015041",
        name: "Busto Garolfo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "19085003",
        name: "Butera",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "09050002",
        name: "Buti",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "05023016",
        name: "Buttapietra",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01001045",
        name: "Buttigliera Alta",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01005012",
        name: "Buttigliera d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "06030014",
        name: "Buttrio",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01006025",
        name: "Cabella Ligure",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03013035",
        name: "Cabiate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "20095018",
        name: "Cabras",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "19082014",
        name: "Caccamo",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "18101002",
        name: "Caccuri",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "03012027",
        name: "Cadegliano-Viconago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "08035008",
        name: "Cadelbosco di Sopra",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "08033007",
        name: "Cadeo",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "04022029",
        name: "Caderzone Terme",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05028016",
        name: "Cadoneghe",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03013036",
        name: "Cadorago",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03012143",
        name: "Cadrezzate con Osmate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05026006",
        name: "Caerano di San Marco",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01001046",
        name: "Cafasse",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15065019",
        name: "Caggiano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "11041007",
        name: "Cagli",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "20092009",
        name: "Cagliari",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "03013037",
        name: "Caglio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "13066013",
        name: "Cagnano Amiterno",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "16071008",
        name: "Cagnano Varano",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "15061008",
        name: "Caianello",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15061009",
        name: "Caiazzo",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "04021014",
        name: "Caines",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03017031",
        name: "Caino",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03014011",
        name: "Caiolo",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "15064013",
        name: "Cairano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03012029",
        name: "Cairate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "07009015",
        name: "Cairo Montenotte",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "15063011",
        name: "Caivano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15064014",
        name: "Calabritto",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "05025008",
        name: "Calalzo di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "01005013",
        name: "Calamandrana",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "19084006",
        name: "Calamonaci",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "20090021",
        name: "Calangianus",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "18080016",
        name: "Calanna",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01103014",
        name: "Calasca-Castiglione",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "19086005",
        name: "Calascibetta",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "13066014",
        name: "Calascio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "20111008",
        name: "Calasetta",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "19087010",
        name: "Calatabiano",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19081003",
        name: "Calatafimi-Segesta",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "12056010",
        name: "Calcata",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "04022032",
        name: "Calceranica al Lago",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "09050003",
        name: "Calci",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "17077004",
        name: "Calciano",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "09050004",
        name: "Calcinaia",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "03016043",
        name: "Calcinate",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03017032",
        name: "Calcinato",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03016044",
        name: "Calcio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03097012",
        name: "Calco",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "04021015",
        name: "Caldaro sulla strada del vino",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11043006",
        name: "Caldarola",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "08037009",
        name: "Calderara di Reno",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "04022033",
        name: "Caldes",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05023017",
        name: "Caldiero",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "05024018",
        name: "Caldogno",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "04022034",
        name: "Caldonazzo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08033008",
        name: "Calendasco",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "09048005",
        name: "Calenzano",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "08034008",
        name: "Calestano",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "07011008",
        name: "Calice al Cornoviglio",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "07009016",
        name: "Calice Ligure",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "16075010",
        name: "Calimera",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "15064015",
        name: "Calitri",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "07009017",
        name: "Calizzano",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01096008",
        name: "Callabiana",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01005014",
        name: "Calliano",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "04022035",
        name: "Calliano",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03097013",
        name: "Calolziocorte",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "18078021",
        name: "Calopezzati",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01005015",
        name: "Calosso",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "18078022",
        name: "Caloveto",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19084007",
        name: "Caltabellotta",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "19087011",
        name: "Caltagirone",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19085004",
        name: "Caltanissetta",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "19082015",
        name: "Caltavuturo",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "01003030",
        name: "Caltignaga",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "05029008",
        name: "Calto",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "05024019",
        name: "Caltrano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03016046",
        name: "Calusco d'Adda",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001047",
        name: "Caluso",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03017033",
        name: "Calvagese della Riviera",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15065020",
        name: "Calvanico",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03019009",
        name: "Calvatone",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "17076015",
        name: "Calvello",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "05024020",
        name: "Calvene",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03016047",
        name: "Calvenzano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "17076016",
        name: "Calvera",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15062012",
        name: "Calvi",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "10055008",
        name: "Calvi dell'Umbria",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "15061010",
        name: "Calvi Risorta",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03018025",
        name: "Calvignano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03015042",
        name: "Calvignasco",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03017034",
        name: "Calvisano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15063012",
        name: "Calvizzano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01006026",
        name: "Camagna Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "09046005",
        name: "Camaiore",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "01096009",
        name: "Camandona",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "19084008",
        name: "Camastra",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "03015044",
        name: "Cambiago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01001048",
        name: "Cambiano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01103015",
        name: "Cambiasca",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01096010",
        name: "Camburzano",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01004035",
        name: "Camerana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "11042006",
        name: "Camerano",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01005016",
        name: "Camerano Casasco",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03016048",
        name: "Camerata Cornello",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12058014",
        name: "Camerata Nuova",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "11042007",
        name: "Camerata Picena",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01003032",
        name: "Cameri",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "11043007",
        name: "Camerino",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "15065021",
        name: "Camerota",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15061011",
        name: "Camigliano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "18080017",
        name: "Camini",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01006027",
        name: "Camino",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "06030015",
        name: "Camino al Tagliamento",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03019010",
        name: "Camisano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05024021",
        name: "Camisano Vicentino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "19084009",
        name: "Cammarata",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "07010007",
        name: "Camogli",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "15065022",
        name: "Campagna",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05027002",
        name: "Campagna Lupia",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "12058015",
        name: "Campagnano di Roma",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "09053002",
        name: "Campagnatico",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "03019011",
        name: "Campagnola Cremasca",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "08035009",
        name: "Campagnola Emilia",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "18078023",
        name: "Campana",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03108014",
        name: "Camparada",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "08035010",
        name: "Campegine",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "10054005",
        name: "Campello sul Clitunno",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01002025",
        name: "Campertogno",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "09048006",
        name: "Campi Bisenzio",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "16075011",
        name: "Campi Salentina",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01096086",
        name: "Campiglia Cervo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "05024022",
        name: "Campiglia dei Berici",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "09049002",
        name: "Campiglia Marittima",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "01001049",
        name: "Campiglione Fenile",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03013040",
        name: "Campione d'Italia",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04022036",
        name: "Campitello di Fassa",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "13067008",
        name: "Campli",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "18080018",
        name: "Campo Calabro",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "13066015",
        name: "Campo di Giove",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "04021016",
        name: "Campo di Trens",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07010008",
        name: "Campo Ligure",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "09049003",
        name: "Campo nell'Elba",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "05028020",
        name: "Campo San Martino",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "04021017",
        name: "Campo Tures",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "14070006",
        name: "Campobasso",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "19084010",
        name: "Campobello di Licata",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "19081004",
        name: "Campobello di Mazara",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "14070007",
        name: "Campochiaro",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "05028017",
        name: "Campodarsego",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "04022037",
        name: "Campodenno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "12059003",
        name: "Campodimele",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "14070008",
        name: "Campodipietra",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03014012",
        name: "Campodolcino",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "05028018",
        name: "Campodoro",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "19082016",
        name: "Campofelice di Fitalia",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "19082017",
        name: "Campofelice di Roccella",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "11109004",
        name: "Campofilone",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "19082018",
        name: "Campofiorito",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "06030016",
        name: "Campoformido",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19085005",
        name: "Campofranco",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "08036003",
        name: "Campogalliano",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "15062013",
        name: "Campolattaro",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "12060016",
        name: "Campoli Appennino",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15062014",
        name: "Campoli del Monte Taburno",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "14070009",
        name: "Campolieto",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "05027003",
        name: "Campolongo Maggiore",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "06030138",
        name: "Campolongo Tapogliano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "17076017",
        name: "Campomaggiore",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "14070010",
        name: "Campomarino",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "07010009",
        name: "Campomorone",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "05027004",
        name: "Camponogara",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "15065023",
        name: "Campora",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19082019",
        name: "Camporeale",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "09046006",
        name: "Camporgiano",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "07008011",
        name: "Camporosso",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "11043008",
        name: "Camporotondo di Fiastrone",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "19087012",
        name: "Camporotondo Etneo",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "05028019",
        name: "Camposampiero",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "15063013",
        name: "Camposano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "08036004",
        name: "Camposanto",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "03018026",
        name: "Campospinoso",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "13066016",
        name: "Campotosto",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "08037010",
        name: "Camugnano",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "04022038",
        name: "Canal San Bovo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004037",
        name: "Canale",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05025023",
        name: "Canale d'Agordo",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "12058016",
        name: "Canale Monterano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05029009",
        name: "Canaro",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "04022039",
        name: "Canazei",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "17076018",
        name: "Cancellara",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15061012",
        name: "Cancello ed Arnone",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "05029010",
        name: "Canda",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "16071009",
        name: "Candela",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "01096012",
        name: "Candelo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01001050",
        name: "Candia Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018027",
        name: "Candia Lomellina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05028021",
        name: "Candiana",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "15064016",
        name: "Candida",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18080019",
        name: "Candidoni",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01001051",
        name: "Candiolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03015046",
        name: "Canegrate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01005017",
        name: "Canelli",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "12056011",
        name: "Canepina",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "06093009",
        name: "Caneva",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19084011",
        name: "Canicattì",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "19089005",
        name: "Canicattini Bagni",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "12056012",
        name: "Canino",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "01001052",
        name: "Canischio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "13066017",
        name: "Canistro",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "18078024",
        name: "Canna",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15065024",
        name: "Cannalonga",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "10054006",
        name: "Cannara",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01103016",
        name: "Cannero Riviera",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03018029",
        name: "Canneto Pavese",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03020008",
        name: "Canneto sull'Oglio",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01103017",
        name: "Cannobio",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "16075012",
        name: "Cannole",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "18080020",
        name: "Canolo",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03016049",
        name: "Canonica d'Adda",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "16110004",
        name: "Canosa di Puglia",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "13069010",
        name: "Canosa Sannita",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01004038",
        name: "Canosio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08035018",
        name: "Canossa",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "13066018",
        name: "Cansano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "09100001",
        name: "Cantagallo",
        districtInitials: "PO",
        district: "Prato",
        region: "Toscana"
    },
    {
        code: "12057009",
        name: "Cantalice",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "01001053",
        name: "Cantalupa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12057010",
        name: "Cantalupo in Sabina",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "01006028",
        name: "Cantalupo Ligure",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "14094005",
        name: "Cantalupo nel Sannio",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "01005018",
        name: "Cantarana",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03012030",
        name: "Cantello",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "12058017",
        name: "Canterano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "11041008",
        name: "Cantiano",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "01001054",
        name: "Cantoira",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03013041",
        name: "Cantù",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "13067009",
        name: "Canzano",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "03013042",
        name: "Canzo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05027005",
        name: "Caorle",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "08033010",
        name: "Caorso",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "15065025",
        name: "Capaccio Paestum",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19082020",
        name: "Capaci",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "09053003",
        name: "Capalbio",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "09050005",
        name: "Capannoli",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "09046007",
        name: "Capannori",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "12058018",
        name: "Capena",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03019012",
        name: "Capergnanica",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "13066019",
        name: "Capestrano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03013043",
        name: "Capiago Intimiano",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "18102005",
        name: "Capistrano",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "13066020",
        name: "Capistrello",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "13066021",
        name: "Capitignano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "19083008",
        name: "Capizzi",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03016050",
        name: "Capizzone",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19083009",
        name: "Capo d'Orlando",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03017035",
        name: "Capo di Ponte",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "12056013",
        name: "Capodimonte",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "15061013",
        name: "Capodrise",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "09049004",
        name: "Capoliveri",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "09051006",
        name: "Capolona",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "03108052",
        name: "Caponago",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "13066022",
        name: "Caporciano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15064017",
        name: "Caposele",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "20092011",
        name: "Capoterra",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "03017036",
        name: "Capovalle",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "13066023",
        name: "Cappadocia",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03019013",
        name: "Cappella Cantone",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03019014",
        name: "Cappella de' Picenardi",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05026007",
        name: "Cappella Maggiore",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "13068006",
        name: "Cappelle sul Tavo",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "14094006",
        name: "Capracotta",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "09048008",
        name: "Capraia e Limite",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "09049005",
        name: "Capraia Isola",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "03019015",
        name: "Capralba",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "12056014",
        name: "Capranica",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "12058019",
        name: "Capranica Prenestina",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "16075013",
        name: "Caprarica di Lecce",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "12056015",
        name: "Caprarola",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "01004039",
        name: "Caprauna",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "09051007",
        name: "Caprese Michelangelo",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "01103018",
        name: "Caprezzo",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "15063014",
        name: "Capri",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "19083010",
        name: "Capri Leone",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "04022040",
        name: "Capriana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03017037",
        name: "Capriano del Colle",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01006029",
        name: "Capriata d'Orba",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03016051",
        name: "Capriate San Gervasio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "15061014",
        name: "Capriati a Volturno",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01001055",
        name: "Caprie",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15064018",
        name: "Capriglia Irpina",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01005019",
        name: "Capriglio",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01096013",
        name: "Caprile",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03016052",
        name: "Caprino Bergamasco",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05023018",
        name: "Caprino Veronese",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03017038",
        name: "Capriolo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "06031001",
        name: "Capriva del Friuli",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15061015",
        name: "Capua",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "16072014",
        name: "Capurso",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "18080021",
        name: "Caraffa del Bianco",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18079017",
        name: "Caraffa di Catanzaro",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "01004040",
        name: "Caraglio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004041",
        name: "Caramagna Piemonte",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13068007",
        name: "Caramanico Terme",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "16071010",
        name: "Carapelle",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "13066024",
        name: "Carapelle Calvisio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "07010010",
        name: "Carasco",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "11044010",
        name: "Carassai",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "03108015",
        name: "Carate Brianza",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03013044",
        name: "Carate Urio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016053",
        name: "Caravaggio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03012031",
        name: "Caravate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01001056",
        name: "Caravino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07008012",
        name: "Caravonica",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "12056016",
        name: "Carbognano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03018030",
        name: "Carbonara al Ticino",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "15063015",
        name: "Carbonara di Nola",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01006030",
        name: "Carbonara Scrivia",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03013045",
        name: "Carbonate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "17076019",
        name: "Carbone",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "05026008",
        name: "Carbonera",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "20111009",
        name: "Carbonia",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "07009018",
        name: "Carcare",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "05028022",
        name: "Carceri",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01002029",
        name: "Carcoforo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03012032",
        name: "Cardano al Campo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01004042",
        name: "Cardè",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20091103",
        name: "Cardedu",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "18080022",
        name: "Cardeto",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18079018",
        name: "Cardinale",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "15063016",
        name: "Cardito",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "09046008",
        name: "Careggine",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "01001057",
        name: "Carema",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03097014",
        name: "Carenno",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01006031",
        name: "Carentino",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18080023",
        name: "Careri",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01002030",
        name: "Caresana",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01002031",
        name: "Caresanablot",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01006032",
        name: "Carezzano",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18101003",
        name: "Carfizzi",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "20090022",
        name: "Cargeghe",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "18078025",
        name: "Cariati",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15064019",
        name: "Carife",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01001058",
        name: "Carignano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03013046",
        name: "Carimate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "15061016",
        name: "Carinaro",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "19082021",
        name: "Carini",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15061017",
        name: "Carinola",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01002032",
        name: "Carisio",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "04022042",
        name: "Carisolo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "16071011",
        name: "Carlantino",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03013047",
        name: "Carlazzo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "19089006",
        name: "Carlentini",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "06030018",
        name: "Carlino",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20111010",
        name: "Carloforte",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "18079020",
        name: "Carlopoli",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "01001059",
        name: "Carmagnola",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16075014",
        name: "Carmiano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "09100002",
        name: "Carmignano",
        districtInitials: "PO",
        district: "Prato",
        region: "Toscana"
    },
    {
        code: "05028023",
        name: "Carmignano di Brenta",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03012033",
        name: "Carnago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03108016",
        name: "Carnate",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03016055",
        name: "Carobbio degli Angeli",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "18078026",
        name: "Carolei",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03016056",
        name: "Carona",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19083011",
        name: "Caronia",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03012034",
        name: "Caronno Pertusella",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012035",
        name: "Caronno Varesino",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "16073002",
        name: "Carosino",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "16074002",
        name: "Carovigno",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "14094007",
        name: "Carovilli",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "08033011",
        name: "Carpaneto Piacentino",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "18078027",
        name: "Carpanzano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "11041009",
        name: "Carpegna",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "03017039",
        name: "Carpenedolo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01006033",
        name: "Carpeneto",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "08036005",
        name: "Carpi",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "03015050",
        name: "Carpiano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "16075015",
        name: "Carpignano Salentino",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01003036",
        name: "Carpignano Sesia",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "08035011",
        name: "Carpineti",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "13068008",
        name: "Carpineto della Nora",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "12058020",
        name: "Carpineto Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "13069011",
        name: "Carpineto Sinello",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "16071012",
        name: "Carpino",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "14094008",
        name: "Carpinone",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "09045003",
        name: "Carrara",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "05024024",
        name: "Carrè",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01006034",
        name: "Carrega Ligure",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "07011009",
        name: "Carro",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "07011010",
        name: "Carrodano",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "01006035",
        name: "Carrosio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01004043",
        name: "Carrù",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13066025",
        name: "Carsoli",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "05024025",
        name: "Cartigliano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01004044",
        name: "Cartignano",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "11041010",
        name: "Cartoceto",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "01006036",
        name: "Cartosio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05028026",
        name: "Cartura",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03015051",
        name: "Carugate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03013048",
        name: "Carugo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "13069012",
        name: "Carunchio",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "03016057",
        name: "Carvico",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04022043",
        name: "Carzano",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18101004",
        name: "Casabona",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "14070011",
        name: "Casacalenda",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "13069013",
        name: "Casacanditella",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15061018",
        name: "Casagiove",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01006037",
        name: "Casal Cermelli",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15061019",
        name: "Casal di Principe",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15065028",
        name: "Casal Velino",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13069014",
        name: "Casalanguida",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "12060017",
        name: "Casalattico",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01003037",
        name: "Casalbeltrame",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "13069015",
        name: "Casalbordino",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15064020",
        name: "Casalbore",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01001060",
        name: "Casalborgone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15065026",
        name: "Casalbuono",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03019016",
        name: "Casalbuttano ed Uniti",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "14070012",
        name: "Casalciprano",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "15062015",
        name: "Casalduni",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "01103019",
        name: "Casale Corte Cerro",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03019017",
        name: "Casale Cremasco-Vidolasco",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05028027",
        name: "Casale di Scodosia",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03012036",
        name: "Casale Litta",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "09050006",
        name: "Casale Marittimo",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01006039",
        name: "Casale Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05026009",
        name: "Casale sul Sile",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "08037011",
        name: "Casalecchio di Reno",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "01006038",
        name: "Casaleggio Boiro",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01003039",
        name: "Casaleggio Novara",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "05023019",
        name: "Casaleone",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03019018",
        name: "Casaletto Ceredano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03019019",
        name: "Casaletto di Sopra",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03098008",
        name: "Casaletto Lodigiano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "15065027",
        name: "Casaletto Spartano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03019020",
        name: "Casaletto Vaprio",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "08037012",
        name: "Casalfiumanese",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "08035012",
        name: "Casalgrande",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "01004045",
        name: "Casalgrasso",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18078156",
        name: "Casali del Manco",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13069016",
        name: "Casalincontrada",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01003040",
        name: "Casalino",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03019021",
        name: "Casalmaggiore",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03098009",
        name: "Casalmaiocco",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03019022",
        name: "Casalmorano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03020010",
        name: "Casalmoro",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01006040",
        name: "Casalnoceto",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15063017",
        name: "Casalnuovo di Napoli",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "16071013",
        name: "Casalnuovo Monterotaro",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03020011",
        name: "Casaloldo",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03098010",
        name: "Casalpusterlengo",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03020012",
        name: "Casalromano",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "05028028",
        name: "Casalserugo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "15061020",
        name: "Casaluce",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "16071014",
        name: "Casalvecchio di Puglia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "19083012",
        name: "Casalvecchio Siculo",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "12060018",
        name: "Casalvieri",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01003041",
        name: "Casalvolone",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03012037",
        name: "Casalzuigno",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "15063018",
        name: "Casamarciano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "16072015",
        name: "Casamassima",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15063019",
        name: "Casamicciola Terme",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15063020",
        name: "Casandrino",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01002033",
        name: "Casanova Elvo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "07009019",
        name: "Casanova Lerrone",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03018031",
        name: "Casanova Lonati",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "12058021",
        name: "Casape",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15061103",
        name: "Casapesenna",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01096014",
        name: "Casapinta",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "12057011",
        name: "Casaprota",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "15061021",
        name: "Casapulla",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "16075016",
        name: "Casarano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03097015",
        name: "Casargo",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03015055",
        name: "Casarile",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "06093010",
        name: "Casarsa della Delizia",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "07010011",
        name: "Casarza Ligure",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01006041",
        name: "Casasco",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03097016",
        name: "Casatenovo",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03018032",
        name: "Casatisma",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "15063021",
        name: "Casavatore",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03016058",
        name: "Casazza",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "10054007",
        name: "Cascia",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03012038",
        name: "Casciago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "09050040",
        name: "Casciana Terme Lari",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "09050008",
        name: "Cascina",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01001061",
        name: "Cascinette d'Ivrea",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018033",
        name: "Casei Gerola",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001062",
        name: "Caselette",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07010012",
        name: "Casella",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "15065029",
        name: "Caselle in Pittari",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03098011",
        name: "Caselle Landi",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03098012",
        name: "Caselle Lurani",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "01001063",
        name: "Caselle Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15061022",
        name: "Caserta",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "05026010",
        name: "Casier",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "18080024",
        name: "Casignana",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "08035013",
        name: "Casina",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "03016059",
        name: "Casirate d'Adda",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013052",
        name: "Caslino d'Erba",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03013053",
        name: "Casnate con Bernate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016060",
        name: "Casnigo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "15063022",
        name: "Casola di Napoli",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "09045004",
        name: "Casola in Lunigiana",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "08039005",
        name: "Casola Valsenio",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "09052004",
        name: "Casole d'Elsa",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "13069017",
        name: "Casoli",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "03018034",
        name: "Casorate Primo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03012039",
        name: "Casorate Sempione",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03015058",
        name: "Casorezzo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "15063023",
        name: "Casoria",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01005020",
        name: "Casorzo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "12057012",
        name: "Casperia",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03014013",
        name: "Caspoggio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "06030019",
        name: "Cassacco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03097017",
        name: "Cassago Brianza",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "18078029",
        name: "Cassano all'Ionio",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03015059",
        name: "Cassano d'Adda",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "16072016",
        name: "Cassano delle Murge",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15064021",
        name: "Cassano Irpino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03012040",
        name: "Cassano Magnago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01006191",
        name: "Cassano Spinola",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03012041",
        name: "Cassano Valcuvia",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "19089007",
        name: "Cassaro",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "03016061",
        name: "Cassiglio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03015060",
        name: "Cassina de' Pecchi",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03013055",
        name: "Cassina Rizzardi",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03097018",
        name: "Cassina Valsassina",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01005021",
        name: "Cassinasco",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01006043",
        name: "Cassine",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01006044",
        name: "Cassinelle",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03015061",
        name: "Cassinetta di Lugagnano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "12060019",
        name: "Cassino",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "05024026",
        name: "Cassola",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03018035",
        name: "Cassolnovo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05023020",
        name: "Castagnaro",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "09049006",
        name: "Castagneto Carducci",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "01001064",
        name: "Castagneto Po",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004046",
        name: "Castagnito",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01005022",
        name: "Castagnole delle Lanze",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01005023",
        name: "Castagnole Monferrato",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001065",
        name: "Castagnole Piemonte",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018036",
        name: "Castana",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03015062",
        name: "Castano Primo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03018037",
        name: "Casteggio",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03017040",
        name: "Castegnato",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05024027",
        name: "Castegnero",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "15064022",
        name: "Castel Baronia",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01005024",
        name: "Castel Boglione",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "08039006",
        name: "Castel Bolognese",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "15061023",
        name: "Castel Campagnano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "13067010",
        name: "Castel Castagna",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "04022045",
        name: "Castel Condino",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08037013",
        name: "Castel d'Aiano",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03020014",
        name: "Castel d'Ario",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "05023021",
        name: "Castel d'Azzano",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "14094009",
        name: "Castel del Giudice",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "13066026",
        name: "Castel del Monte",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "09053004",
        name: "Castel del Piano",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "08037014",
        name: "Castel del Rio",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "08037015",
        name: "Castel di Casio",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "13066027",
        name: "Castel di Ieri",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "19087013",
        name: "Castel di Iudica",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "11044011",
        name: "Castel di Lama",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "19083013",
        name: "Castel di Lucio",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "13066028",
        name: "Castel di Sangro",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15061024",
        name: "Castel di Sasso",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "12057013",
        name: "Castel di Tora",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "09051008",
        name: "Castel Focognano",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "13069018",
        name: "Castel Frentano",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "03019024",
        name: "Castel Gabbiano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "12058022",
        name: "Castel Gandolfo",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "10055009",
        name: "Castel Giorgio",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "03020015",
        name: "Castel Goffredo",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "08037016",
        name: "Castel Guelfo di Bologna",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "04022240",
        name: "Castel Ivano",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "12058023",
        name: "Castel Madama",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "08037019",
        name: "Castel Maggiore",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03017042",
        name: "Castel Mella",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15061026",
        name: "Castel Morrone",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "10054008",
        name: "Castel Ritaldi",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01005032",
        name: "Castel Rocchero",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03016063",
        name: "Castel Rozzone",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "15065034",
        name: "Castel San Giorgio",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "08033013",
        name: "Castel San Giovanni",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "15065035",
        name: "Castel San Lorenzo",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "09051010",
        name: "Castel San Niccolò",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "12058025",
        name: "Castel San Pietro Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "08037020",
        name: "Castel San Pietro Terme",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "14094012",
        name: "Castel San Vincenzo",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "12057015",
        name: "Castel Sant'Angelo",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "12056017",
        name: "Castel Sant'Elia",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "10055010",
        name: "Castel Viscardo",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "07008015",
        name: "Castel Vittorio",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "15061027",
        name: "Castel Volturno",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "05028029",
        name: "Castelbaldo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03020013",
        name: "Castelbelforte",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "11042008",
        name: "Castelbellino",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "04021018",
        name: "Castelbello-Ciardes",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07009020",
        name: "Castelbianco",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "14070013",
        name: "Castelbottaccio",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "19082022",
        name: "Castelbuono",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15065030",
        name: "Castelcivita",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03017041",
        name: "Castelcovati",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05026011",
        name: "Castelcucco",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "19082023",
        name: "Casteldaccia",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "08099021",
        name: "Casteldelci",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "01004047",
        name: "Casteldelfino",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03019023",
        name: "Casteldidone",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "11042010",
        name: "Castelfidardo",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "09048010",
        name: "Castelfiorentino",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "12059004",
        name: "Castelforte",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "15064023",
        name: "Castelfranci",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "09050009",
        name: "Castelfranco di Sotto",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "08036006",
        name: "Castelfranco Emilia",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "15062016",
        name: "Castelfranco in Miscano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "09051040",
        name: "Castelfranco Piandiscò",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "05026012",
        name: "Castelfranco Veneto",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03098062",
        name: "Castelgerundo",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "05024028",
        name: "Castelgomberto",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "17076021",
        name: "Castelgrande",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "05029011",
        name: "Castelguglielmo",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "13069019",
        name: "Castelguidone",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01005025",
        name: "Castell'Alfero",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "08033012",
        name: "Castell'Arquato",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "09053005",
        name: "Castell'Azzara",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "19083014",
        name: "Castell'Umberto",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "15065031",
        name: "Castellabate",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13066029",
        name: "Castellafiume",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "13067011",
        name: "Castellalto",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "19081005",
        name: "Castellammare del Golfo",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "15063024",
        name: "Castellammare di Stabia",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01001066",
        name: "Castellamonte",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16072017",
        name: "Castellana Grotte",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "19082024",
        name: "Castellana Sicula",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "16073003",
        name: "Castellaneta",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "01006045",
        name: "Castellania Coppi",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03012042",
        name: "Castellanza",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01006046",
        name: "Castellar Guidobono",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "08035014",
        name: "Castellarano",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "07008014",
        name: "Castellaro",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01006047",
        name: "Castellazzo Bormida",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01003042",
        name: "Castellazzo Novarese",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03019025",
        name: "Castelleone",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "11042011",
        name: "Castelleone di Suasa",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01005026",
        name: "Castellero",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01096015",
        name: "Castelletto Cervo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01006048",
        name: "Castelletto d'Erro",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01006049",
        name: "Castelletto d'Orba",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018038",
        name: "Castelletto di Branduzzo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01006050",
        name: "Castelletto Merli",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01005027",
        name: "Castelletto Molina",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01006051",
        name: "Castelletto Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01003043",
        name: "Castelletto sopra Ticino",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01004049",
        name: "Castelletto Stura",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004050",
        name: "Castelletto Uzzone",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13067012",
        name: "Castelli",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "03016062",
        name: "Castelli Calepio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "09052005",
        name: "Castellina in Chianti",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09050010",
        name: "Castellina Marittima",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01004051",
        name: "Castellinaldo d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "14070014",
        name: "Castellino del Biferno",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01004052",
        name: "Castellino Tanaro",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "12060020",
        name: "Castelliri",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "03012043",
        name: "Castello Cabiaglio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03018039",
        name: "Castello d'Agogna",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "08037017",
        name: "Castello d'Argile",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "15061025",
        name: "Castello del Matese",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03014014",
        name: "Castello dell'Acqua",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01005028",
        name: "Castello di Annone",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03097019",
        name: "Castello di Brianza",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "15063025",
        name: "Castello di Cisterna",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "05026013",
        name: "Castello di Godego",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "04022048",
        name: "Castello Tesino",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022047",
        name: "Castello-Molina di Fiemme",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03020016",
        name: "Castellucchio",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "16071015",
        name: "Castelluccio dei Sauri",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "17076022",
        name: "Castelluccio Inferiore",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "17076023",
        name: "Castelluccio Superiore",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "16071016",
        name: "Castelluccio Valmaggiore",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "01004053",
        name: "Castelmagno",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03013058",
        name: "Castelmarte",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05029012",
        name: "Castelmassa",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "14070015",
        name: "Castelmauro",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "17076024",
        name: "Castelmezzano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "19083015",
        name: "Castelmola",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03018040",
        name: "Castelnovetto",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05029013",
        name: "Castelnovo Bariano",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "06093011",
        name: "Castelnovo del Friuli",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "08035015",
        name: "Castelnovo di Sotto",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "08035016",
        name: "Castelnovo ne' Monti",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "04022049",
        name: "Castelnuovo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01005029",
        name: "Castelnuovo Belbo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "09052006",
        name: "Castelnuovo Berardenga",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "03098013",
        name: "Castelnuovo Bocca d'Adda",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "01006052",
        name: "Castelnuovo Bormida",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03013059",
        name: "Castelnuovo Bozzente",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01005030",
        name: "Castelnuovo Calcea",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "15065032",
        name: "Castelnuovo Cilento",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05023022",
        name: "Castelnuovo del Garda",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "16071017",
        name: "Castelnuovo della Daunia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "01004054",
        name: "Castelnuovo di Ceva",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15065033",
        name: "Castelnuovo di Conza",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "12057014",
        name: "Castelnuovo di Farfa",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "09046009",
        name: "Castelnuovo di Garfagnana",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "12058024",
        name: "Castelnuovo di Porto",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "09050011",
        name: "Castelnuovo di Val di Cecina",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01005031",
        name: "Castelnuovo Don Bosco",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "07011011",
        name: "Castelnuovo Magra",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "01001067",
        name: "Castelnuovo Nigra",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12060021",
        name: "Castelnuovo Parano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "08036007",
        name: "Castelnuovo Rangone",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "01006053",
        name: "Castelnuovo Scrivia",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15062017",
        name: "Castelpagano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "14094010",
        name: "Castelpetroso",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "14094011",
        name: "Castelpizzuto",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "11042012",
        name: "Castelplanio",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "15062018",
        name: "Castelpoto",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "11043009",
        name: "Castelraimondo",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "04021019",
        name: "Castelrotto",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11043010",
        name: "Castelsantangelo sul Nera",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "17076025",
        name: "Castelsaraceno",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "20090023",
        name: "Castelsardo",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03012044",
        name: "Castelseprio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "18101005",
        name: "Castelsilano",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "01006054",
        name: "Castelspina",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "19084012",
        name: "Casteltermini",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "03012045",
        name: "Castelveccana",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "13066030",
        name: "Castelvecchio Calvisio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "07009021",
        name: "Castelvecchio di Rocca Barbena",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "13066031",
        name: "Castelvecchio Subequo",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15062019",
        name: "Castelvenere",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03019026",
        name: "Castelverde",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "14094013",
        name: "Castelverrino",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "15062020",
        name: "Castelvetere in Val Fortore",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15064024",
        name: "Castelvetere sul Calore",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "19081006",
        name: "Castelvetrano",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "08036008",
        name: "Castelvetro di Modena",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "08033014",
        name: "Castelvetro Piacentino",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03019027",
        name: "Castelvisconti",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "08037021",
        name: "Castenaso",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03017043",
        name: "Castenedolo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20111011",
        name: "Castiadas",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "09051011",
        name: "Castiglion Fibocchi",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "09051012",
        name: "Castiglion Fiorentino",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "13068009",
        name: "Castiglione a Casauria",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "07010013",
        name: "Castiglione Chiavarese",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "18078030",
        name: "Castiglione Cosentino",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03098014",
        name: "Castiglione d'Adda",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "09052007",
        name: "Castiglione d'Orcia",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "08037022",
        name: "Castiglione dei Pepoli",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "15065036",
        name: "Castiglione del Genovesi",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "10054009",
        name: "Castiglione del Lago",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "09053006",
        name: "Castiglione della Pescaia",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "03020017",
        name: "Castiglione delle Stiviere",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "09046010",
        name: "Castiglione di Garfagnana",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "19087014",
        name: "Castiglione di Sicilia",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "01004055",
        name: "Castiglione Falletto",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "12056018",
        name: "Castiglione in Teverina",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "13069020",
        name: "Castiglione Messer Marino",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13067013",
        name: "Castiglione Messer Raimondo",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "03012046",
        name: "Castiglione Olona",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01004056",
        name: "Castiglione Tinella",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001068",
        name: "Castiglione Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "11044012",
        name: "Castignano",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "13067014",
        name: "Castilenti",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "01004057",
        name: "Castino",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03014015",
        name: "Castione Andevenno",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03016064",
        name: "Castione della Presolana",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "06030020",
        name: "Castions di Strada",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03098015",
        name: "Castiraga Vidardo",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03017044",
        name: "Casto",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "11044013",
        name: "Castorano",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "03017045",
        name: "Castrezzato",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "16075017",
        name: "Castri di Lecce",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "16075018",
        name: "Castrignano de' Greci",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "16075019",
        name: "Castrignano del Capo",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03016065",
        name: "Castro",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "16075096",
        name: "Castro",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "12060023",
        name: "Castro dei Volsci",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "08040005",
        name: "Castrocaro Terme e Terra del Sole",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "12060022",
        name: "Castrocielo",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "19084013",
        name: "Castrofilippo",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "18078031",
        name: "Castrolibero",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03012047",
        name: "Castronno",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "19082025",
        name: "Castronovo di Sicilia",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "17076026",
        name: "Castronuovo di Sant'Andrea",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "14070016",
        name: "Castropignano",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "19083016",
        name: "Castroreale",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "18078032",
        name: "Castroregio",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18078033",
        name: "Castrovillari",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19087015",
        name: "Catania",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "18079023",
        name: "Catanzaro",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "19086006",
        name: "Catenanuova",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "13068010",
        name: "Catignano",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "08099002",
        name: "Cattolica",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "19084014",
        name: "Cattolica Eraclea",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "18080025",
        name: "Caulonia",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "15062021",
        name: "Cautano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15065037",
        name: "Cava de' Tirreni",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03018041",
        name: "Cava Manara",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01096016",
        name: "Cavaglià",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01003044",
        name: "Cavaglietto",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01003045",
        name: "Cavaglio d'Agogna",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01001069",
        name: "Cavagnolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05023023",
        name: "Cavaion Veronese",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04022050",
        name: "Cavalese",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004058",
        name: "Cavallerleone",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004059",
        name: "Cavallermaggiore",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "16075020",
        name: "Cavallino",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "05027044",
        name: "Cavallino-Treporti",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "01003047",
        name: "Cavallirio",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "04022051",
        name: "Cavareno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03013062",
        name: "Cavargna",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03012048",
        name: "Cavaria con Premezzo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05027006",
        name: "Cavarzere",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "05026014",
        name: "Cavaso del Tomba",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "06093012",
        name: "Cavasso Nuovo",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01006055",
        name: "Cavatore",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "06030021",
        name: "Cavazzo Carnico",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12058026",
        name: "Cave",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "04022052",
        name: "Cavedago",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022053",
        name: "Cavedine",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03098017",
        name: "Cavenago d'Adda",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03108017",
        name: "Cavenago di Brianza",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03016066",
        name: "Cavernago",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08036009",
        name: "Cavezzo",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "04022054",
        name: "Cavizzana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001070",
        name: "Cavour",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08035017",
        name: "Cavriago",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "03020018",
        name: "Cavriana",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "09051013",
        name: "Cavriglia",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "03012049",
        name: "Cazzago Brabbia",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03017046",
        name: "Cazzago San Martino",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05023024",
        name: "Cazzano di Tramigna",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03016067",
        name: "Cazzano Sant'Andrea",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12060024",
        name: "Ceccano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "03018042",
        name: "Cecima",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "09049007",
        name: "Cecina",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "03017047",
        name: "Cedegolo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03014016",
        name: "Cedrasco",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "19082026",
        name: "Cefalà Diana",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "19082027",
        name: "Cefalù",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "05027007",
        name: "Ceggia",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "16074003",
        name: "Ceglie Messapica",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "13066032",
        name: "Celano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "13069021",
        name: "Celenza sul Trigno",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "16071018",
        name: "Celenza Valfortore",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "18078034",
        name: "Celico",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03019028",
        name: "Cella Dati",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01006056",
        name: "Cella Monte",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16072018",
        name: "Cellamare",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "18078035",
        name: "Cellara",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01005033",
        name: "Cellarengo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03017048",
        name: "Cellatica",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15065038",
        name: "Celle di Bulgheria",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01004060",
        name: "Celle di Macra",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "16071019",
        name: "Celle di San Vito",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "01005034",
        name: "Celle Enomondo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "07009022",
        name: "Celle Ligure",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "12056019",
        name: "Celleno",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "12056020",
        name: "Cellere",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "13067015",
        name: "Cellino Attanasio",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "16074004",
        name: "Cellino San Marco",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "01002171",
        name: "Cellio con Breia",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "15061102",
        name: "Cellole",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "04022241",
        name: "Cembra Lisignago",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18079024",
        name: "Cenadi",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "03016068",
        name: "Cenate Sopra",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016069",
        name: "Cenate Sotto",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05025010",
        name: "Cencenighe Agordino",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03016070",
        name: "Cene",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05029014",
        name: "Ceneselli",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "07009023",
        name: "Cengio",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01004061",
        name: "Centallo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08038004",
        name: "Cento",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "15065039",
        name: "Centola",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "18079025",
        name: "Centrache",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "03013254",
        name: "Centro Valle Intelvi",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "19086007",
        name: "Centuripe",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "13068011",
        name: "Cepagatti",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "15062022",
        name: "Ceppaloni",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "01103021",
        name: "Ceppo Morelli",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "12060025",
        name: "Ceprano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "19086008",
        name: "Cerami",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "07010014",
        name: "Ceranesi",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01003049",
        name: "Cerano",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03013063",
        name: "Cerano d'Intelvi",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03018043",
        name: "Ceranova",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "15065040",
        name: "Ceraso",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "14070017",
        name: "Cercemaggiore",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01001071",
        name: "Cercenasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "14070018",
        name: "Cercepiccola",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "18078036",
        name: "Cerchiara di Calabria",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13066033",
        name: "Cerchio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03014017",
        name: "Cercino",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "06030022",
        name: "Cercivento",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15063026",
        name: "Cercola",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "19082028",
        name: "Cerda",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "05023025",
        name: "Cerea",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "05029015",
        name: "Ceregnano",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "18101006",
        name: "Cerenzia",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "01001072",
        name: "Ceres",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03020019",
        name: "Ceresara",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01006057",
        name: "Cereseto",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01004062",
        name: "Ceresole Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001073",
        name: "Ceresole Reale",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03016071",
        name: "Cerete",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03018044",
        name: "Ceretto Lomellina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03018045",
        name: "Cergnago",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "07009024",
        name: "Ceriale",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "07008016",
        name: "Ceriana",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "03108018",
        name: "Ceriano Laghetto",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "08033015",
        name: "Cerignale",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "16071020",
        name: "Cerignola",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "18078037",
        name: "Cerisano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03013064",
        name: "Cermenate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04021020",
        name: "Cermes",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "13067016",
        name: "Cermignano",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "03013065",
        name: "Cernobbio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03097020",
        name: "Cernusco Lombardone",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03015070",
        name: "Cernusco sul Naviglio",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01005035",
        name: "Cerreto d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "11042013",
        name: "Cerreto d'Esi",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "10054010",
        name: "Cerreto di Spoleto",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01006058",
        name: "Cerreto Grue",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "09048011",
        name: "Cerreto Guidi",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "12058027",
        name: "Cerreto Laziale",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15062023",
        name: "Cerreto Sannita",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "01004063",
        name: "Cerretto Langhe",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01006059",
        name: "Cerrina Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01096018",
        name: "Cerrione",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03015071",
        name: "Cerro al Lambro",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "14094014",
        name: "Cerro al Volturno",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "03015072",
        name: "Cerro Maggiore",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01005036",
        name: "Cerro Tanaro",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05023026",
        name: "Cerro Veronese",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "17076027",
        name: "Cersosimo",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "09048012",
        name: "Certaldo",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "03018046",
        name: "Certosa di Pavia",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "18079027",
        name: "Cerva",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "12058028",
        name: "Cervara di Roma",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05028030",
        name: "Cervarese Santa Croce",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "12060026",
        name: "Cervaro",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01004064",
        name: "Cervasca",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01002041",
        name: "Cervatto",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03017049",
        name: "Cerveno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01004065",
        name: "Cervere",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03018047",
        name: "Cervesina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "12058029",
        name: "Cerveteri",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "08039007",
        name: "Cervia",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "18078038",
        name: "Cervicati",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03098018",
        name: "Cervignano d'Adda",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "06030023",
        name: "Cervignano del Friuli",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15064025",
        name: "Cervinara",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15061028",
        name: "Cervino",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "07008017",
        name: "Cervo",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "18078039",
        name: "Cerzeto",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15061029",
        name: "Cesa",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03097021",
        name: "Cesana Brianza",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01001074",
        name: "Cesana Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03015074",
        name: "Cesano Boscone",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03108019",
        name: "Cesano Maderno",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "01103022",
        name: "Cesara",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "19083017",
        name: "Cesarò",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03015076",
        name: "Cesate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "08040007",
        name: "Cesena",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "08040008",
        name: "Cesenatico",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "15064026",
        name: "Cesinali",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "07008018",
        name: "Cesio",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "05025011",
        name: "Cesiomaggiore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05026015",
        name: "Cessalto",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "18102006",
        name: "Cessaniti",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "11043011",
        name: "Cessapalombo",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "01005037",
        name: "Cessole",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "15065041",
        name: "Cetara",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03017050",
        name: "Ceto",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "09052008",
        name: "Cetona",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "18078040",
        name: "Cetraro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01004066",
        name: "Ceva",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017051",
        name: "Cevo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "02007013",
        name: "Challand-Saint-Anselme",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007014",
        name: "Challand-Saint-Victor",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007015",
        name: "Chambave",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007016",
        name: "Chamois",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007017",
        name: "Champdepraz",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007018",
        name: "Champorcher",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007019",
        name: "Charvensod",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007020",
        name: "Châtillon",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "01004067",
        name: "Cherasco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20090024",
        name: "Cheremule",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01001075",
        name: "Chialamberto",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05024029",
        name: "Chiampo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "15064027",
        name: "Chianche",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "09052009",
        name: "Chianciano Terme",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09050012",
        name: "Chianni",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01001076",
        name: "Chianocco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19088002",
        name: "Chiaramonte Gulfi",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "20090025",
        name: "Chiaramonti",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "05026016",
        name: "Chiarano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "11042014",
        name: "Chiaravalle",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "18079029",
        name: "Chiaravalle Centrale",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "03017052",
        name: "Chiari",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "17076028",
        name: "Chiaromonte",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "14094015",
        name: "Chiauci",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "07010015",
        name: "Chiavari",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03014018",
        name: "Chiavenna",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01001077",
        name: "Chiaverano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "04021021",
        name: "Chienes",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001078",
        name: "Chieri",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05025012",
        name: "Chies d'Alpago",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03014019",
        name: "Chiesa in Valmalenco",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01001079",
        name: "Chiesanuova",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "09047022",
        name: "Chiesina Uzzanese",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "13069022",
        name: "Chieti",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "16071021",
        name: "Chieuti",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03019029",
        name: "Chieve",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03016072",
        name: "Chignolo d'Isola",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03018048",
        name: "Chignolo Po",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05027008",
        name: "Chioggia",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "01001080",
        name: "Chiomonte",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "06093013",
        name: "Chions",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06030024",
        name: "Chiopris-Viscone",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "09051014",
        name: "Chitignano",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "03016073",
        name: "Chiuduno",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05024030",
        name: "Chiuppano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03014020",
        name: "Chiuro",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "04021022",
        name: "Chiusa",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004068",
        name: "Chiusa di Pesio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001081",
        name: "Chiusa di San Michele",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19082029",
        name: "Chiusa Sclafani",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "06030025",
        name: "Chiusaforte",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "07008019",
        name: "Chiusanico",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01005038",
        name: "Chiusano d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "15064028",
        name: "Chiusano di San Domenico",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "07008020",
        name: "Chiusavecchia",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "09052010",
        name: "Chiusdino",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09052011",
        name: "Chiusi",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09051015",
        name: "Chiusi della Verna",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "01001082",
        name: "Chivasso",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12058118",
        name: "Ciampino",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "19084015",
        name: "Cianciana",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "05025013",
        name: "Cibiana di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "07010016",
        name: "Cicagna",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "18079030",
        name: "Cicala",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "15063027",
        name: "Cicciano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15065042",
        name: "Cicerale",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "12058030",
        name: "Ciciliano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03019030",
        name: "Cicognolo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01001083",
        name: "Ciconio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002042",
        name: "Cigliano",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01004069",
        name: "Cigliè",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03018049",
        name: "Cigognola",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03017053",
        name: "Cigole",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03018050",
        name: "Cilavegna",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05026017",
        name: "Cimadolmo",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03017054",
        name: "Cimbergo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "18080026",
        name: "Ciminà",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19082030",
        name: "Ciminna",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15063028",
        name: "Cimitile",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "06093014",
        name: "Cimolais",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04022058",
        name: "Cimone",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01005039",
        name: "Cinaglio",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "12058031",
        name: "Cineto Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03019031",
        name: "Cingia de' Botti",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "11043012",
        name: "Cingoli",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "09053007",
        name: "Cinigiano",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "03015077",
        name: "Cinisello Balsamo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "19082031",
        name: "Cinisi",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03014021",
        name: "Cino",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "18080027",
        name: "Cinquefrondi",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01001084",
        name: "Cintano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "04022059",
        name: "Cinte Tesino",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05027009",
        name: "Cinto Caomaggiore",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "05028031",
        name: "Cinto Euganeo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01001085",
        name: "Cinzano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15061030",
        name: "Ciorlano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "07008021",
        name: "Cipressa",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "15062024",
        name: "Circello",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "01001086",
        name: "Ciriè",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "17077005",
        name: "Cirigliano",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "03013068",
        name: "Cirimido",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "18101007",
        name: "Cirò",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "18101008",
        name: "Cirò Marina",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "04022060",
        name: "Cis",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03016074",
        name: "Cisano Bergamasco",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "07009025",
        name: "Cisano sul Neva",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03016075",
        name: "Ciserano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03012050",
        name: "Cislago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03015078",
        name: "Cisliano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05026018",
        name: "Cison di Valmarino",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01004070",
        name: "Cissone",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01005040",
        name: "Cisterna d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "12059005",
        name: "Cisterna di Latina",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "16074005",
        name: "Cisternino",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "10054011",
        name: "Citerna",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "10054012",
        name: "Città della Pieve",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "10054013",
        name: "Città di Castello",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "13068012",
        name: "Città Sant'Angelo",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "05028032",
        name: "Cittadella",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "12057016",
        name: "Cittaducale",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "18080028",
        name: "Cittanova",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "12057017",
        name: "Cittareale",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03012051",
        name: "Cittiglio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03097022",
        name: "Civate",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "07008022",
        name: "Civezza",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "04022061",
        name: "Civezzano",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01002043",
        name: "Civiasco",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "06030026",
        name: "Cividale del Friuli",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03016076",
        name: "Cividate al Piano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03017055",
        name: "Cividate Camuno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "18078041",
        name: "Civita",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12056021",
        name: "Civita Castellana",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "13066034",
        name: "Civita d'Antino",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "14070019",
        name: "Civitacampomarano",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "13069023",
        name: "Civitaluparella",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "14094016",
        name: "Civitanova del Sannio",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "11043013",
        name: "Civitanova Marche",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "13068013",
        name: "Civitaquana",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "12058032",
        name: "Civitavecchia",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "13066035",
        name: "Civitella Alfedena",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "13068014",
        name: "Civitella Casanova",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "12056022",
        name: "Civitella d'Agliano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "13067017",
        name: "Civitella del Tronto",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "08040009",
        name: "Civitella di Romagna",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "09051016",
        name: "Civitella in Val di Chiana",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "13069024",
        name: "Civitella Messer Raimondo",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "09053008",
        name: "Civitella Paganico",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "13066036",
        name: "Civitella Roveto",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "12058033",
        name: "Civitella San Paolo",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03014022",
        name: "Civo",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03013071",
        name: "Claino con Osteno",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "06093015",
        name: "Claut",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06093016",
        name: "Clauzetto",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01004071",
        name: "Clavesana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001087",
        name: "Claviere",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "04022062",
        name: "Cles",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18078042",
        name: "Cleto",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03012052",
        name: "Clivio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03016077",
        name: "Clusone",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001088",
        name: "Coassolo Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001089",
        name: "Coazze",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01005041",
        name: "Coazzolo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03017056",
        name: "Coccaglio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01005042",
        name: "Cocconato",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03012053",
        name: "Cocquio-Trevisago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "13066037",
        name: "Cocullo",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "05028033",
        name: "Codevigo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03018051",
        name: "Codevilla",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "08038005",
        name: "Codigoro",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "05026019",
        name: "Codognè",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03098019",
        name: "Codogno",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "06030027",
        name: "Codroipo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20090026",
        name: "Codrongianos",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01096019",
        name: "Coggiola",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03108020",
        name: "Cogliate",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "02007021",
        name: "Cogne",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "07010017",
        name: "Cogoleto",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "05024032",
        name: "Cogollo del Cengio",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "07010018",
        name: "Cogorno",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01003051",
        name: "Colazza",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "05024126",
        name: "Colceresa",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03016078",
        name: "Colere",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12060027",
        name: "Colfelice",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "08033016",
        name: "Coli",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03097023",
        name: "Colico",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "12057018",
        name: "Collalto Sabino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "13066038",
        name: "Collarmele",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "10054014",
        name: "Collazzone",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03097024",
        name: "Colle Brianza",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "14070020",
        name: "Colle d'Anchise",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "12057019",
        name: "Colle di Tora",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "09052012",
        name: "Colle di Val d'Elsa",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "12060029",
        name: "Colle San Magno",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15062025",
        name: "Colle Sannita",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "05025014",
        name: "Colle Santa Lucia",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05026020",
        name: "Colle Umberto",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03017057",
        name: "Collebeato",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "08034009",
        name: "Collecchio",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "13068015",
        name: "Collecorvino",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "13067018",
        name: "Colledara",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "13069025",
        name: "Colledimacine",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13069026",
        name: "Colledimezzo",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "12058034",
        name: "Colleferro",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "12057020",
        name: "Collegiove",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "01001090",
        name: "Collegno",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "13066039",
        name: "Collelongo",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "12060028",
        name: "Collepardo",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "16075021",
        name: "Collepasso",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "13066040",
        name: "Collepietro",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "01001091",
        name: "Colleretto Castelnuovo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001092",
        name: "Colleretto Giacosa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "09049008",
        name: "Collesalvetti",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "19082032",
        name: "Collesano",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "14070021",
        name: "Colletorto",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "12057021",
        name: "Collevecchio",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "14094017",
        name: "Colli a Volturno",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "11041069",
        name: "Colli al Metauro",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11044014",
        name: "Colli del Tronto",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "12057022",
        name: "Colli sul Velino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03018193",
        name: "Colli Verdi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "15065043",
        name: "Colliano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "20111012",
        name: "Collinas",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03017058",
        name: "Collio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01002045",
        name: "Collobiano",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "06030028",
        name: "Colloredo di Monte Albano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "11043014",
        name: "Colmurano",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "17077006",
        name: "Colobraro",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "05023027",
        name: "Cologna Veneta",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03017059",
        name: "Cologne",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03016079",
        name: "Cologno al Serio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03015081",
        name: "Cologno Monzese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05023028",
        name: "Colognola ai Colli",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "12058035",
        name: "Colonna",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "13067019",
        name: "Colonnella",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "03013074",
        name: "Colonno",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03014023",
        name: "Colorina",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "08034010",
        name: "Colorno",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "18078043",
        name: "Colosimi",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03015082",
        name: "Colturano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03013251",
        name: "Colverde",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016080",
        name: "Colzate",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03012054",
        name: "Comabbio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "08038006",
        name: "Comacchio",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "09045005",
        name: "Comano",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "04022228",
        name: "Comano Terme",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03098020",
        name: "Comazzo",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "06030029",
        name: "Comeglians",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05025015",
        name: "Comelico Superiore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03012055",
        name: "Comerio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03017060",
        name: "Comezzano-Cizzago",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01003052",
        name: "Comignago",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "19088003",
        name: "Comiso",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "19084016",
        name: "Comitini",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "15063029",
        name: "Comiziano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03020020",
        name: "Commessaggio",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "04022064",
        name: "Commezzadura",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03013075",
        name: "Como",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "08034011",
        name: "Compiano",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "03016081",
        name: "Comun Nuovo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "11044015",
        name: "Comunanza",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "05027010",
        name: "Cona",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "14094018",
        name: "Conca Casale",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "15065044",
        name: "Conca dei Marini",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15061031",
        name: "Conca della Campania",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "05023029",
        name: "Concamarise",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "12057023",
        name: "Concerviano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03017061",
        name: "Concesio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05027011",
        name: "Concordia Sagittaria",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "08036010",
        name: "Concordia sulla Secchia",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "03108021",
        name: "Concorezzo",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "18080029",
        name: "Condofuri",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01001093",
        name: "Condove",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19083018",
        name: "Condrò",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "05026021",
        name: "Conegliano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03018052",
        name: "Confienza",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "12057024",
        name: "Configni",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "18079033",
        name: "Conflenti",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "01006060",
        name: "Coniolo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "08039008",
        name: "Conselice",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "05028034",
        name: "Conselve",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "04022242",
        name: "Contà",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "19082033",
        name: "Contessa Entellina",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "12057025",
        name: "Contigliano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "15064029",
        name: "Contrada",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "13067020",
        name: "Controguerra",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "15065045",
        name: "Controne",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15065046",
        name: "Contursi Terme",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "16072019",
        name: "Conversano",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15064030",
        name: "Conza della Campania",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01006061",
        name: "Conzano",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16075022",
        name: "Copertino",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03018053",
        name: "Copiano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "08038007",
        name: "Copparo",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "03018054",
        name: "Corana",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "16072020",
        name: "Corato",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15065047",
        name: "Corbara",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03015085",
        name: "Corbetta",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05029017",
        name: "Corbola",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "12056023",
        name: "Corchiano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "10054015",
        name: "Corciano",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "06093017",
        name: "Cordenons",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05026022",
        name: "Cordignano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "06093018",
        name: "Cordovado",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "09046011",
        name: "Coreglia Antelminelli",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "07010019",
        name: "Coreglia Ligure",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "12060030",
        name: "Coreno Ausonio",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "13066041",
        name: "Corfinio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "12059006",
        name: "Cori",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "08099003",
        name: "Coriano",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "16075023",
        name: "Corigliano d'Otranto",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "18078157",
        name: "Corigliano-Rossano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "11042015",
        name: "Corinaldo",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01001094",
        name: "Corio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19082034",
        name: "Corleone",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15065048",
        name: "Corleto Monforte",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "17076029",
        name: "Corleto Perticara",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03015086",
        name: "Cormano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "06031002",
        name: "Cormons",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03016082",
        name: "Corna Imagna",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016249",
        name: "Cornalba",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03018191",
        name: "Cornale e Bastida",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03015087",
        name: "Cornaredo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03108053",
        name: "Cornate d'Adda",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "04021023",
        name: "Cornedo all'Isarco",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05024034",
        name: "Cornedo Vicentino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03098021",
        name: "Cornegliano Laudense",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "01004072",
        name: "Corneliano d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08034012",
        name: "Corniglio",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "06030030",
        name: "Corno di Rosazzo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03098022",
        name: "Corno Giovine",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03098023",
        name: "Cornovecchio",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "05026023",
        name: "Cornuda",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "08035020",
        name: "Correggio",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "03108022",
        name: "Correzzana",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "05028035",
        name: "Correzzola",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03013077",
        name: "Corrido",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "11043015",
        name: "Corridonia",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "13067021",
        name: "Corropoli",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "16075024",
        name: "Corsano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03015093",
        name: "Corsico",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01005044",
        name: "Corsione",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "04021024",
        name: "Cortaccia sulla strada del vino",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18079034",
        name: "Cortale",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "01005045",
        name: "Cortandone",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01005046",
        name: "Cortanze",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01005047",
        name: "Cortazzone",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "08033017",
        name: "Corte Brugnatella",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03019032",
        name: "Corte de' Cortesi con Cignone",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03019033",
        name: "Corte de' Frati",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03017062",
        name: "Corte Franca",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03098024",
        name: "Corte Palasio",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "08033018",
        name: "Cortemaggiore",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "01004073",
        name: "Cortemilia",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017063",
        name: "Corteno Golgi",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03097025",
        name: "Cortenova",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03016083",
        name: "Cortenuova",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03018192",
        name: "Corteolona e Genzone",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01005048",
        name: "Cortiglione",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05025016",
        name: "Cortina d'Ampezzo",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "04021025",
        name: "Cortina sulla strada del vino",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "13067022",
        name: "Cortino",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "09051017",
        name: "Cortona",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "13068016",
        name: "Corvara",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "04021026",
        name: "Corvara in Badia",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03018057",
        name: "Corvino San Quirico",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03017064",
        name: "Corzano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "06030031",
        name: "Coseano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "18078045",
        name: "Cosenza",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "07008023",
        name: "Cosio d'Arroscia",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "03014024",
        name: "Cosio Valtellino",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "18080030",
        name: "Cosoleto",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01004074",
        name: "Cossano Belbo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001095",
        name: "Cossano Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01096020",
        name: "Cossato",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "07009026",
        name: "Cosseria",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "11044016",
        name: "Cossignano",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "01103023",
        name: "Cossogno",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "20090027",
        name: "Cossoine",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01005049",
        name: "Cossombrato",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03018058",
        name: "Costa de' Nobili",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03016084",
        name: "Costa di Mezzate",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05029018",
        name: "Costa di Rovigo",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "03097026",
        name: "Costa Masnaga",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03016247",
        name: "Costa Serina",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016085",
        name: "Costa Valle Imagna",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01006062",
        name: "Costa Vescovato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03016086",
        name: "Costa Volpino",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05024035",
        name: "Costabissara",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "10054016",
        name: "Costacciaro",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01002047",
        name: "Costanzana",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "07008024",
        name: "Costarainera",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "05023030",
        name: "Costermano sul Garda",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01005050",
        name: "Costigliole d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01004075",
        name: "Costigliole Saluzzo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08039009",
        name: "Cotignola",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "18101009",
        name: "Cotronei",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "12057026",
        name: "Cottanello",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "02007022",
        name: "Courmayeur",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03016087",
        name: "Covo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03018059",
        name: "Cozzo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "17077007",
        name: "Craco",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "03097027",
        name: "Crandola Valsassina",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01002048",
        name: "Cravagliana",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01004076",
        name: "Cravanzana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01103024",
        name: "Craveggia",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "05024036",
        name: "Creazzo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "13069027",
        name: "Crecchio",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "03016088",
        name: "Credaro",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03019034",
        name: "Credera Rubbiano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03019035",
        name: "Crema",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03097028",
        name: "Cremella",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03012056",
        name: "Cremenaga",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03097029",
        name: "Cremeno",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03013083",
        name: "Cremia",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01006063",
        name: "Cremolino",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03019036",
        name: "Cremona",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03019037",
        name: "Cremosano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01002049",
        name: "Crescentino",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "05024037",
        name: "Crespadoro",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03098025",
        name: "Crespiatica",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "09050041",
        name: "Crespina Lorenzana",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "05029019",
        name: "Crespino",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01003055",
        name: "Cressa",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01096021",
        name: "Crevacuore",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "08037024",
        name: "Crevalcore",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "01103025",
        name: "Crevoladossola",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "15063030",
        name: "Crispano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "16073004",
        name: "Crispiano",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "01004077",
        name: "Crissolo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "07010020",
        name: "Crocefieschi",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "05026025",
        name: "Crocetta del Montello",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01103026",
        name: "Crodo",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "13067023",
        name: "Crognaleto",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "18078046",
        name: "Cropalati",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18079036",
        name: "Cropani",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18078047",
        name: "Crosia",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03012057",
        name: "Crosio della Valle",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "18101010",
        name: "Crotone",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "03019038",
        name: "Crotta d'Adda",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01002052",
        name: "Crova",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "04022068",
        name: "Croviana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18101011",
        name: "Crucoli",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "03012058",
        name: "Cuasso al Monte",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "15065049",
        name: "Cuccaro Vetere",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03013084",
        name: "Cucciago",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01001096",
        name: "Cuceglio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03015096",
        name: "Cuggiono",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03012059",
        name: "Cugliate-Fabiasco",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "20095019",
        name: "Cuglieri",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "13068017",
        name: "Cugnoli",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "01001097",
        name: "Cumiana",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03019039",
        name: "Cumignano sul Naviglio",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03012060",
        name: "Cunardo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01004078",
        name: "Cuneo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01005051",
        name: "Cunico",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001098",
        name: "Cuorgnè",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "13069028",
        name: "Cupello",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "11044017",
        name: "Cupra Marittima",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "11042016",
        name: "Cupramontana",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "03018060",
        name: "Cura Carpignano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "20095077",
        name: "Curcuris",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01003058",
        name: "Cureggio",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03012061",
        name: "Curiglia con Monteviasco",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "18079039",
        name: "Curinga",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "01096023",
        name: "Curino",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03016089",
        name: "Curno",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04021027",
        name: "Curon Venosta",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "16075025",
        name: "Cursi",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "05028036",
        name: "Curtarolo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03020021",
        name: "Curtatone",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "15061032",
        name: "Curti",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03015097",
        name: "Cusago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03015098",
        name: "Cusano Milanino",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "15062026",
        name: "Cusano Mutri",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03013085",
        name: "Cusino",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016090",
        name: "Cusio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19081007",
        name: "Custonaci",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "18101012",
        name: "Cutro",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "16075026",
        name: "Cutrofiano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03012062",
        name: "Cuveglio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012063",
        name: "Cuvio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03015099",
        name: "Dairago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03016091",
        name: "Dalmine",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04022071",
        name: "Dambel",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05025017",
        name: "Danta di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03017065",
        name: "Darfo Boario Terme",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "18102007",
        name: "Dasà",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "07010021",
        name: "Davagna",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03012064",
        name: "Daverio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "18079042",
        name: "Davoli",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "03014025",
        name: "Dazio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "20092015",
        name: "Decimomannu",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "20111013",
        name: "Decimoputzu",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "18079043",
        name: "Decollatura",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "07009027",
        name: "Dego",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "07011012",
        name: "Deiva Marina",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "03014026",
        name: "Delebio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "19085006",
        name: "Delia",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "18080031",
        name: "Delianuova",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "16071022",
        name: "Deliceto",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03017066",
        name: "Dello",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01004079",
        name: "Demonte",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01006065",
        name: "Denice",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "04022074",
        name: "Denno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01006066",
        name: "Dernice",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03019040",
        name: "Derovere",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "10054017",
        name: "Deruta",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03097030",
        name: "Dervio",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01002054",
        name: "Desana",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03017067",
        name: "Desenzano del Garda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03108023",
        name: "Desio",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "20091016",
        name: "Desulo",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "18078048",
        name: "Diamante",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "07008025",
        name: "Diano Arentino",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "07008026",
        name: "Diano Castello",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01004080",
        name: "Diano d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "07008027",
        name: "Diano Marina",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "07008028",
        name: "Diano San Pietro",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "09048013",
        name: "Dicomano",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "06030032",
        name: "Dignano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04022233",
        name: "Dimaro Folgarida",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18102008",
        name: "Dinami",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "18078049",
        name: "Dipignano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "16075027",
        name: "Diso",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01003060",
        name: "Divignano",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03013087",
        name: "Dizzasco",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04021028",
        name: "Dobbiaco",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06031003",
        name: "Doberdò del Lago",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01004081",
        name: "Dogliani",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13069029",
        name: "Dogliola",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "06030033",
        name: "Dogna",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05023031",
        name: "Dolcè",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "07008029",
        name: "Dolceacqua",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "07008030",
        name: "Dolcedo",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "06031004",
        name: "Dolegna del Collio",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20111014",
        name: "Dolianova",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "05027012",
        name: "Dolo",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "03097031",
        name: "Dolzago",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "18078050",
        name: "Domanico",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03013089",
        name: "Domaso",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05025018",
        name: "Domegge di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "15064031",
        name: "Domicella",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01103028",
        name: "Domodossola",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "20111015",
        name: "Domus de Maria",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111016",
        name: "Domusnovas",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01096024",
        name: "Donato",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03013090",
        name: "Dongo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "02007023",
        name: "Donnas",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "20111017",
        name: "Donori",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20091017",
        name: "Dorgali",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03097032",
        name: "Dorio",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01003062",
        name: "Dormelletto",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03018061",
        name: "Dorno",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01096025",
        name: "Dorzano",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03020022",
        name: "Dosolo",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03016092",
        name: "Dossena",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013092",
        name: "Dosso del Liro",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "02007024",
        name: "Doues",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "08040011",
        name: "Dovadola",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "03019041",
        name: "Dovera",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "08037025",
        name: "Dozza",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "15061033",
        name: "Dragoni",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "18102009",
        name: "Drapia",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "04022078",
        name: "Drena",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06030034",
        name: "Drenchia",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03015101",
        name: "Dresano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "04022079",
        name: "Dro",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004082",
        name: "Dronero",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001099",
        name: "Druento",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01103029",
        name: "Druogno",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "20091018",
        name: "Dualchi",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03014027",
        name: "Dubino",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "05028106",
        name: "Due Carrare",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05024038",
        name: "Dueville",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "15062027",
        name: "Dugenta",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "06032001",
        name: "Duino Aurisina",
        districtInitials: "TS",
        district: "Trieste",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03012065",
        name: "Dumenza",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012066",
        name: "Duno",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "15062028",
        name: "Durazzano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "14070022",
        name: "Duronia",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01005052",
        name: "Dusino San Michele",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "15065050",
        name: "Eboli",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03017068",
        name: "Edolo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04021029",
        name: "Egna",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "13068018",
        name: "Elice",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "20091019",
        name: "Elini",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03097033",
        name: "Ello",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "20092108",
        name: "Elmas",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "01004083",
        name: "Elva",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "02007025",
        name: "Emarèse",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "09048014",
        name: "Empoli",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "03016093",
        name: "Endine Gaiano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05024039",
        name: "Enego",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "06030035",
        name: "Enemonzo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19086009",
        name: "Enna",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "01004084",
        name: "Entracque",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03016094",
        name: "Entratico",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01004085",
        name: "Envie",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "17076030",
        name: "Episcopia",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "05027013",
        name: "Eraclea",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "03013095",
        name: "Erba",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05023032",
        name: "Erbè",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "05023033",
        name: "Erbezzo",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03017069",
        name: "Erbusco",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "16074006",
        name: "Erchie",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "15063064",
        name: "Ercolano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "19081008",
        name: "Erice",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "07009028",
        name: "Erli",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "06093019",
        name: "Erto e Casso",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20090088",
        name: "Erula",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03097034",
        name: "Erve",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "11043016",
        name: "Esanatoglia",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "20111018",
        name: "Escalaplano",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111019",
        name: "Escolca",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03017070",
        name: "Esine",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03097035",
        name: "Esino Lario",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "12060031",
        name: "Esperia",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "20090028",
        name: "Esporlatu",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "05028037",
        name: "Este",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "20111020",
        name: "Esterzili",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "02007026",
        name: "Etroubles",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03013097",
        name: "Eupilio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01001100",
        name: "Exilles",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01006067",
        name: "Fabbrica Curone",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "09046036",
        name: "Fabbriche di Vergemoli",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "08035021",
        name: "Fabbrico",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "11042017",
        name: "Fabriano",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "12056024",
        name: "Fabrica di Roma",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "18102010",
        name: "Fabrizia",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "10055011",
        name: "Fabro",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "06030036",
        name: "Faedis",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03014028",
        name: "Faedo Valtellino",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "08039010",
        name: "Faenza",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "16071023",
        name: "Faeto",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "06030037",
        name: "Fagagna",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03013098",
        name: "Faggeto Lario",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "16073005",
        name: "Faggiano",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "13066042",
        name: "Fagnano Alto",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "18078051",
        name: "Fagnano Castello",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03012067",
        name: "Fagnano Olona",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "04022081",
        name: "Fai della Paganella",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15062029",
        name: "Faicchio",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "05025019",
        name: "Falcade",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "15061101",
        name: "Falciano del Massico",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "18078052",
        name: "Falconara Albanese",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "11042018",
        name: "Falconara Marittima",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "19083019",
        name: "Falcone",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "12056025",
        name: "Faleria",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "18079047",
        name: "Falerna",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "11109005",
        name: "Falerone",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "13069104",
        name: "Fallo",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "03013099",
        name: "Faloppio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "12060032",
        name: "Falvaterra",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "04021030",
        name: "Falzes",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08036011",
        name: "Fanano",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "06093020",
        name: "Fanna",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "11041013",
        name: "Fano",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "13067024",
        name: "Fano Adriano",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "13069030",
        name: "Fara Filiorum Petri",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "03016096",
        name: "Fara Gera d'Adda",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12057027",
        name: "Fara in Sabina",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "01003065",
        name: "Fara Novarese",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03016097",
        name: "Fara Olivana con Sola",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "13069031",
        name: "Fara San Martino",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "05024040",
        name: "Fara Vicentino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "17076031",
        name: "Fardella",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "01004086",
        name: "Farigliano",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13068019",
        name: "Farindola",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "08033019",
        name: "Farini",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "12056026",
        name: "Farnese",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "06031005",
        name: "Farra d'Isonzo",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05026026",
        name: "Farra di Soligo",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "16074007",
        name: "Fasano",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "07010022",
        name: "Fascia",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "09050014",
        name: "Fauglia",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01004087",
        name: "Faule",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "07010023",
        name: "Favale di Malvaro",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "19084017",
        name: "Favara",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "19081009",
        name: "Favignana",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "01001101",
        name: "Favria",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004088",
        name: "Feisoglio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001102",
        name: "Feletto",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08034013",
        name: "Felino",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "15065051",
        name: "Felitto",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01006068",
        name: "Felizzano",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05025021",
        name: "Feltre",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03013100",
        name: "Fenegrò",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01001103",
        name: "Fenestrelle",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "02007027",
        name: "Fénis",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "10055012",
        name: "Ferentillo",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "12060033",
        name: "Ferentino",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "19089008",
        name: "Ferla",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "11041014",
        name: "Fermignano",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11109006",
        name: "Fermo",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "03012068",
        name: "Ferno",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "18079048",
        name: "Feroleto Antico",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18080032",
        name: "Feroleto della Chiesa",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "17077008",
        name: "Ferrandina",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "08038008",
        name: "Ferrara",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "05023034",
        name: "Ferrara di Monte Baldo",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "14070023",
        name: "Ferrazzano",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03012069",
        name: "Ferrera di Varese",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03018062",
        name: "Ferrera Erbognone",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01005053",
        name: "Ferrere",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "08033020",
        name: "Ferriere",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "18080033",
        name: "Ferruzzano",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "12057028",
        name: "Fiamignano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "01001104",
        name: "Fiano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12058036",
        name: "Fiano Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "11043017",
        name: "Fiastra",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "04022083",
        name: "Fiavè",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "19082035",
        name: "Ficarazzi",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "05029021",
        name: "Ficarolo",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "19083020",
        name: "Ficarra",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "10055013",
        name: "Ficulle",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "08034014",
        name: "Fidenza",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "04021031",
        name: "Fiè allo Sciliar",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022085",
        name: "Fierozzo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03019043",
        name: "Fiesco",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "09048015",
        name: "Fiesole",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "03017071",
        name: "Fiesse",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05027014",
        name: "Fiesso d'Artico",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "05029022",
        name: "Fiesso Umbertiano",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "03013101",
        name: "Figino Serenza",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "09048052",
        name: "Figline e Incisa Valdarno",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "18078053",
        name: "Figline Vegliaturo",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12058037",
        name: "Filacciano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "18102011",
        name: "Filadelfia",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "03016098",
        name: "Filago",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "18102012",
        name: "Filandari",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "09045006",
        name: "Filattiera",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "12060034",
        name: "Filettino",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "13069032",
        name: "Filetto",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "17076032",
        name: "Filiano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03018063",
        name: "Filighera",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "14094019",
        name: "Filignano",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "18102013",
        name: "Filogaso",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "11042019",
        name: "Filottrano",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "08036012",
        name: "Finale Emilia",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "07009029",
        name: "Finale Ligure",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03016099",
        name: "Fino del Monte",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013102",
        name: "Fino Mornasco",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016100",
        name: "Fiorano al Serio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001105",
        name: "Fiorano Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08036013",
        name: "Fiorano Modenese",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "08033021",
        name: "Fiorenzuola d'Arda",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "09048017",
        name: "Firenze",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "09048018",
        name: "Firenzuola",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "18078054",
        name: "Firmo",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "08038027",
        name: "Fiscaglia",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "15065052",
        name: "Fisciano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "12060035",
        name: "Fiuggi",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "08036014",
        name: "Fiumalbo",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "18080034",
        name: "Fiumara",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "06093021",
        name: "Fiume Veneto",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19083021",
        name: "Fiumedinisi",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "18078055",
        name: "Fiumefreddo Bruzio",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19087016",
        name: "Fiumefreddo di Sicilia",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "06030190",
        name: "Fiumicello Villa Vicentina",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12058120",
        name: "Fiumicino",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "11043019",
        name: "Fiuminata",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "09045007",
        name: "Fivizzano",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "06030039",
        name: "Flaibano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03017072",
        name: "Flero",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "19083022",
        name: "Floresta",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19089009",
        name: "Floridia",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "20090029",
        name: "Florinas",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "15064032",
        name: "Flumeri",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "20111021",
        name: "Fluminimaggiore",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20095080",
        name: "Flussio",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01002057",
        name: "Fobello",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "16071024",
        name: "Foggia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "15062030",
        name: "Foglianise",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "06031006",
        name: "Fogliano Redipuglia",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001106",
        name: "Foglizzo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "09051018",
        name: "Foiano della Chiana",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "15062031",
        name: "Foiano di Val Fortore",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "04022087",
        name: "Folgaria",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11044020",
        name: "Folignano",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "10054018",
        name: "Foligno",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "05026027",
        name: "Follina",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "07011013",
        name: "Follo",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "09053009",
        name: "Follonica",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "03098026",
        name: "Fombio",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "19083023",
        name: "Fondachelli-Fantina",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "12059007",
        name: "Fondi",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "20091024",
        name: "Fonni",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "02007028",
        name: "Fontainemore",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "12060036",
        name: "Fontana Liri",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "06093022",
        name: "Fontanafredda",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15064033",
        name: "Fontanarosa",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "08037026",
        name: "Fontanelice",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03016101",
        name: "Fontanella",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08034015",
        name: "Fontanellato",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "05026028",
        name: "Fontanelle",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01003066",
        name: "Fontaneto d'Agogna",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01002058",
        name: "Fontanetto Po",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "07010024",
        name: "Fontanigorda",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01005054",
        name: "Fontanile",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05028038",
        name: "Fontaniva",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05026029",
        name: "Fonte",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "12058122",
        name: "Fonte Nuova",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "13066043",
        name: "Fontecchio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "12060037",
        name: "Fontechiari",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15061034",
        name: "Fontegreca",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03016102",
        name: "Fonteno",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08034016",
        name: "Fontevivo",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "05025022",
        name: "Fonzaso",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03016103",
        name: "Foppolo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12057029",
        name: "Forano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "11044021",
        name: "Force",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "15062032",
        name: "Forchia",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03014029",
        name: "Forcola",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "20095020",
        name: "Fordongianus",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "17076033",
        name: "Forenza",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03016104",
        name: "Foresto Sparso",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "06030137",
        name: "Forgaria nel Friuli",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15064034",
        name: "Forino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15063031",
        name: "Forio",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "08040012",
        name: "Forlì",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "14094020",
        name: "Forlì del Sannio",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "08040013",
        name: "Forlimpopoli",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "01103031",
        name: "Formazza",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "12058038",
        name: "Formello",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "12059008",
        name: "Formia",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "15061035",
        name: "Formicola",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03019044",
        name: "Formigara",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "08036015",
        name: "Formigine",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "01002059",
        name: "Formigliana",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "04022089",
        name: "Fornace",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "14094021",
        name: "Fornelli",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "06030040",
        name: "Forni Avoltri",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06030041",
        name: "Forni di Sopra",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06030042",
        name: "Forni di Sotto",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001107",
        name: "Forno Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08034017",
        name: "Fornovo di Taro",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "03016105",
        name: "Fornovo San Giovanni",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "09046013",
        name: "Forte dei Marmi",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "04021032",
        name: "Fortezza",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03018064",
        name: "Fortunago",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19083024",
        name: "Forza d'Agrò",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "09046014",
        name: "Fosciandora",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "09045008",
        name: "Fosdinovo",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "13066044",
        name: "Fossa",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "13069033",
        name: "Fossacesia",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "05027015",
        name: "Fossalta di Piave",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "05027016",
        name: "Fossalta di Portogruaro",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "14070024",
        name: "Fossalto",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01004089",
        name: "Fossano",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "10054019",
        name: "Fossato di Vico",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "18079052",
        name: "Fossato Serralta",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "05027017",
        name: "Fossò",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "11041015",
        name: "Fossombrone",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "05024041",
        name: "Foza",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01004090",
        name: "Frabosa Soprana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004091",
        name: "Frabosa Sottana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01006069",
        name: "Fraconalto",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16073006",
        name: "Fragagnano",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "15062033",
        name: "Fragneto l'Abate",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15062034",
        name: "Fragneto Monforte",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "13069034",
        name: "Fraine",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "07011014",
        name: "Framura",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "13069035",
        name: "Francavilla al Mare",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "18102014",
        name: "Francavilla Angitola",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "01006070",
        name: "Francavilla Bisio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "11109007",
        name: "Francavilla d'Ete",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "19083025",
        name: "Francavilla di Sicilia",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "16074008",
        name: "Francavilla Fontana",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "17076034",
        name: "Francavilla in Sinni",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "18078056",
        name: "Francavilla Marittima",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18102015",
        name: "Francica",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "19089010",
        name: "Francofonte",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "15061036",
        name: "Francolise",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01006071",
        name: "Frascaro",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018065",
        name: "Frascarolo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "12058039",
        name: "Frascati",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "18078057",
        name: "Frascineto",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "04022090",
        name: "Frassilongo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05029023",
        name: "Frassinelle Polesine",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01006072",
        name: "Frassinello Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01006073",
        name: "Frassineto Po",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01001108",
        name: "Frassinetto",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004092",
        name: "Frassino",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08036016",
        name: "Frassinoro",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "12057030",
        name: "Frasso Sabino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "15062035",
        name: "Frasso Telesino",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "05029024",
        name: "Fratta Polesine",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "10054020",
        name: "Fratta Todina",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "15063032",
        name: "Frattamaggiore",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15063033",
        name: "Frattaminore",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "11041016",
        name: "Fratte Rosa",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "19083026",
        name: "Frazzanò",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "05026030",
        name: "Fregona",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "13069036",
        name: "Fresagrandinaria",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01006074",
        name: "Fresonara",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15064035",
        name: "Frigento",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15061037",
        name: "Frignano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01005055",
        name: "Frinco",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "13069037",
        name: "Frisa",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "06093024",
        name: "Frisanco",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001109",
        name: "Front",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "11041017",
        name: "Frontino",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11041018",
        name: "Frontone",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "12060038",
        name: "Frosinone",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "14094022",
        name: "Frosolone",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "01001110",
        name: "Frossasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01006075",
        name: "Frugarolo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01006076",
        name: "Fubine Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "09048019",
        name: "Fucecchio",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "03016106",
        name: "Fuipiano Valle Imagna",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05023035",
        name: "Fumane",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "12060039",
        name: "Fumone",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "04021033",
        name: "Funes",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "13069038",
        name: "Furci",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "19083027",
        name: "Furci Siculo",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19083028",
        name: "Furnari",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "15065053",
        name: "Furore",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "20111022",
        name: "Furtei",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "18078058",
        name: "Fuscaldo",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "08039011",
        name: "Fusignano",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "03014030",
        name: "Fusine",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "15065054",
        name: "Futani",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03019045",
        name: "Gabbioneta-Binanuova",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01006077",
        name: "Gabiano",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "11041019",
        name: "Gabicce Mare",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "02007029",
        name: "Gaby",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03019046",
        name: "Gadesco-Pieve Delmona",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "20091025",
        name: "Gadoni",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "12059009",
        name: "Gaeta",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "19083029",
        name: "Gaggi",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03015103",
        name: "Gaggiano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "08037027",
        name: "Gaggio Montano",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "01096026",
        name: "Gaglianico",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "13066045",
        name: "Gagliano Aterno",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "19086010",
        name: "Gagliano Castelferrato",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "16075028",
        name: "Gagliano del Capo",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "18079055",
        name: "Gagliato",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "11043020",
        name: "Gagliole",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "05026031",
        name: "Gaiarine",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "05029025",
        name: "Gaiba",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01004093",
        name: "Gaiola",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "09052013",
        name: "Gaiole in Chianti",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "20091026",
        name: "Gairo",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "04021034",
        name: "Gais",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "19083030",
        name: "Galati Mamertino",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "16075029",
        name: "Galatina",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "16075030",
        name: "Galatone",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "18080035",
        name: "Galatro",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03097036",
        name: "Galbiate",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "08040014",
        name: "Galeata",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "03098027",
        name: "Galgagnano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03012070",
        name: "Gallarate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "12056027",
        name: "Gallese",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "01003068",
        name: "Galliate",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03012071",
        name: "Galliate Lombardo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03018066",
        name: "Galliavola",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "09046015",
        name: "Gallicano",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "12058040",
        name: "Gallicano nel Lazio",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "17076035",
        name: "Gallicchio",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "08037028",
        name: "Galliera",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "05028039",
        name: "Galliera Veneta",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "12060040",
        name: "Gallinaro",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "05024042",
        name: "Gallio",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "16075031",
        name: "Gallipoli",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "15061038",
        name: "Gallo Matese",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "19083031",
        name: "Gallodoro",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "15061039",
        name: "Galluccio",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "20091027",
        name: "Galtellì",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "05028040",
        name: "Galzignano Terme",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01006078",
        name: "Gamalero",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03017073",
        name: "Gambara",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03018067",
        name: "Gambarana",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01004094",
        name: "Gambasca",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "09048020",
        name: "Gambassi Terme",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "14070025",
        name: "Gambatesa",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "05024043",
        name: "Gambellara",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "13069039",
        name: "Gamberale",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "08040015",
        name: "Gambettola",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "03018068",
        name: "Gambolò",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05024044",
        name: "Gambugliano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03016107",
        name: "Gandellino",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016108",
        name: "Gandino",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016109",
        name: "Gandosso",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19082036",
        name: "Gangi",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "17077009",
        name: "Garaguso",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "01006079",
        name: "Garbagna",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01003069",
        name: "Garbagna Novarese",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03015105",
        name: "Garbagnate Milanese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03097037",
        name: "Garbagnate Monastero",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "05023036",
        name: "Garda",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03017074",
        name: "Gardone Riviera",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017075",
        name: "Gardone Val Trompia",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01004095",
        name: "Garessio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01003070",
        name: "Gargallo",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "04021035",
        name: "Gargazzone",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03017076",
        name: "Gargnano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03018069",
        name: "Garlasco",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03097038",
        name: "Garlate",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "07009030",
        name: "Garlenda",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "04022091",
        name: "Garniga Terme",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03013106",
        name: "Garzeno",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01001111",
        name: "Garzigliana",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18079056",
        name: "Gasperina",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "01001112",
        name: "Gassino Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08035022",
        name: "Gattatico",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "08040016",
        name: "Gatteo",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "01003166",
        name: "Gattico-Veruno",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01002061",
        name: "Gattinara",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03017077",
        name: "Gavardo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05029026",
        name: "Gavello",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "03016110",
        name: "Gaverina Terme",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01006081",
        name: "Gavi",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "12058041",
        name: "Gavignano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03012072",
        name: "Gavirate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "20091028",
        name: "Gavoi",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "09053010",
        name: "Gavorrano",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "03020024",
        name: "Gazoldo degli Ippoliti",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03012073",
        name: "Gazzada Schianno",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03016111",
        name: "Gazzaniga",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05028041",
        name: "Gazzo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05023037",
        name: "Gazzo Veronese",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "08033022",
        name: "Gazzola",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03020025",
        name: "Gazzuolo",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "19085007",
        name: "Gela",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "08099004",
        name: "Gemmano",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "06030043",
        name: "Gemona del Friuli",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03012074",
        name: "Gemonio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "12058042",
        name: "Genazzano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "11042020",
        name: "Genga",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "03019047",
        name: "Genivolta",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01004096",
        name: "Genola",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20111023",
        name: "Genoni",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "07010025",
        name: "Genova",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "20111024",
        name: "Genuri",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "17076036",
        name: "Genzano di Lucania",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "12058043",
        name: "Genzano di Roma",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03013107",
        name: "Gera Lario",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "18080036",
        name: "Gerace",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19082037",
        name: "Geraci Siculo",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "12058044",
        name: "Gerano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03018071",
        name: "Gerenzago",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03012075",
        name: "Gerenzano",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "20111025",
        name: "Gergei",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01001113",
        name: "Germagnano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01103032",
        name: "Germagno",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03012076",
        name: "Germignaga",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "18102016",
        name: "Gerocarne",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "03014031",
        name: "Gerola Alta",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03019048",
        name: "Gerre de' Caprioli",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "20111026",
        name: "Gesico",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03015106",
        name: "Gessate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "13069040",
        name: "Gessopalena",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "20111027",
        name: "Gesturi",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "15064036",
        name: "Gesualdo",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03017078",
        name: "Ghedi",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01003073",
        name: "Ghemme",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01103033",
        name: "Ghiffa",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "20095021",
        name: "Ghilarza",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "03016113",
        name: "Ghisalba",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01002062",
        name: "Ghislarengo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "05029027",
        name: "Giacciano con Baruchella",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01001114",
        name: "Giaglione",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03017079",
        name: "Gianico",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "10054021",
        name: "Giano dell'Umbria",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "15061040",
        name: "Giano Vetusto",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "19082038",
        name: "Giardinello",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "19083032",
        name: "Giardini-Naxos",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01006082",
        name: "Giarole",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "19088004",
        name: "Giarratana",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "19087017",
        name: "Giarre",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "20090030",
        name: "Giave",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01001115",
        name: "Giaveno",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05026032",
        name: "Giavera del Montello",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "20111028",
        name: "Giba",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "19081010",
        name: "Gibellina",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "01096027",
        name: "Gifflenga",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "18080037",
        name: "Giffone",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "15065055",
        name: "Giffoni Sei Casali",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15065056",
        name: "Giffoni Valle Piana",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01103034",
        name: "Gignese",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "02007030",
        name: "Gignod",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "14070026",
        name: "Gildone",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "18079058",
        name: "Gimigliano",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "17076099",
        name: "Ginestra",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15062036",
        name: "Ginestra degli Schiavoni",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "16073007",
        name: "Ginosa",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "15065057",
        name: "Gioi",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13066046",
        name: "Gioia dei Marsi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "16072021",
        name: "Gioia del Colle",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15061041",
        name: "Gioia Sannitica",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "18080038",
        name: "Gioia Tauro",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18080039",
        name: "Gioiosa Ionica",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19083033",
        name: "Gioiosa Marea",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "10055014",
        name: "Giove",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "16072022",
        name: "Giovinazzo",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "04022092",
        name: "Giovo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20091031",
        name: "Girasole",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "18079059",
        name: "Girifalco",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "13069041",
        name: "Gissi",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "16075032",
        name: "Giuggianello",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "15063034",
        name: "Giugliano in Campania",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "19082039",
        name: "Giuliana",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "12060041",
        name: "Giuliano di Roma",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "13069042",
        name: "Giuliano Teatino",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13067025",
        name: "Giulianova",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "15065058",
        name: "Giungano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "16075033",
        name: "Giurdignano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03018072",
        name: "Giussago",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03108024",
        name: "Giussano",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "07009031",
        name: "Giustenice",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "04022093",
        name: "Giustino",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07009032",
        name: "Giusvalla",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01001116",
        name: "Givoletto",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18079060",
        name: "Gizzeria",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "04021036",
        name: "Glorenza",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05026033",
        name: "Godega di Sant'Urbano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03018073",
        name: "Godiasco Salice Terme",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19082040",
        name: "Godrano",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03020026",
        name: "Goito",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03012077",
        name: "Golasecca",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03018074",
        name: "Golferenzo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "20090083",
        name: "Golfo Aranci",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03019049",
        name: "Gombito",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "06030044",
        name: "Gonars",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20111029",
        name: "Goni",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111030",
        name: "Gonnesa",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20095022",
        name: "Gonnoscodina",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20111031",
        name: "Gonnosfanadiga",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20095023",
        name: "Gonnosnò",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20095024",
        name: "Gonnostramatza",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "03020027",
        name: "Gonzaga",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03014032",
        name: "Gordona",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "12058045",
        name: "Gorga",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05026034",
        name: "Gorgo al Monticano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "17077010",
        name: "Gorgoglione",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "03015108",
        name: "Gorgonzola",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "13066047",
        name: "Goriano Sicoli",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "06031007",
        name: "Gorizia",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03012078",
        name: "Gorla Maggiore",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012079",
        name: "Gorla Minore",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03016114",
        name: "Gorlago",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016115",
        name: "Gorle",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03012080",
        name: "Gornate Olona",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03016116",
        name: "Gorno",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08038025",
        name: "Goro",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "07010026",
        name: "Gorreto",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01004097",
        name: "Gorzegno",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05025025",
        name: "Gosaldo",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "08033023",
        name: "Gossolengo",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "01004098",
        name: "Gottasecca",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017080",
        name: "Gottolengo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01004099",
        name: "Govone",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01003076",
        name: "Gozzano",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "11041020",
        name: "Gradara",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "06031008",
        name: "Gradisca d'Isonzo",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06031009",
        name: "Grado",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12056028",
        name: "Gradoli",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03098028",
        name: "Graffignana",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "12056029",
        name: "Graffignano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "01096028",
        name: "Graglia",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "15063035",
        name: "Gragnano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "08033024",
        name: "Gragnano Trebbiense",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "19087018",
        name: "Grammichele",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "01005056",
        name: "Grana",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "08037030",
        name: "Granarolo dell'Emilia",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03013110",
        name: "Grandate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03013111",
        name: "Grandola ed Uniti",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "19083034",
        name: "Graniti",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01003077",
        name: "Granozzo con Monticello",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03012081",
        name: "Grantola",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05028042",
        name: "Grantorto",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05028043",
        name: "Granze",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "17077011",
        name: "Grassano",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "03016117",
        name: "Grassobbio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19082041",
        name: "Gratteri",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03013249",
        name: "Gravedona ed Uniti",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03018075",
        name: "Gravellona Lomellina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01103035",
        name: "Gravellona Toce",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01001117",
        name: "Gravere",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19087019",
        name: "Gravina di Catania",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "16072023",
        name: "Gravina in Puglia",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15061042",
        name: "Grazzanise",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01005057",
        name: "Grazzano Badoglio",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "12057031",
        name: "Greccio",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "15064037",
        name: "Greci",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01002065",
        name: "Greggio",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01006083",
        name: "Gremiasco",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "02007031",
        name: "Gressan",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007032",
        name: "Gressoney-La-Trinité",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007033",
        name: "Gressoney-Saint-Jean",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "09048021",
        name: "Greve in Chianti",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "03015110",
        name: "Grezzago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05023038",
        name: "Grezzana",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03013113",
        name: "Griante",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "15061043",
        name: "Gricignano di Aversa",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01003079",
        name: "Grignasco",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "04022095",
        name: "Grigno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06030045",
        name: "Grimacco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "18078059",
        name: "Grimaldi",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01004100",
        name: "Grinzane Cavour",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05024046",
        name: "Grisignano di Zocco",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "18078060",
        name: "Grisolia",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "08037031",
        name: "Grizzana Morandi",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "01006084",
        name: "Grognardo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03016118",
        name: "Gromo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01006085",
        name: "Grondona",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03016119",
        name: "Grone",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03019050",
        name: "Grontardo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03018076",
        name: "Gropello Cairoli",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "08033025",
        name: "Gropparello",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "01001118",
        name: "Groscavallo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03014033",
        name: "Grosio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03014034",
        name: "Grosotto",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "09053011",
        name: "Grosseto",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "01001119",
        name: "Grosso",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12058046",
        name: "Grottaferrata",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "16073008",
        name: "Grottaglie",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "15064038",
        name: "Grottaminarda",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "11044023",
        name: "Grottammare",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "11109008",
        name: "Grottazzolina",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "19084018",
        name: "Grotte",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "12056030",
        name: "Grotte di Castro",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "18080040",
        name: "Grotteria",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "17077012",
        name: "Grottole",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "15064039",
        name: "Grottolella",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "05027018",
        name: "Gruaro",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "01001120",
        name: "Grugliasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03019051",
        name: "Grumello Cremonese ed Uniti",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03016120",
        name: "Grumello del Monte",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "17076037",
        name: "Grumento Nova",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "16072024",
        name: "Grumo Appula",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15063036",
        name: "Grumo Nevano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "05024047",
        name: "Grumolo delle Abbadesse",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "16075034",
        name: "Guagnano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "11043021",
        name: "Gualdo",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "10054022",
        name: "Gualdo Cattaneo",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "10054023",
        name: "Gualdo Tadino",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "08035023",
        name: "Gualtieri",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "19083035",
        name: "Gualtieri Sicaminò",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "20111032",
        name: "Guamaggiore",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03013114",
        name: "Guanzate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "12060042",
        name: "Guarcino",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "05029028",
        name: "Guarda Veneta",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01002066",
        name: "Guardabosone",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03098029",
        name: "Guardamiglio",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "18079061",
        name: "Guardavalle",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "10055015",
        name: "Guardea",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "15064040",
        name: "Guardia Lombardi",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "17076038",
        name: "Guardia Perticara",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "18078061",
        name: "Guardia Piemontese",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15062037",
        name: "Guardia Sanframondi",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "13069043",
        name: "Guardiagrele",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "14070027",
        name: "Guardialfiera",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "14070028",
        name: "Guardiaregia",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "09050015",
        name: "Guardistallo",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01004101",
        name: "Guarene",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20111033",
        name: "Guasila",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "08035024",
        name: "Guastalla",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "01006086",
        name: "Guazzora",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "10054024",
        name: "Gubbio",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03015112",
        name: "Gudo Visconti",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "14070029",
        name: "Guglionesi",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03020028",
        name: "Guidizzolo",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "12058047",
        name: "Guidonia Montecelio",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "08036017",
        name: "Guiglia",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "13069044",
        name: "Guilmi",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01103036",
        name: "Gurro",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "20111034",
        name: "Guspini",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03017081",
        name: "Gussago",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03019052",
        name: "Gussola",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "02007034",
        name: "Hône",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03017082",
        name: "Idro",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20111035",
        name: "Iglesias",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01004102",
        name: "Igliano",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20091032",
        name: "Ilbono",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "05023039",
        name: "Illasi",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "20090031",
        name: "Illorai",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03097039",
        name: "Imbersago",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "04022097",
        name: "Imer",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08037032",
        name: "Imola",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "07008031",
        name: "Imperia",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "09048022",
        name: "Impruneta",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "03012082",
        name: "Inarzo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01005058",
        name: "Incisa Scapaccino",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03017083",
        name: "Incudine",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03012083",
        name: "Induno Olona",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01001121",
        name: "Ingria",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01103037",
        name: "Intragna",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03097040",
        name: "Introbio",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "02007035",
        name: "Introd",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "13066048",
        name: "Introdacqua",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03013118",
        name: "Inverigo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03018077",
        name: "Inverno e Monteleone",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001122",
        name: "Inverso Pinasca",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03015113",
        name: "Inveruno",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01003082",
        name: "Invorio",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03015114",
        name: "Inzago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "18102017",
        name: "Ionadi",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "20091033",
        name: "Irgoli",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03017084",
        name: "Irma",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "17077013",
        name: "Irsina",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "01004103",
        name: "Isasca",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18079063",
        name: "Isca sullo Ionio",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "15063037",
        name: "Ischia",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "12056031",
        name: "Ischia di Castro",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "16071025",
        name: "Ischitella",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03017085",
        name: "Iseo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04022098",
        name: "Isera",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "14094023",
        name: "Isernia",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "20111036",
        name: "Isili",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "19082042",
        name: "Isnello",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "01005059",
        name: "Isola d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "07010027",
        name: "Isola del Cantone",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "09053012",
        name: "Isola del Giglio",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "13067026",
        name: "Isola del Gran Sasso d'Italia",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "12060043",
        name: "Isola del Liri",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "11041021",
        name: "Isola del Piano",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "05023040",
        name: "Isola della Scala",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "19082043",
        name: "Isola delle Femmine",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "18101013",
        name: "Isola di Capo Rizzuto",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "03016121",
        name: "Isola di Fondra",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03019053",
        name: "Isola Dovarese",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05023041",
        name: "Isola Rizza",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01006087",
        name: "Isola Sant'Antonio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05024048",
        name: "Isola Vicentina",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01001123",
        name: "Isolabella",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07008032",
        name: "Isolabona",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "16071026",
        name: "Isole Tremiti",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03017086",
        name: "Isorella",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15065059",
        name: "Ispani",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19088005",
        name: "Ispica",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "03012084",
        name: "Ispra",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01001124",
        name: "Issiglio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "02007036",
        name: "Issime",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03016122",
        name: "Isso",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "02007037",
        name: "Issogne",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "05026035",
        name: "Istrana",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "19083036",
        name: "Itala",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "12059010",
        name: "Itri",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "20090032",
        name: "Ittireddu",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20090033",
        name: "Ittiri",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01001125",
        name: "Ivrea",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03019054",
        name: "Izano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18079065",
        name: "Jacurso",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "14070030",
        name: "Jelsi",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "12058048",
        name: "Jenne",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03012085",
        name: "Jerago con Orago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "20091035",
        name: "Jerzu",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "11042021",
        name: "Jesi",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "05027019",
        name: "Jesolo",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "08038010",
        name: "Jolanda di Savoia",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "18102018",
        name: "Joppolo",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "19084019",
        name: "Joppolo Giancaxio",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "02007038",
        name: "Jovençan",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "13066049",
        name: "L'Aquila",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "01001126",
        name: "La Cassa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001127",
        name: "La Loggia",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20090035",
        name: "La Maddalena",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "02007039",
        name: "La Magdeleine",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "01004105",
        name: "La Morra",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "02007040",
        name: "La Salle",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "07011015",
        name: "La Spezia",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "02007041",
        name: "La Thuile",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "04021117",
        name: "La Valle",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05025027",
        name: "La Valle Agordina",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03097092",
        name: "La Valletta Brianza",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "12058049",
        name: "Labico",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "12057032",
        name: "Labro",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03015115",
        name: "Lacchiarella",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "15063038",
        name: "Lacco Ameno",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15064041",
        name: "Lacedonia",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "04021037",
        name: "Laces",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20095082",
        name: "Laconi",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "12058116",
        name: "Ladispoli",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "20090034",
        name: "Laerru",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "18080041",
        name: "Laganadi",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "05024049",
        name: "Laghi",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03013119",
        name: "Laglio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01004104",
        name: "Lagnasco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18078062",
        name: "Lago",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "17076039",
        name: "Lagonegro",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "08038011",
        name: "Lagosanto",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "04021038",
        name: "Lagundo",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07009033",
        name: "Laigueglia",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03015116",
        name: "Lainate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03013120",
        name: "Laino",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "18078063",
        name: "Laino Borgo",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18078064",
        name: "Laino Castello",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "04021039",
        name: "Laion",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04021040",
        name: "Laives",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "09050016",
        name: "Lajatico",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "03016123",
        name: "Lallio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "13069045",
        name: "Lama dei Peligni",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "08036018",
        name: "Lama Mocogno",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "03013121",
        name: "Lambrugo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "18079160",
        name: "Lamezia Terme",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "05025026",
        name: "Lamon",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "19084020",
        name: "Lampedusa e Linosa",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "09047005",
        name: "Lamporecchio",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "01002067",
        name: "Lamporo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "04021041",
        name: "Lana",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "13069046",
        name: "Lanciano",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01003083",
        name: "Landiona",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03018078",
        name: "Landriano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "08034018",
        name: "Langhirano",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "03018079",
        name: "Langosco",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "20091037",
        name: "Lanusei",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "12058050",
        name: "Lanuvio",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03014036",
        name: "Lanzada",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01001128",
        name: "Lanzo Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "11109009",
        name: "Lapedona",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "15064042",
        name: "Lapio",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18078065",
        name: "Lappano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "09047006",
        name: "Larciano",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "03018080",
        name: "Lardirago",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "12058115",
        name: "Lariano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "14070031",
        name: "Larino",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "20111037",
        name: "Las Plassas",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "04021042",
        name: "Lasa",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "19082044",
        name: "Lascari",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03013123",
        name: "Lasnigo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05024050",
        name: "Lastebasse",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "09048024",
        name: "Lastra a Signa",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "12056032",
        name: "Latera",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "09051042",
        name: "Laterina Pergine Valdarno",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "16073009",
        name: "Laterza",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "16074009",
        name: "Latiano",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "12059011",
        name: "Latina",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "06030046",
        name: "Latisana",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "17076040",
        name: "Latronico",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "18078066",
        name: "Lattarico",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "06030047",
        name: "Lauco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15065060",
        name: "Laureana Cilento",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "18080042",
        name: "Laureana di Borrello",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "04021043",
        name: "Lauregno",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "17076041",
        name: "Laurenzana",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "17076042",
        name: "Lauria",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "01001129",
        name: "Lauriano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15065061",
        name: "Laurino",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15065062",
        name: "Laurito",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15064043",
        name: "Lauro",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "07010028",
        name: "Lavagna",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "05023042",
        name: "Lavagno",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04022102",
        name: "Lavarone",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "17076043",
        name: "Lavello",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03012086",
        name: "Lavena Ponte Tresa",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012087",
        name: "Laveno-Mombello",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03017087",
        name: "Lavenone",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15065063",
        name: "Laviano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "04022103",
        name: "Lavis",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05023043",
        name: "Lazise",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03108025",
        name: "Lazzate",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "16075035",
        name: "Lecce",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "13066050",
        name: "Lecce nei Marsi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03097042",
        name: "Lecco",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "04022229",
        name: "Ledro",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03016124",
        name: "Leffe",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03012088",
        name: "Leggiuno",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05023044",
        name: "Legnago",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03015118",
        name: "Legnano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05028044",
        name: "Legnaro",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "20091038",
        name: "Lei",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "01001130",
        name: "Leini",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07010029",
        name: "Leivi",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01001131",
        name: "Lemie",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05029029",
        name: "Lendinara",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "19083037",
        name: "Leni",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03016125",
        name: "Lenna",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03017088",
        name: "Leno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "12059012",
        name: "Lenola",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "01002068",
        name: "Lenta",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03108054",
        name: "Lentate sul Seveso",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "13069047",
        name: "Lentella",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "19089011",
        name: "Lentini",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "12057033",
        name: "Leonessa",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "19086011",
        name: "Leonforte",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "16073010",
        name: "Leporano",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "16075036",
        name: "Lequile",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01004106",
        name: "Lequio Berria",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004107",
        name: "Lequio Tanaro",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19082045",
        name: "Lercara Friddi",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "07011016",
        name: "Lerici",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "01006088",
        name: "Lerma",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01003084",
        name: "Lesa",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01004108",
        name: "Lesegno",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08034019",
        name: "Lesignano de' Bagni",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "16071027",
        name: "Lesina",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03108026",
        name: "Lesmo",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "01001132",
        name: "Lessolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01096085",
        name: "Lessona",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "06030048",
        name: "Lestizza",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15061044",
        name: "Letino",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "19083038",
        name: "Letojanni",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "15063039",
        name: "Lettere",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "13068020",
        name: "Lettomanoppello",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "13069048",
        name: "Lettopalena",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "07011017",
        name: "Levanto",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "03016126",
        name: "Levate",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "16075037",
        name: "Leverano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01004109",
        name: "Levice",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "04022104",
        name: "Levico Terme",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001133",
        name: "Levone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03013126",
        name: "Lezzeno",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "15061045",
        name: "Liberi",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "19083039",
        name: "Librizzi",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19084021",
        name: "Licata",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "09045009",
        name: "Licciana Nardi",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "12058051",
        name: "Licenza",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "19087020",
        name: "Licodia Eubea",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "03097043",
        name: "Lierna",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01002070",
        name: "Lignana",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "06030049",
        name: "Lignano Sabbiadoro",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "02007042",
        name: "Lillianes",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "05025029",
        name: "Limana",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "15062038",
        name: "Limatola",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "18102019",
        name: "Limbadi",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "03108027",
        name: "Limbiate",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "05028045",
        name: "Limena",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03013128",
        name: "Limido Comasco",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "19083040",
        name: "Limina",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01004110",
        name: "Limone Piemonte",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017089",
        name: "Limone sul Garda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "14070032",
        name: "Limosano",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03018081",
        name: "Linarolo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19087021",
        name: "Linguaglossa",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "15064044",
        name: "Lioni",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "19083041",
        name: "Lipari",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03013129",
        name: "Lipomo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03018082",
        name: "Lirio",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03015122",
        name: "Liscate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "13069049",
        name: "Liscia",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "10054025",
        name: "Lisciano Niccone",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01004111",
        name: "Lisio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03108028",
        name: "Lissone",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "15063040",
        name: "Liveri",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03014037",
        name: "Livigno",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "05025030",
        name: "Livinallongo del Col di Lana",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03013130",
        name: "Livo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04022106",
        name: "Livo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "09049009",
        name: "Livorno",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "01002071",
        name: "Livorno Ferraris",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03098030",
        name: "Livraga",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "16075038",
        name: "Lizzanello",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "16073011",
        name: "Lizzano",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "08037033",
        name: "Lizzano in Belvedere",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "07009034",
        name: "Loano",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01005060",
        name: "Loazzolo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001134",
        name: "Locana",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03015125",
        name: "Locate di Triulzi",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03013131",
        name: "Locate Varesino",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016127",
        name: "Locatello",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "20091039",
        name: "Loceri",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "16072025",
        name: "Locorotondo",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "18080043",
        name: "Locri",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "20091040",
        name: "Loculi",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20091041",
        name: "Lodè",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03098031",
        name: "Lodi",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03098032",
        name: "Lodi Vecchio",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "20091104",
        name: "Lodine",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03017090",
        name: "Lodrino",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017091",
        name: "Lograto",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "08037034",
        name: "Loiano",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "20090084",
        name: "Loiri Porto San Paolo",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03097044",
        name: "Lomagna",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03013133",
        name: "Lomazzo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01001135",
        name: "Lombardore",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001136",
        name: "Lombriasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018083",
        name: "Lomello",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "04022108",
        name: "Lona-Lases",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03012089",
        name: "Lonate Ceppino",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012090",
        name: "Lonate Pozzolo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03017092",
        name: "Lonato del Garda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "09048025",
        name: "Londa",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "14094024",
        name: "Longano",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "05024051",
        name: "Longare",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05025071",
        name: "Longarone",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03017093",
        name: "Longhena",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "19083042",
        name: "Longi",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "08040018",
        name: "Longiano",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "18078067",
        name: "Longobardi",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18078068",
        name: "Longobucco",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03013134",
        name: "Longone al Segrino",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "12057034",
        name: "Longone Sabino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "05024052",
        name: "Lonigo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01001137",
        name: "Loranzè",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05028046",
        name: "Loreggia",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01103038",
        name: "Loreglia",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "05025032",
        name: "Lorenzago di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05029030",
        name: "Loreo",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "11042022",
        name: "Loreto",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "13068021",
        name: "Loreto Aprutino",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "05026036",
        name: "Loria",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "09051020",
        name: "Loro Ciuffenna",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "11043022",
        name: "Loro Piceno",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "07010030",
        name: "Lorsica",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03017094",
        name: "Losine",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20091042",
        name: "Lotzorai",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03016128",
        name: "Lovere",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03014038",
        name: "Lovero",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03017095",
        name: "Lozio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03012091",
        name: "Lozza",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05028047",
        name: "Lozzo Atestino",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05025033",
        name: "Lozzo di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "01002072",
        name: "Lozzolo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01006193",
        name: "Lu e Cuccaro Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "12056033",
        name: "Lubriano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "09046017",
        name: "Lucca",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "19084022",
        name: "Lucca Sicula",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "16071028",
        name: "Lucera",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "09051021",
        name: "Lucignano",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "07008033",
        name: "Lucinasco",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "14070033",
        name: "Lucito",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "13066051",
        name: "Luco dei Marsi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "13066052",
        name: "Lucoli",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "08033026",
        name: "Lugagnano Val d'Arda",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "10055016",
        name: "Lugnano in Teverina",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "08039012",
        name: "Lugo",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "05024053",
        name: "Lugo di Vicenza",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03012092",
        name: "Luino",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03013135",
        name: "Luisago",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "20091043",
        name: "Lula",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "07010031",
        name: "Lumarzo",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03017096",
        name: "Lumezzane",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20111038",
        name: "Lunamatrona",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "11041022",
        name: "Lunano",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "03018084",
        name: "Lungavilla",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "18078069",
        name: "Lungro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "07011020",
        name: "Luni",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "15064045",
        name: "Luogosano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "20090036",
        name: "Luogosanto",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "14070034",
        name: "Lupara",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03013136",
        name: "Lurago d'Erba",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03013137",
        name: "Lurago Marinone",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016129",
        name: "Lurano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "20090037",
        name: "Luras",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03013138",
        name: "Lurate Caccivio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "15061046",
        name: "Lusciano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "04022109",
        name: "Luserna",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001139",
        name: "Luserna San Giovanni",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001140",
        name: "Lusernetta",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "06030051",
        name: "Lusevera",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05029031",
        name: "Lusia",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "05024127",
        name: "Lusiana Conco",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01001141",
        name: "Lusigliè",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "04021044",
        name: "Luson",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15065064",
        name: "Lustra",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03012093",
        name: "Luvinate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03016130",
        name: "Luzzana",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08035026",
        name: "Luzzara",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "18078070",
        name: "Luzzi",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03012142",
        name: "Maccagno con Pino e Veddasca",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03098033",
        name: "Maccastorna",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "14094025",
        name: "Macchia d'Isernia",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "14070035",
        name: "Macchia Valfortore",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "14094026",
        name: "Macchiagodena",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "01001142",
        name: "Macello",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "11043023",
        name: "Macerata",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "15061047",
        name: "Macerata Campania",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "11041023",
        name: "Macerata Feltria",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "03108029",
        name: "Macherio",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03017097",
        name: "Maclodio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20091044",
        name: "Macomer",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "01004112",
        name: "Macra",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01103039",
        name: "Macugnaga",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "15061048",
        name: "Maddaloni",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03014035",
        name: "Madesimo",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03019055",
        name: "Madignano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03016131",
        name: "Madone",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01103040",
        name: "Madonna del Sasso",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "04022243",
        name: "Madruzzo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "12059013",
        name: "Maenza",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "14070036",
        name: "Mafalda",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03017098",
        name: "Magasa",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03015130",
        name: "Magenta",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01003088",
        name: "Maggiora",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03018085",
        name: "Magherno",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "10054026",
        name: "Magione",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "18079068",
        name: "Magisano",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "01004113",
        name: "Magliano Alfieri",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004114",
        name: "Magliano Alpi",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13066053",
        name: "Magliano de' Marsi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "11109010",
        name: "Magliano di Tenna",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "09053013",
        name: "Magliano in Toscana",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "12058052",
        name: "Magliano Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "12057035",
        name: "Magliano Sabina",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "15065065",
        name: "Magliano Vetere",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "16075039",
        name: "Maglie",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "07009035",
        name: "Magliolo",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01001143",
        name: "Maglione",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03020029",
        name: "Magnacavallo",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03015131",
        name: "Magnago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01096030",
        name: "Magnano",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "06030052",
        name: "Magnano in Riviera",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20095083",
        name: "Magomadas",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "04021045",
        name: "Magrè sulla strada del vino",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03013139",
        name: "Magreglio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "18079069",
        name: "Maida",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18078071",
        name: "Maierà",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18102020",
        name: "Maierato",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "11042023",
        name: "Maiolati Spontini",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "08099022",
        name: "Maiolo",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "15065066",
        name: "Maiori",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03098034",
        name: "Mairago",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03017099",
        name: "Mairano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "07011018",
        name: "Maissana",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "06030053",
        name: "Majano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03019056",
        name: "Malagnino",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "08037035",
        name: "Malalbergo",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "06030054",
        name: "Malborghetto Valbruna",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05023045",
        name: "Malcesine",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04022110",
        name: "Malé",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03017100",
        name: "Malegno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03098035",
        name: "Maleo",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "01103041",
        name: "Malesco",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "19087022",
        name: "Maletto",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19083043",
        name: "Malfa",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03012095",
        name: "Malgesso",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03097045",
        name: "Malgrate",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "18078072",
        name: "Malito",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "07009036",
        name: "Mallare",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "04021046",
        name: "Malles Venosta",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03012096",
        name: "Malnate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05024055",
        name: "Malo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03017101",
        name: "Malonno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "11044027",
        name: "Maltignano",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "19083044",
        name: "Malvagna",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01006090",
        name: "Malvicino",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18078073",
        name: "Malvito",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18080044",
        name: "Mammola",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "20091046",
        name: "Mamoiada",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "09053014",
        name: "Manciano",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "19083045",
        name: "Mandanici",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "20111039",
        name: "Mandas",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "18078074",
        name: "Mandatoriccio",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12058053",
        name: "Mandela",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03097046",
        name: "Mandello del Lario",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01003090",
        name: "Mandello Vitta",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "16073012",
        name: "Manduria",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "03017102",
        name: "Manerba del Garda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017103",
        name: "Manerbio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "16071029",
        name: "Manfredonia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "01004115",
        name: "Mango",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18078075",
        name: "Mangone",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19087057",
        name: "Maniace",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "06093025",
        name: "Maniago",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15064046",
        name: "Manocalzati",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "13068022",
        name: "Manoppello",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "05026037",
        name: "Mansuè",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01004116",
        name: "Manta",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03014039",
        name: "Mantello",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03020030",
        name: "Mantova",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "06030055",
        name: "Manzano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12058054",
        name: "Manziana",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03016132",
        name: "Mapello",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001316",
        name: "Mappano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20090038",
        name: "Mara",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20092037",
        name: "Maracalagonis",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "08036019",
        name: "Maranello",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "15063041",
        name: "Marano di Napoli",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "05023046",
        name: "Marano di Valpolicella",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "12058055",
        name: "Marano Equo",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "06030056",
        name: "Marano Lagunare",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "18078076",
        name: "Marano Marchesato",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18078077",
        name: "Marano Principato",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "08036020",
        name: "Marano sul Panaro",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "01003091",
        name: "Marano Ticino",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "05024056",
        name: "Marano Vicentino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01005061",
        name: "Maranzana",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "17076044",
        name: "Maratea",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03015134",
        name: "Marcallo con Casone",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03020031",
        name: "Marcaria",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "18079071",
        name: "Marcedusa",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "12058056",
        name: "Marcellina",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "18079072",
        name: "Marcellinara",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "12057036",
        name: "Marcetelli",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03017104",
        name: "Marcheno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03012097",
        name: "Marchirolo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "09049010",
        name: "Marciana",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "09049011",
        name: "Marciana Marina",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "15061049",
        name: "Marcianise",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "09051022",
        name: "Marciano della Chiana",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "03018086",
        name: "Marcignago",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05027020",
        name: "Marcon",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "04021047",
        name: "Marebbe",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004117",
        name: "Marene",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05026038",
        name: "Mareno di Piave",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01001144",
        name: "Marentino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01005062",
        name: "Maretto",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01004118",
        name: "Margarita",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "16110005",
        name: "Margherita di Savoia",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "03097047",
        name: "Margno",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03020032",
        name: "Mariana Mantovana",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03013143",
        name: "Mariano Comense",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "06031010",
        name: "Mariano del Friuli",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19085008",
        name: "Marianopoli",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "15063042",
        name: "Mariglianella",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15063043",
        name: "Marigliano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "18080045",
        name: "Marina di Gioiosa Ionica",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19082046",
        name: "Marineo",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "12058057",
        name: "Marino",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "04021048",
        name: "Marlengo",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "09047007",
        name: "Marliana",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "03017105",
        name: "Marmentino",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03020033",
        name: "Marmirolo",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01004119",
        name: "Marmora",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03012098",
        name: "Marnate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03017106",
        name: "Marone",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "18080046",
        name: "Maropati",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "05024057",
        name: "Marostica",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "09048026",
        name: "Marradi",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "20095025",
        name: "Marrubiu",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01004120",
        name: "Marsaglia",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19081011",
        name: "Marsala",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "10054027",
        name: "Marsciano",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "17076045",
        name: "Marsico Nuovo",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "17076046",
        name: "Marsicovetere",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "12056034",
        name: "Marta",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "16075040",
        name: "Martano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "05027021",
        name: "Martellago",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "04021049",
        name: "Martello",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06030057",
        name: "Martignacco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03019057",
        name: "Martignana di Po",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "16075041",
        name: "Martignano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "16073013",
        name: "Martina Franca",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "03016133",
        name: "Martinengo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01004121",
        name: "Martiniana Po",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13067047",
        name: "Martinsicuro",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "18079073",
        name: "Martirano",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18079074",
        name: "Martirano Lombardo",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "20090039",
        name: "Martis",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "18080047",
        name: "Martone",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03098036",
        name: "Marudo",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "16073014",
        name: "Maruggio",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "08037036",
        name: "Marzabotto",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03018087",
        name: "Marzano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "15061050",
        name: "Marzano Appio",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15064047",
        name: "Marzano di Nola",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18078078",
        name: "Marzi",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03012099",
        name: "Marzio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "20111040",
        name: "Masainas",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03015136",
        name: "Masate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "19087023",
        name: "Mascali",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19087024",
        name: "Mascalucia",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "17076047",
        name: "Maschito",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03012100",
        name: "Masciago Primo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05026039",
        name: "Maser",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01103042",
        name: "Masera",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "05028048",
        name: "Maserà di Padova",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05026040",
        name: "Maserada sul Piave",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "05028049",
        name: "Masi",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "08038012",
        name: "Masi Torello",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "01006091",
        name: "Masio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03013144",
        name: "Maslianico",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "07010032",
        name: "Masone",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "09045010",
        name: "Massa",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "13066054",
        name: "Massa d'Albe",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15063092",
        name: "Massa di Somma",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "09047008",
        name: "Massa e Cozzile",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "11109011",
        name: "Massa Fermana",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "08039013",
        name: "Massa Lombarda",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "15063044",
        name: "Massa Lubrense",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "09053015",
        name: "Massa Marittima",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "10054028",
        name: "Massa Martana",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "16073015",
        name: "Massafra",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "03098037",
        name: "Massalengo",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "05028050",
        name: "Massanzago",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "09046018",
        name: "Massarosa",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "01096031",
        name: "Massazza",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01001145",
        name: "Massello",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01096032",
        name: "Masserano",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "11044029",
        name: "Massignano",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "04022112",
        name: "Massimeno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07009037",
        name: "Massimino",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01003093",
        name: "Massino Visconti",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01103043",
        name: "Massiola",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "20095026",
        name: "Masullas",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "11043024",
        name: "Matelica",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "17077014",
        name: "Matera",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "01001146",
        name: "Mathi",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16075042",
        name: "Matino",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "14070037",
        name: "Matrice",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01001147",
        name: "Mattie",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16071031",
        name: "Mattinata",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "19081012",
        name: "Mazara del Vallo",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "03017107",
        name: "Mazzano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "12058058",
        name: "Mazzano Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "19085009",
        name: "Mazzarino",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "19083046",
        name: "Mazzarrà Sant'Andrea",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19087056",
        name: "Mazzarrone",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "01001148",
        name: "Mazzè",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "04022113",
        name: "Mazzin",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03014040",
        name: "Mazzo di Valtellina",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01001149",
        name: "Meana di Susa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20091047",
        name: "Meana Sardo",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03108030",
        name: "Meda",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03018088",
        name: "Mede",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "06031011",
        name: "Medea",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "08034020",
        name: "Medesano",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "08037037",
        name: "Medicina",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03015139",
        name: "Mediglia",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03016250",
        name: "Medolago",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03020034",
        name: "Medole",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "08036021",
        name: "Medolla",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "05026041",
        name: "Meduna di Livenza",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "06093026",
        name: "Meduno",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05028052",
        name: "Megliadino San Vitale",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01003095",
        name: "Meina",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "05029032",
        name: "Melara",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01006092",
        name: "Melazzo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "08040019",
        name: "Meldola",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "07010033",
        name: "Mele",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03015140",
        name: "Melegnano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "16075043",
        name: "Melendugno",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03098038",
        name: "Meleti",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "17076048",
        name: "Melfi",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "18080048",
        name: "Melicuccà",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18080049",
        name: "Melicucco",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19089012",
        name: "Melilli",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "18101014",
        name: "Melissa",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "16075044",
        name: "Melissano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "15063045",
        name: "Melito di Napoli",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "18080050",
        name: "Melito di Porto Salvo",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "15064048",
        name: "Melito Irpino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15062039",
        name: "Melizzano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "01004122",
        name: "Melle",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03014041",
        name: "Mello",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "16075045",
        name: "Melpignano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "04021050",
        name: "Meltina",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03015142",
        name: "Melzo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03013145",
        name: "Menaggio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03018089",
        name: "Menconico",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "07008034",
        name: "Mendatica",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "18078079",
        name: "Mendicino",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19084023",
        name: "Menfi",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "12058059",
        name: "Mentana",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05027022",
        name: "Meolo",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "01006093",
        name: "Merana",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "04021051",
        name: "Merano",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03097048",
        name: "Merate",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03012101",
        name: "Mercallo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "11041025",
        name: "Mercatello sul Metauro",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11041026",
        name: "Mercatino Conca",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "15065067",
        name: "Mercato San Severino",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "08040020",
        name: "Mercato Saraceno",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "01001150",
        name: "Mercenasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15064049",
        name: "Mercogliano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "06030058",
        name: "Mereto di Tomba",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "11042024",
        name: "Mergo",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01103044",
        name: "Mergozzo",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "19083047",
        name: "Merì",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "05028053",
        name: "Merlara",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03098039",
        name: "Merlino",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03013147",
        name: "Merone",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "16074010",
        name: "Mesagne",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "03014043",
        name: "Mese",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03012102",
        name: "Mesenzana",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03015144",
        name: "Mesero",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "08038014",
        name: "Mesola",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "18101015",
        name: "Mesoraca",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "19083048",
        name: "Messina",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "05028054",
        name: "Mestrino",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "15063046",
        name: "Meta",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03108031",
        name: "Mezzago",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "04022114",
        name: "Mezzana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03018090",
        name: "Mezzana Bigli",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01096033",
        name: "Mezzana Mortigliengo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03018091",
        name: "Mezzana Rabattone",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05023047",
        name: "Mezzane di Sotto",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "07010034",
        name: "Mezzanego",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03018092",
        name: "Mezzanino",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "04022115",
        name: "Mezzano",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001152",
        name: "Mezzenile",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "04022116",
        name: "Mezzocorona",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "19082047",
        name: "Mezzojuso",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03016134",
        name: "Mezzoldo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04022117",
        name: "Mezzolombardo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01003097",
        name: "Mezzomerico",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01096034",
        name: "Miagliano",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "05026042",
        name: "Miane",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01003098",
        name: "Miasino",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01103045",
        name: "Miazzina",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "12057037",
        name: "Micigliano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "16075046",
        name: "Miggiano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "13069050",
        name: "Miglianico",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "18079077",
        name: "Miglierina",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "17077015",
        name: "Miglionico",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "07010035",
        name: "Mignanego",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "15061051",
        name: "Mignano Monte Lungo",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03015146",
        name: "Milano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "19083049",
        name: "Milazzo",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19085010",
        name: "Milena",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "18102021",
        name: "Mileto",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "20095027",
        name: "Milis",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "19087025",
        name: "Militello in Val di Catania",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19083050",
        name: "Militello Rosmarino",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "07009038",
        name: "Millesimo",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "19087026",
        name: "Milo",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "03017108",
        name: "Milzano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "19087027",
        name: "Mineo",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "05023048",
        name: "Minerbe",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "08037038",
        name: "Minerbio",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "16075047",
        name: "Minervino di Lecce",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "16110006",
        name: "Minervino Murge",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "15065068",
        name: "Minori",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "12059014",
        name: "Minturno",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "09046019",
        name: "Minucciano",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "07009039",
        name: "Mioglia",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "05027023",
        name: "Mira",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "15064050",
        name: "Mirabella Eclano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "19087028",
        name: "Mirabella Imbaccari",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "01006094",
        name: "Mirabello Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "14070038",
        name: "Mirabello Sannitico",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03018093",
        name: "Miradolo Terme",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "14094027",
        name: "Miranda",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "08036022",
        name: "Mirandola",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "05027024",
        name: "Mirano",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "19083051",
        name: "Mirto",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "08099005",
        name: "Misano Adriatico",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "03016135",
        name: "Misano di Gera d'Adda",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19082048",
        name: "Misilmeri",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03108032",
        name: "Misinto",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03097049",
        name: "Missaglia",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "17076049",
        name: "Missanello",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "19087029",
        name: "Misterbianco",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "19083052",
        name: "Mistretta",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01005063",
        name: "Moasca",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "07010036",
        name: "Moconesi",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "08036023",
        name: "Modena",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "19088006",
        name: "Modica",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "08040022",
        name: "Modigliana",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "20095084",
        name: "Modolo",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "16072027",
        name: "Modugno",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "04022118",
        name: "Moena",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03097050",
        name: "Moggio",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "06030059",
        name: "Moggio Udinese",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03020035",
        name: "Moglia",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "11043025",
        name: "Mogliano",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "05026043",
        name: "Mogliano Veneto",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "20095028",
        name: "Mogorella",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20095029",
        name: "Mogoro",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "15062040",
        name: "Moiano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "06030060",
        name: "Moimacco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19083053",
        name: "Moio Alcantara",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03016136",
        name: "Moio de' Calvi",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "15065069",
        name: "Moio della Civitella",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01004123",
        name: "Moiola",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "16072028",
        name: "Mola di Bari",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "01006095",
        name: "Molare",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "09046020",
        name: "Molazzana",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "16072029",
        name: "Molfetta",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "13066055",
        name: "Molina Aterno",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15062041",
        name: "Molinara",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "08037039",
        name: "Molinella",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "07008035",
        name: "Molini di Triora",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01006096",
        name: "Molino dei Torti",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "14070039",
        name: "Molise",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "17076050",
        name: "Moliterno",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "01002078",
        name: "Mollia",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "18080051",
        name: "Molochio",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03097051",
        name: "Molteno",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03013152",
        name: "Moltrasio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04022120",
        name: "Molveno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01005064",
        name: "Mombaldone",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01004124",
        name: "Mombarcaro",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "11041027",
        name: "Mombaroccio",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "01005065",
        name: "Mombaruzzo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01004125",
        name: "Mombasiglio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001153",
        name: "Mombello di Torino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01006097",
        name: "Mombello Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01005066",
        name: "Mombercelli",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01003100",
        name: "Momo",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01001154",
        name: "Mompantero",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12057038",
        name: "Mompeo",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "01006098",
        name: "Momperone",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "14070040",
        name: "Monacilioni",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01005067",
        name: "Monale",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "18080052",
        name: "Monasterace",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01005068",
        name: "Monastero Bormida",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001155",
        name: "Monastero di Lanzo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004126",
        name: "Monastero di Vasco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004127",
        name: "Monasterolo Casotto",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03016137",
        name: "Monasterolo del Castello",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01004128",
        name: "Monasterolo di Savigliano",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05026044",
        name: "Monastier di Treviso",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "20111041",
        name: "Monastir",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01001156",
        name: "Moncalieri",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01005069",
        name: "Moncalvo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001157",
        name: "Moncenisio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01006099",
        name: "Moncestino",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01004129",
        name: "Monchiero",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08034022",
        name: "Monchio delle Corti",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "01002079",
        name: "Moncrivello",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01005070",
        name: "Moncucco Torinese",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "08099006",
        name: "Mondaino",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "11041028",
        name: "Mondavio",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11041029",
        name: "Mondolfo",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "01004130",
        name: "Mondovì",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15061052",
        name: "Mondragone",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "07010037",
        name: "Moneglia",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01004131",
        name: "Monesiglio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "06031012",
        name: "Monfalcone",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01004132",
        name: "Monforte d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19083054",
        name: "Monforte San Giorgio",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "05026045",
        name: "Monfumo",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01005071",
        name: "Mongardino",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "08037040",
        name: "Monghidoro",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "18102022",
        name: "Mongiana",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "01006100",
        name: "Mongiardino Ligure",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "19083055",
        name: "Mongiuffi Melia",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01096035",
        name: "Mongrando",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "18078080",
        name: "Mongrassano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "04021052",
        name: "Monguelfo-Tesido",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03013153",
        name: "Monguzzo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03017109",
        name: "Moniga del Garda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01006101",
        name: "Monleale",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03017110",
        name: "Monno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "16072030",
        name: "Monopoli",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "19082049",
        name: "Monreale",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "06032002",
        name: "Monrupino",
        districtInitials: "TS",
        district: "Trieste",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "11109012",
        name: "Monsampietro Morico",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "11044031",
        name: "Monsampolo del Tronto",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "11042025",
        name: "Monsano",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "05028055",
        name: "Monselice",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "20092109",
        name: "Monserrato",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "09047009",
        name: "Monsummano Terme",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "01004133",
        name: "Montà",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01005072",
        name: "Montabone",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01006102",
        name: "Montacuto",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01005073",
        name: "Montafia",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "14070041",
        name: "Montagano",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "04021053",
        name: "Montagna",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03014044",
        name: "Montagna in Valtellina",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "05028056",
        name: "Montagnana",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "19083056",
        name: "Montagnareale",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "15064051",
        name: "Montaguto",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "09048027",
        name: "Montaione",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "19083057",
        name: "Montalbano Elicona",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "17077016",
        name: "Montalbano Jonico",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "09052037",
        name: "Montalcino",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "01006103",
        name: "Montaldeo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01006104",
        name: "Montaldo Bormida",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01004134",
        name: "Montaldo di Mondovì",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004135",
        name: "Montaldo Roero",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01005074",
        name: "Montaldo Scarampi",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001158",
        name: "Montaldo Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "09047010",
        name: "Montale",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "01001159",
        name: "Montalenghe",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19084024",
        name: "Montallegro",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "07008068",
        name: "Montalto Carpasio",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "11044032",
        name: "Montalto delle Marche",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "12056035",
        name: "Montalto di Castro",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "01001160",
        name: "Montalto Dora",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018094",
        name: "Montalto Pavese",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "18078081",
        name: "Montalto Uffugo",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01001161",
        name: "Montanaro",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03098040",
        name: "Montanaso Lombardo",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "01004136",
        name: "Montanera",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15065070",
        name: "Montano Antilia",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03013154",
        name: "Montano Lucino",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "11109013",
        name: "Montappone",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "14094028",
        name: "Montaquila",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "12057039",
        name: "Montasola",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "18079080",
        name: "Montauro",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "13069051",
        name: "Montazzoli",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "09053016",
        name: "Monte Argentario",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "10054029",
        name: "Monte Castello di Vibio",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "11043027",
        name: "Monte Cavallo",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "11041031",
        name: "Monte Cerignone",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "12058060",
        name: "Monte Compatri",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03019058",
        name: "Monte Cremasco",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05024063",
        name: "Monte di Malo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "15063047",
        name: "Monte di Procida",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "11109016",
        name: "Monte Giberto",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "11041035",
        name: "Monte Grimano Terme",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "03017111",
        name: "Monte Isola",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03097052",
        name: "Monte Marenzo",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "11041038",
        name: "Monte Porzio",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "12058064",
        name: "Monte Porzio Catone",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "11109021",
        name: "Monte Rinaldo",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "11042029",
        name: "Monte Roberto",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "12056037",
        name: "Monte Romano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "12059015",
        name: "Monte San Biagio",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "15065075",
        name: "Monte San Giacomo",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "12060044",
        name: "Monte San Giovanni Campano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "12057043",
        name: "Monte San Giovanni in Sabina",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "11043031",
        name: "Monte San Giusto",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "11043032",
        name: "Monte San Martino",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "11109023",
        name: "Monte San Pietrangeli",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "08037042",
        name: "Monte San Pietro",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "09051025",
        name: "Monte San Savino",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "11042030",
        name: "Monte San Vito",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "16071033",
        name: "Monte Sant'Angelo",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "10054032",
        name: "Monte Santa Maria Tiberina",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "11109024",
        name: "Monte Urano",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "11109025",
        name: "Monte Vidon Combatte",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "11109026",
        name: "Monte Vidon Corrado",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "03018095",
        name: "Montebello della Battaglia",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "13068023",
        name: "Montebello di Bertona",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "18080053",
        name: "Montebello Jonico",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "13069009",
        name: "Montebello sul Sangro",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "05024060",
        name: "Montebello Vicentino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05026046",
        name: "Montebelluna",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "07010038",
        name: "Montebruno",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "12057040",
        name: "Montebuono",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "11041030",
        name: "Montecalvo in Foglia",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "15064052",
        name: "Montecalvo Irpino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03018096",
        name: "Montecalvo Versiggia",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "09046021",
        name: "Montecarlo",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "11042026",
        name: "Montecarotto",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "11043026",
        name: "Montecassiano",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "01006105",
        name: "Montecastello",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "10055017",
        name: "Montecastrilli",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "09050019",
        name: "Montecatini Val di Cecina",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "09047011",
        name: "Montecatini-Terme",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "05023049",
        name: "Montecchia di Crosara",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "10055018",
        name: "Montecchio",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "08035027",
        name: "Montecchio Emilia",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "05024061",
        name: "Montecchio Maggiore",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05024062",
        name: "Montecchio Precalcino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01006106",
        name: "Montechiaro d'Acqui",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01005075",
        name: "Montechiaro d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "08034023",
        name: "Montechiarugolo",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "11041032",
        name: "Monteciccardo",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "14070042",
        name: "Montecilfone",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "11041033",
        name: "Montecopiolo",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "15065071",
        name: "Montecorice",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15065072",
        name: "Montecorvino Pugliano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15065073",
        name: "Montecorvino Rovella",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "11043028",
        name: "Montecosaro",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "01103046",
        name: "Montecrestese",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "08036024",
        name: "Montecreto",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "11044034",
        name: "Montedinove",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "19085011",
        name: "Montedoro",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "15064053",
        name: "Montefalcione",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "10054030",
        name: "Montefalco",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "11109014",
        name: "Montefalcone Appennino",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "15062042",
        name: "Montefalcone di Val Fortore",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "14070043",
        name: "Montefalcone nel Sannio",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "11043029",
        name: "Montefano",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "11041034",
        name: "Montefelcino",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "13069052",
        name: "Monteferrante",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "12056036",
        name: "Montefiascone",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "13067027",
        name: "Montefino",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "08099008",
        name: "Montefiore Conca",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "11044036",
        name: "Montefiore dell'Aso",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "08036025",
        name: "Montefiorino",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "12058061",
        name: "Monteflavio",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15065074",
        name: "Monteforte Cilento",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05023050",
        name: "Monteforte d'Alpone",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "15064054",
        name: "Monteforte Irpino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "11109015",
        name: "Montefortino",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "10055019",
        name: "Montefranco",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "15064055",
        name: "Montefredane",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15064056",
        name: "Montefusco",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "10055020",
        name: "Montegabbione",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "05024064",
        name: "Montegalda",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05024065",
        name: "Montegaldella",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "11044038",
        name: "Montegallo",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "01006107",
        name: "Montegioco",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18078082",
        name: "Montegiordano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "11109017",
        name: "Montegiorgio",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "11109018",
        name: "Montegranaro",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "08099009",
        name: "Montegridolfo",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "03012103",
        name: "Montegrino Valtravaglia",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01005076",
        name: "Montegrosso d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "07008037",
        name: "Montegrosso Pian Latte",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "05028057",
        name: "Montegrotto Terme",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "16073016",
        name: "Monteiasi",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "11041036",
        name: "Montelabbate",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "12058062",
        name: "Montelanico",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "13069053",
        name: "Montelapiano",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "10055021",
        name: "Monteleone d'Orvieto",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "11109019",
        name: "Monteleone di Fermo",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "16071032",
        name: "Monteleone di Puglia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "10054031",
        name: "Monteleone di Spoleto",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "20090040",
        name: "Monteleone Rocca Doria",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "12057041",
        name: "Monteleone Sabino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "19082050",
        name: "Montelepre",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "12058063",
        name: "Montelibretti",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15064057",
        name: "Montella",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03016139",
        name: "Montello",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "14070044",
        name: "Montelongo",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "11109020",
        name: "Montelparo",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "01004137",
        name: "Montelupo Albese",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "09048028",
        name: "Montelupo Fiorentino",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "11043030",
        name: "Montelupone",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "19082051",
        name: "Montemaggiore Belsito",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "01005077",
        name: "Montemagno",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01004138",
        name: "Montemale di Cuneo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15064058",
        name: "Montemarano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "11042027",
        name: "Montemarciano",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01006108",
        name: "Montemarzino",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16073017",
        name: "Montemesola",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "03013155",
        name: "Montemezzo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "09051023",
        name: "Montemignaio",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "15064059",
        name: "Montemiletto",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "17076051",
        name: "Montemilone",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "14070045",
        name: "Montemitro",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "11044044",
        name: "Montemonaco",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "09100003",
        name: "Montemurlo",
        districtInitials: "PO",
        district: "Prato",
        region: "Toscana"
    },
    {
        code: "17076052",
        name: "Montemurro",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "06030061",
        name: "Montenars",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "14070046",
        name: "Montenero di Bisaccia",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "12057042",
        name: "Montenero Sabino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "14094029",
        name: "Montenero Val Cocchiara",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "13069054",
        name: "Montenerodomo",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13069055",
        name: "Monteodorisio",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "18079081",
        name: "Montepaone",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "16073018",
        name: "Monteparano",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "11044045",
        name: "Monteprandone",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "09052015",
        name: "Montepulciano",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09051024",
        name: "Monterchi",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "13066056",
        name: "Montereale",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "06093027",
        name: "Montereale Valcellina",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "08037041",
        name: "Monterenzio",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "09052016",
        name: "Monteriggioni",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "14094030",
        name: "Monteroduni",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "09052017",
        name: "Monteroni d'Arbia",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "16075048",
        name: "Monteroni di Lecce",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "12056038",
        name: "Monterosi",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "07011019",
        name: "Monterosso al Mare",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "19088007",
        name: "Monterosso Almo",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "18102023",
        name: "Monterosso Calabro",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "01004139",
        name: "Monterosso Grana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "12058065",
        name: "Monterotondo",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "09053027",
        name: "Monterotondo Marittimo",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "11109022",
        name: "Monterubbiano",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "16075049",
        name: "Montesano Salentino",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "15065076",
        name: "Montesano sulla Marcellana",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15062043",
        name: "Montesarchio",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "17077017",
        name: "Montescaglioso",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "03018097",
        name: "Montescano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01103047",
        name: "Montescheno",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "09050020",
        name: "Montescudaio",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "08099029",
        name: "Montescudo-Monte Colombo",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "08036026",
        name: "Montese",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "03018098",
        name: "Montesegale",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "13068024",
        name: "Montesilvano",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "09048030",
        name: "Montespertoli",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "01001162",
        name: "Monteu da Po",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004140",
        name: "Monteu Roero",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19084025",
        name: "Montevago",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "09051026",
        name: "Montevarchi",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "03097053",
        name: "Montevecchia",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "15064060",
        name: "Monteverde",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "09050021",
        name: "Monteverdi Marittimo",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "05024066",
        name: "Monteviale",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01004141",
        name: "Montezemolo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20090041",
        name: "Monti",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "08040028",
        name: "Montiano",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "03017112",
        name: "Monticelli Brusati",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "08033027",
        name: "Monticelli d'Ongina",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03018099",
        name: "Monticelli Pavese",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03097054",
        name: "Monticello Brianza",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "05024067",
        name: "Monticello Conte Otto",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01004142",
        name: "Monticello d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017113",
        name: "Montichiari",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "09052018",
        name: "Monticiano",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09053017",
        name: "Montieri",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "01005121",
        name: "Montiglio Monferrato",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "09045011",
        name: "Montignoso",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "03017114",
        name: "Montirone",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "02007043",
        name: "Montjovet",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03019059",
        name: "Montodine",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "07010039",
        name: "Montoggio",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "10054033",
        name: "Montone",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "12057044",
        name: "Montopoli di Sabina",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "09050022",
        name: "Montopoli in Val d'Arno",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "03013157",
        name: "Montorfano",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "13067028",
        name: "Montorio al Vomano",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "14070047",
        name: "Montorio nei Frentani",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "12058066",
        name: "Montorio Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15064121",
        name: "Montoro",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "05024068",
        name: "Montorso Vicentino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "11109027",
        name: "Montottone",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "20095085",
        name: "Montresta",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "03018100",
        name: "Montù Beccaria",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03012104",
        name: "Monvalle",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03108033",
        name: "Monza",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03020036",
        name: "Monzambano",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "08037044",
        name: "Monzuno",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "18078083",
        name: "Morano Calabro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01006109",
        name: "Morano sul Po",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01005079",
        name: "Moransengo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "06031013",
        name: "Moraro",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03012105",
        name: "Morazzone",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03014045",
        name: "Morbegno",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01006110",
        name: "Morbello",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16075050",
        name: "Morciano di Leuca",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "08099011",
        name: "Morciano di Romagna",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "15062044",
        name: "Morcone",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "08037045",
        name: "Mordano",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03016140",
        name: "Morengo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "20090042",
        name: "Mores",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "11109028",
        name: "Moresco",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "01004143",
        name: "Moretta",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08033028",
        name: "Morfasso",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "05026047",
        name: "Morgano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "02007044",
        name: "Morgex",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "20095030",
        name: "Morgongiori",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "04022123",
        name: "Mori",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05026048",
        name: "Moriago della Battaglia",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "12058067",
        name: "Moricone",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15065077",
        name: "Morigerati",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03015150",
        name: "Morimondo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "13066057",
        name: "Morino",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "01001163",
        name: "Moriondo Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12058068",
        name: "Morlupo",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "18078084",
        name: "Mormanno",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03012106",
        name: "Mornago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01006111",
        name: "Mornese",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03016141",
        name: "Mornico al Serio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03018101",
        name: "Mornico Losana",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "12060045",
        name: "Morolo",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01004144",
        name: "Morozzo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15064063",
        name: "Morra De Sanctis",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "11042031",
        name: "Morro d'Alba",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "13067029",
        name: "Morro d'Oro",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "12057045",
        name: "Morro Reatino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "14070048",
        name: "Morrone del Sannio",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "11043033",
        name: "Morrovalle",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "06093028",
        name: "Morsano al Tagliamento",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01006112",
        name: "Morsasco",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018102",
        name: "Mortara",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "06030062",
        name: "Mortegliano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03097055",
        name: "Morterone",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "06030063",
        name: "Moruzzo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03019060",
        name: "Moscazzano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "15064064",
        name: "Moschiano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "13067030",
        name: "Mosciano Sant'Angelo",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "13068025",
        name: "Moscufo",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "04021054",
        name: "Moso in Passiria",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06031014",
        name: "Mossa",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03019061",
        name: "Motta Baluffi",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "19083058",
        name: "Motta Camastra",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19083059",
        name: "Motta d'Affermo",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01002082",
        name: "Motta de' Conti",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "05026049",
        name: "Motta di Livenza",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "16071034",
        name: "Motta Montecorvino",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "18080054",
        name: "Motta San Giovanni",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19087030",
        name: "Motta Sant'Anastasia",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "18079083",
        name: "Motta Santa Lucia",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "03015151",
        name: "Motta Visconti",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "18078085",
        name: "Mottafollone",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01096037",
        name: "Mottalciata",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03020037",
        name: "Motteggiana",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "16073019",
        name: "Mottola",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "13069056",
        name: "Mozzagrogna",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "03016142",
        name: "Mozzanica",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013159",
        name: "Mozzate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05023051",
        name: "Mozzecane",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03016143",
        name: "Mozzo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "11043034",
        name: "Muccia",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "06032003",
        name: "Muggia",
        districtInitials: "TS",
        district: "Trieste",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03108034",
        name: "Muggiò",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "15064065",
        name: "Mugnano del Cardinale",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15063048",
        name: "Mugnano di Napoli",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03098041",
        name: "Mulazzano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "09045012",
        name: "Mulazzo",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "03017115",
        name: "Mura",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20111042",
        name: "Muravera",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01004145",
        name: "Murazzano",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004146",
        name: "Murello",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "07009040",
        name: "Murialdo",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01006113",
        name: "Murisengo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "09052019",
        name: "Murlo",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "16075051",
        name: "Muro Leccese",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "17076053",
        name: "Muro Lucano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "20090043",
        name: "Muros",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03017116",
        name: "Muscoline",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20111043",
        name: "Musei",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "05027025",
        name: "Musile di Piave",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "03013160",
        name: "Musso",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05024070",
        name: "Mussolente",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "19085012",
        name: "Mussomeli",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "06030064",
        name: "Muzzana del Turgnano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01096038",
        name: "Muzzano",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "04022124",
        name: "Nago-Torbole",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04021055",
        name: "Nalles",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05024071",
        name: "Nanto",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "15063049",
        name: "Napoli",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "20095031",
        name: "Narbolia",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20111044",
        name: "Narcao",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "16075052",
        name: "Nardò",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "18102024",
        name: "Nardodipace",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "10055022",
        name: "Narni",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "19084026",
        name: "Naro",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "01004147",
        name: "Narzole",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "07009041",
        name: "Nasino",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "19083060",
        name: "Naso",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "04021056",
        name: "Naturno",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03017117",
        name: "Nave",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "13066058",
        name: "Navelli",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "04021057",
        name: "Naz-Sciaves",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "12058069",
        name: "Nazzano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "07010040",
        name: "Ne",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01003103",
        name: "Nebbiuno",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "05023052",
        name: "Negrar di Valpolicella",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "07010041",
        name: "Neirone",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01004148",
        name: "Neive",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03016144",
        name: "Nembro",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12058070",
        name: "Nemi",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "17076054",
        name: "Nemoli",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "20095032",
        name: "Neoneli",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "12056039",
        name: "Nepi",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "13067031",
        name: "Nereto",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "12058071",
        name: "Nerola",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05026050",
        name: "Nervesa della Battaglia",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03015154",
        name: "Nerviano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "12057046",
        name: "Nespolo",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03013161",
        name: "Nesso",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01096039",
        name: "Netro",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "12058072",
        name: "Nettuno",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "16075053",
        name: "Neviano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "08034024",
        name: "Neviano degli Arduini",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "01004149",
        name: "Neviglie",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017118",
        name: "Niardo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01003104",
        name: "Nibbiola",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03097056",
        name: "Nibionno",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01001164",
        name: "Nichelino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19087031",
        name: "Nicolosi",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "03018103",
        name: "Nicorvo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19086012",
        name: "Nicosia",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "18102025",
        name: "Nicotera",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "01004150",
        name: "Niella Belbo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004151",
        name: "Niella Tanaro",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "06030065",
        name: "Nimis",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19085013",
        name: "Niscemi",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "19086013",
        name: "Nissoria",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "19083061",
        name: "Nizza di Sicilia",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01005080",
        name: "Nizza Monferrato",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05027026",
        name: "Noale",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "01001165",
        name: "Noasca",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18078086",
        name: "Nocara",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13068026",
        name: "Nocciano",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "15065078",
        name: "Nocera Inferiore",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15065079",
        name: "Nocera Superiore",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "18079087",
        name: "Nocera Terinese",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "10054034",
        name: "Nocera Umbra",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "08034025",
        name: "Noceto",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "16072031",
        name: "Noci",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "16075054",
        name: "Nociglia",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "17076055",
        name: "Noepoli",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "05023053",
        name: "Nogara",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04022127",
        name: "Nogaredo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05023054",
        name: "Nogarole Rocca",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "05024072",
        name: "Nogarole Vicentino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "16072032",
        name: "Noicattaro",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15063050",
        name: "Nola",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01001166",
        name: "Nole",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07009042",
        name: "Noli",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01001167",
        name: "Nomaglio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "04022128",
        name: "Nomi",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08036027",
        name: "Nonantola",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "01001168",
        name: "None",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01103048",
        name: "Nonio",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "20091050",
        name: "Noragugume",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20095033",
        name: "Norbello",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "10054035",
        name: "Norcia",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "12059016",
        name: "Norma",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "03015155",
        name: "Nosate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "13067032",
        name: "Notaresco",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "19089013",
        name: "Noto",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "04021058",
        name: "Nova Levante",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03108035",
        name: "Nova Milanese",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "04021059",
        name: "Nova Ponente",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "17077018",
        name: "Nova Siri",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "08099023",
        name: "Novafeltria",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "04022129",
        name: "Novaledo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001169",
        name: "Novalesa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01003106",
        name: "Novara",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "19083062",
        name: "Novara di Sicilia",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03014046",
        name: "Novate Mezzola",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03015157",
        name: "Novate Milanese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05024073",
        name: "Nove",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03013163",
        name: "Novedrate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04022253",
        name: "Novella",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08035028",
        name: "Novellara",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "01004152",
        name: "Novello",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05027027",
        name: "Noventa di Piave",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "05028058",
        name: "Noventa Padovana",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05024074",
        name: "Noventa Vicentina",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "08036028",
        name: "Novi di Modena",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "01006114",
        name: "Novi Ligure",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15065080",
        name: "Novi Velia",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03015158",
        name: "Noviglio",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "16075055",
        name: "Novoli",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01004153",
        name: "Nucetto",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20090044",
        name: "Nughedu San Nicolò",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20095034",
        name: "Nughedu Santa Vittoria",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20090045",
        name: "Nule",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20090046",
        name: "Nulvi",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "11042032",
        name: "Numana",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "20091051",
        name: "Nuoro",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20095035",
        name: "Nurachi",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20111045",
        name: "Nuragus",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111046",
        name: "Nurallao",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111047",
        name: "Nuraminis",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20095036",
        name: "Nureci",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20111048",
        name: "Nurri",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "02007045",
        name: "Nus",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "15064066",
        name: "Nusco",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03017119",
        name: "Nuvolento",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017120",
        name: "Nuvolera",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20111049",
        name: "Nuxis",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01096040",
        name: "Occhieppo Inferiore",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01096041",
        name: "Occhieppo Superiore",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "05029033",
        name: "Occhiobello",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01006115",
        name: "Occimiano",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "13066059",
        name: "Ocre",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "01006116",
        name: "Odalengo Grande",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01006117",
        name: "Odalengo Piccolo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05026051",
        name: "Oderzo",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03017121",
        name: "Odolo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "13066060",
        name: "Ofena",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "11042033",
        name: "Offagna",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "03019062",
        name: "Offanengo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "11044054",
        name: "Offida",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "03017122",
        name: "Offlaga",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01103049",
        name: "Oggebbio",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03012107",
        name: "Oggiona con Santo Stefano",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03097057",
        name: "Oggiono",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01001170",
        name: "Oglianico",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15065081",
        name: "Ogliastro Cilento",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "20090047",
        name: "Olbia",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01002088",
        name: "Olcenengo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01002089",
        name: "Oldenico",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01003108",
        name: "Oleggio",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01003109",
        name: "Oleggio Castello",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03018104",
        name: "Olevano di Lomellina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "12058073",
        name: "Olevano Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15065082",
        name: "Olevano sul Tusciano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03013165",
        name: "Olgiate Comasco",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03097058",
        name: "Olgiate Molgora",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03012108",
        name: "Olgiate Olona",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03097059",
        name: "Olginate",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "20091055",
        name: "Oliena",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03018105",
        name: "Oliva Gessi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "18079088",
        name: "Olivadi",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "19083063",
        name: "Oliveri",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "15065083",
        name: "Oliveto Citra",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03097060",
        name: "Oliveto Lario",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "17077019",
        name: "Oliveto Lucano",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "07008038",
        name: "Olivetta San Michele",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01006118",
        name: "Olivola",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "20095037",
        name: "Ollastra",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20091056",
        name: "Ollolai",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "02007046",
        name: "Ollomont",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "20090048",
        name: "Olmedo",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03019063",
        name: "Olmeneta",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03016145",
        name: "Olmo al Brembo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01005081",
        name: "Olmo Gentile",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03016146",
        name: "Oltre il Colle",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016147",
        name: "Oltressenda Alta",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013169",
        name: "Oltrona di San Mamette",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "20091057",
        name: "Olzai",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03017123",
        name: "Ome",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01103050",
        name: "Omegna",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "15065084",
        name: "Omignano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "20091058",
        name: "Onanì",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "12056040",
        name: "Onano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "01004154",
        name: "Oncino",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03016148",
        name: "Oneta",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "20091059",
        name: "Onifai",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20091060",
        name: "Oniferi",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03017124",
        name: "Ono San Pietro",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03016149",
        name: "Onore",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "07009043",
        name: "Onzo",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03015159",
        name: "Opera",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "13066061",
        name: "Opi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "05023055",
        name: "Oppeano",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "17076056",
        name: "Oppido Lucano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "18080055",
        name: "Oppido Mamertina",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "04021060",
        name: "Ora",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20091061",
        name: "Orani",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "14070049",
        name: "Oratino",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01001171",
        name: "Orbassano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "09053018",
        name: "Orbetello",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "09050023",
        name: "Orciano Pisano",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "07009044",
        name: "Orco Feglino",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "16071063",
        name: "Ordona",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "07010042",
        name: "Orero",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "05024075",
        name: "Orgiano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "20091062",
        name: "Orgosolo",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "16074011",
        name: "Oria",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "13066062",
        name: "Oricola",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03012109",
        name: "Origgio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012110",
        name: "Orino",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03016150",
        name: "Orio al Serio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001172",
        name: "Orio Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03098042",
        name: "Orio Litta",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "18078087",
        name: "Oriolo",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12056041",
        name: "Oriolo Romano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "20095038",
        name: "Oristano",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01004155",
        name: "Ormea",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05026052",
        name: "Ormelle",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03108036",
        name: "Ornago",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "01103051",
        name: "Ornavasso",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03016151",
        name: "Ornica",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "20091063",
        name: "Orosei",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20091064",
        name: "Orotelli",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "15065085",
        name: "Orria",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "20111050",
        name: "Orroli",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "05026053",
        name: "Orsago",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01006119",
        name: "Orsara Bormida",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16071035",
        name: "Orsara di Puglia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03013170",
        name: "Orsenigo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "13069057",
        name: "Orsogna",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "18078088",
        name: "Orsomarso",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15061053",
        name: "Orta di Atella",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "16071036",
        name: "Orta Nova",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "01003112",
        name: "Orta San Giulio",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "20111051",
        name: "Ortacesus",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "12056042",
        name: "Orte",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "16075056",
        name: "Ortelle",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "11109029",
        name: "Ortezzano",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "09051027",
        name: "Ortignano Raggiolo",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "04021061",
        name: "Ortisei",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "13069058",
        name: "Ortona",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13066063",
        name: "Ortona dei Marsi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "07009045",
        name: "Ortovero",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "13066064",
        name: "Ortucchio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "20091066",
        name: "Ortueri",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20091067",
        name: "Orune",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "10055023",
        name: "Orvieto",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "12057047",
        name: "Orvinio",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03017125",
        name: "Orzinuovi",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017126",
        name: "Orzivecchi",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01001173",
        name: "Osasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001174",
        name: "Osasio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20090049",
        name: "Oschiri",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20091068",
        name: "Osidda",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "07009046",
        name: "Osiglia",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "20090050",
        name: "Osilo",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "11042034",
        name: "Osimo",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "20091069",
        name: "Osini",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03016152",
        name: "Osio Sopra",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016153",
        name: "Osio Sotto",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03097061",
        name: "Osnago",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "06030066",
        name: "Osoppo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "07008039",
        name: "Ospedaletti",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "04022130",
        name: "Ospedaletto",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15064067",
        name: "Ospedaletto d'Alpinolo",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "05028059",
        name: "Ospedaletto Euganeo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03098043",
        name: "Ospedaletto Lodigiano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "05025035",
        name: "Ospitale di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03017127",
        name: "Ospitaletto",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03098044",
        name: "Ossago Lodigiano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "04022131",
        name: "Ossana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20090051",
        name: "Ossi",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03017128",
        name: "Ossimo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03015164",
        name: "Ossona",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01004156",
        name: "Ostana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08038017",
        name: "Ostellato",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "03019064",
        name: "Ostiano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03020038",
        name: "Ostiglia",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "11042035",
        name: "Ostra",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "11042036",
        name: "Ostra Vetere",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "16074012",
        name: "Ostuni",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "16075057",
        name: "Otranto",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "10055024",
        name: "Otricoli",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "20091070",
        name: "Ottana",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "15065086",
        name: "Ottati",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15063051",
        name: "Ottaviano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01006120",
        name: "Ottiglio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018106",
        name: "Ottobiano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "08033030",
        name: "Ottone",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "01001175",
        name: "Oulx",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01006121",
        name: "Ovada",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "06030067",
        name: "Ovaro",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01006122",
        name: "Oviglio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "13066065",
        name: "Ovindoli",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "20091071",
        name: "Ovodda",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "02007047",
        name: "Oyace",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "01001176",
        name: "Ozegna",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20090052",
        name: "Ozieri",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "08037046",
        name: "Ozzano dell'Emilia",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "01006123",
        name: "Ozzano Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03015165",
        name: "Ozzero",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "20111052",
        name: "Pabillonis",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "19083064",
        name: "Pace del Mela",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19081013",
        name: "Paceco",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "13066066",
        name: "Pacentro",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "19089014",
        name: "Pachino",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "10054036",
        name: "Paciano",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03017129",
        name: "Padenghe sul Garda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01006124",
        name: "Paderna",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03097062",
        name: "Paderno d'Adda",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03015166",
        name: "Paderno Dugnano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03017130",
        name: "Paderno Franciacorta",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03019065",
        name: "Paderno Ponchielli",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05028060",
        name: "Padova",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "20090053",
        name: "Padria",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20090090",
        name: "Padru",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "15065087",
        name: "Padula",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15062045",
        name: "Paduli",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "01004157",
        name: "Paesana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05026055",
        name: "Paese",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "15065088",
        name: "Pagani",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "12057048",
        name: "Paganico Sabino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03016154",
        name: "Pagazzano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19083065",
        name: "Pagliara",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "13069059",
        name: "Paglieta",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "06030068",
        name: "Pagnacco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01004158",
        name: "Pagno",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03097063",
        name: "Pagnona",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "15064068",
        name: "Pago del Vallo di Lauro",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15062046",
        name: "Pago Veiano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03017131",
        name: "Paisco Loveno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017132",
        name: "Paitone",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03016155",
        name: "Paladina",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08036029",
        name: "Palagano",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "16073020",
        name: "Palagianello",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "16073021",
        name: "Palagiano",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "19087032",
        name: "Palagonia",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "09050024",
        name: "Palaia",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "08034026",
        name: "Palanzano",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "14070050",
        name: "Palata",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "20090054",
        name: "Palau",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03016156",
        name: "Palazzago",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19082052",
        name: "Palazzo Adriano",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "01001177",
        name: "Palazzo Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03019066",
        name: "Palazzo Pignano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "17076057",
        name: "Palazzo San Gervasio",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "19089015",
        name: "Palazzolo Acreide",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "06030069",
        name: "Palazzolo dello Stella",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03017133",
        name: "Palazzolo sull'Oglio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01002090",
        name: "Palazzolo Vercellese",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "09048031",
        name: "Palazzuolo sul Senio",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "13069060",
        name: "Palena",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "18079089",
        name: "Palermiti",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "19082053",
        name: "Palermo",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "12058074",
        name: "Palestrina",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03018107",
        name: "Palestro",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "12060046",
        name: "Paliano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "18080056",
        name: "Palizzi",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18101016",
        name: "Pallagorio",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "01103052",
        name: "Pallanzeno",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "07009047",
        name: "Pallare",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "15063052",
        name: "Palma Campania",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "19084027",
        name: "Palma di Montechiaro",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "06030070",
        name: "Palmanova",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "16075058",
        name: "Palmariggi",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "20095039",
        name: "Palmas Arborea",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "18080057",
        name: "Palmi",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "11044056",
        name: "Palmiano",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "13069061",
        name: "Palmoli",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "16072033",
        name: "Palo del Colle",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "12058075",
        name: "Palombara Sabina",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "13069062",
        name: "Palombaro",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15065089",
        name: "Palomonte",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03016157",
        name: "Palosco",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05023056",
        name: "Palù",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04022133",
        name: "Palù del Fersina",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18078089",
        name: "Paludi",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "06030071",
        name: "Paluzza",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01004159",
        name: "Pamparato",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001178",
        name: "Pancalieri",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018108",
        name: "Pancarana",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "04022134",
        name: "Panchià",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03019067",
        name: "Pandino",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18078090",
        name: "Panettieri",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "10054037",
        name: "Panicale",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "15062047",
        name: "Pannarano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "16071037",
        name: "Panni",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "19081014",
        name: "Pantelleria",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "03015167",
        name: "Pantigliate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "18078091",
        name: "Paola",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15062048",
        name: "Paolisi",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "18078092",
        name: "Papasidero",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "05029034",
        name: "Papozze",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "03015168",
        name: "Parabiago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "16075059",
        name: "Parabita",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03017134",
        name: "Paratico",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04021062",
        name: "Parcines",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001179",
        name: "Parella",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18078093",
        name: "Parenti",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15061054",
        name: "Parete",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01006125",
        name: "Pareto",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18102026",
        name: "Parghelia",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "03097064",
        name: "Parlasco",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "08034027",
        name: "Parma",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "01006126",
        name: "Parodi Ligure",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01004160",
        name: "Paroldo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15064069",
        name: "Parolise",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03018109",
        name: "Parona",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "10055025",
        name: "Parrano",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "03016158",
        name: "Parre",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19081015",
        name: "Partanna",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "19082054",
        name: "Partinico",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "01003114",
        name: "Paruzzaro",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03016159",
        name: "Parzanica",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "06030072",
        name: "Pasian di Prato",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06093029",
        name: "Pasiano di Pordenone",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03017135",
        name: "Paspardo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01005082",
        name: "Passerano Marmorito",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "10054038",
        name: "Passignano sul Trasimeno",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03017136",
        name: "Passirano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "12060047",
        name: "Pastena",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15061055",
        name: "Pastorano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "05023057",
        name: "Pastrengo",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01006127",
        name: "Pasturana",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03097065",
        name: "Pasturo",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "17076100",
        name: "Paterno",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "19087033",
        name: "Paternò",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "18078094",
        name: "Paterno Calabro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15064070",
        name: "Paternopoli",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "12060048",
        name: "Patrica",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "20090055",
        name: "Pattada",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "19083066",
        name: "Patti",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "16075060",
        name: "Patù",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "20095040",
        name: "Pau",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "06030073",
        name: "Paularo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20111053",
        name: "Pauli Arbarei",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20095041",
        name: "Paulilatino",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "03015169",
        name: "Paullo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "15062049",
        name: "Paupisi",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "01001180",
        name: "Pavarolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018110",
        name: "Pavia",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "06030074",
        name: "Pavia di Udine",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001181",
        name: "Pavone Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03017137",
        name: "Pavone del Mella",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "08036030",
        name: "Pavullo nel Frignano",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "18080058",
        name: "Pazzano",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "09050025",
        name: "Peccioli",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01006128",
        name: "Pecetto di Valenza",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01001183",
        name: "Pecetto Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19087034",
        name: "Pedara",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "11109030",
        name: "Pedaso",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "05025036",
        name: "Pedavena",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05024076",
        name: "Pedemonte",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05026056",
        name: "Pederobba",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03014047",
        name: "Pedesina",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "18078096",
        name: "Pedivigliano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03016160",
        name: "Pedrengo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013178",
        name: "Peglio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "11041041",
        name: "Peglio",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "03020039",
        name: "Pegognaga",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03016161",
        name: "Peia",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04022136",
        name: "Peio",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "09048032",
        name: "Pelago",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "01003115",
        name: "Pella",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "08034028",
        name: "Pellegrino Parmense",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "15065090",
        name: "Pellezzano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "04022137",
        name: "Pellizzano",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022138",
        name: "Pelugo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01005083",
        name: "Penango",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "10055026",
        name: "Penna in Teverina",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "11043035",
        name: "Penna San Giovanni",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "13067033",
        name: "Penna Sant'Andrea",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "08099024",
        name: "Pennabilli",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "13069063",
        name: "Pennadomo",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13069064",
        name: "Pennapiedimonte",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13068027",
        name: "Penne",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "18079092",
        name: "Pentone",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "13069065",
        name: "Perano",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "05025037",
        name: "Perarolo di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "04021063",
        name: "Perca",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "12058076",
        name: "Percile",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "20091072",
        name: "Perdasdefogu",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20111054",
        name: "Perdaxius",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "15065091",
        name: "Perdifumo",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13066067",
        name: "Pereto",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "20090056",
        name: "Perfugas",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "04022139",
        name: "Pergine Valsugana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11041043",
        name: "Pergola",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "07008040",
        name: "Perinaldo",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "15065092",
        name: "Perito",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03097067",
        name: "Perledo",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01004161",
        name: "Perletto",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004162",
        name: "Perlo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "02007048",
        name: "Perloz",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "05028061",
        name: "Pernumia",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03015170",
        name: "Pero",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01001184",
        name: "Perosa Argentina",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001185",
        name: "Perosa Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001186",
        name: "Perrero",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03019068",
        name: "Persico Dosimo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01002091",
        name: "Pertengo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03017139",
        name: "Pertica Alta",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017140",
        name: "Pertica Bassa",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15065093",
        name: "Pertosa",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01001187",
        name: "Pertusio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "10054039",
        name: "Perugia",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "11041044",
        name: "Pesaro",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "09046022",
        name: "Pescaglia",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "05023058",
        name: "Pescantina",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "13068028",
        name: "Pescara",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "03019069",
        name: "Pescarolo ed Uniti",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "13066068",
        name: "Pescasseroli",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03097068",
        name: "Pescate",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "14094031",
        name: "Pesche",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "16071038",
        name: "Peschici",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03015171",
        name: "Peschiera Borromeo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05023059",
        name: "Peschiera del Garda",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "09047012",
        name: "Pescia",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "13066069",
        name: "Pescina",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15062050",
        name: "Pesco Sannita",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "13066070",
        name: "Pescocostanzo",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "14094032",
        name: "Pescolanciano",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "17076058",
        name: "Pescopagano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "14094033",
        name: "Pescopennataro",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "12057049",
        name: "Pescorocchiano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "13068029",
        name: "Pescosansonesco",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "12060049",
        name: "Pescosolido",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "03015172",
        name: "Pessano con Bornago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03019070",
        name: "Pessina Cremonese",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01001188",
        name: "Pessinetto",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "14070051",
        name: "Petacciato",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "18101017",
        name: "Petilia Policastro",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "15065094",
        name: "Petina",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19082055",
        name: "Petralia Soprana",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "19082056",
        name: "Petralia Sottana",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "12057050",
        name: "Petrella Salto",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "14070052",
        name: "Petrella Tifernina",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "11041045",
        name: "Petriano",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11043036",
        name: "Petriolo",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "11109031",
        name: "Petritoli",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "18079094",
        name: "Petrizzi",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18079095",
        name: "Petronà",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "19081024",
        name: "Petrosino",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "15064071",
        name: "Petruro Irpino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01003116",
        name: "Pettenasco",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01096042",
        name: "Pettinengo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "19083067",
        name: "Pettineo",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "14094034",
        name: "Pettoranello del Molise",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "13066071",
        name: "Pettorano sul Gizio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "05029035",
        name: "Pettorazza Grimani",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01004163",
        name: "Peveragno",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01002093",
        name: "Pezzana",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03017141",
        name: "Pezzaze",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01004164",
        name: "Pezzolo Valle Uzzone",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08033032",
        name: "Piacenza",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "05028062",
        name: "Piacenza d'Adige",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03019116",
        name: "Piadena Drizzona",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "15065095",
        name: "Piaggine",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03017142",
        name: "Pian Camuno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "07009048",
        name: "Piana Crixia",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "19082057",
        name: "Piana degli Albanesi",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15061056",
        name: "Piana di Monte Verna",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "09052020",
        name: "Piancastagnaio",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "03017206",
        name: "Piancogno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "11041047",
        name: "Piandimeleto",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "18078097",
        name: "Piane Crati",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13068030",
        name: "Pianella",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "03013183",
        name: "Pianello del Lario",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "08033033",
        name: "Pianello Val Tidone",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03019072",
        name: "Pianengo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01001189",
        name: "Pianezza",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05024077",
        name: "Pianezze",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01004165",
        name: "Pianfei",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03016162",
        name: "Pianico",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05027028",
        name: "Pianiga",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "15063053",
        name: "Piano di Sorrento",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "18079096",
        name: "Pianopoli",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "08037047",
        name: "Pianoro",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "12056043",
        name: "Piansano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03014048",
        name: "Piantedo",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03016163",
        name: "Piario",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01004166",
        name: "Piasco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03014049",
        name: "Piateda",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01096043",
        name: "Piatto",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "09046023",
        name: "Piazza al Serchio",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "19086014",
        name: "Piazza Armerina",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "03016164",
        name: "Piazza Brembana",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016165",
        name: "Piazzatorre",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05028063",
        name: "Piazzola sul Brenta",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03016166",
        name: "Piazzolo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "13068031",
        name: "Picciano",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "17076059",
        name: "Picerno",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "12060050",
        name: "Picinisco",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "12060051",
        name: "Pico",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01005084",
        name: "Piea",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01096044",
        name: "Piedicavallo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "19087035",
        name: "Piedimonte Etneo",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "15061057",
        name: "Piedimonte Matese",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "12060052",
        name: "Piedimonte San Germano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01103053",
        name: "Piedimulera",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "10054040",
        name: "Piegaro",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "09052021",
        name: "Pienza",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "03019073",
        name: "Pieranica",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03018111",
        name: "Pietra de' Giorgi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "07009049",
        name: "Pietra Ligure",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01006129",
        name: "Pietra Marazzi",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "14094035",
        name: "Pietrabbondante",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "07008041",
        name: "Pietrabruna",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "13067034",
        name: "Pietracamela",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "14070053",
        name: "Pietracatella",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "14070054",
        name: "Pietracupa",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "15064072",
        name: "Pietradefusi",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "13069103",
        name: "Pietraferrazzana",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "18078098",
        name: "Pietrafitta",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "17076060",
        name: "Pietragalla",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "10054041",
        name: "Pietralunga",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "15061058",
        name: "Pietramelara",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "16071039",
        name: "Pietramontecorvino",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "13068032",
        name: "Pietranico",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "18078099",
        name: "Pietrapaola",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "17076061",
        name: "Pietrapertosa",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "19086015",
        name: "Pietraperzia",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "01004167",
        name: "Pietraporzio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15062051",
        name: "Pietraroja",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "11041048",
        name: "Pietrarubbia",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "09046024",
        name: "Pietrasanta",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "15064073",
        name: "Pietrastornina",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15061059",
        name: "Pietravairano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15062052",
        name: "Pietrelcina",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "09047013",
        name: "Pieve a Nievole",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "03018112",
        name: "Pieve Albignola",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03019074",
        name: "Pieve d'Olmi",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03018113",
        name: "Pieve del Cairo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05026096",
        name: "Pieve del Grappa",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "04022234",
        name: "Pieve di Bono-Prezzo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05025039",
        name: "Pieve di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "08037048",
        name: "Pieve di Cento",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "05026057",
        name: "Pieve di Soligo",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "07008042",
        name: "Pieve di Teco",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "03015173",
        name: "Pieve Emanuele",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03098045",
        name: "Pieve Fissiraga",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "09046025",
        name: "Pieve Fosciana",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "07010043",
        name: "Pieve Ligure",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03018114",
        name: "Pieve Porto Morone",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03019075",
        name: "Pieve San Giacomo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "09051030",
        name: "Pieve Santo Stefano",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "04022142",
        name: "Pieve Tesino",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11043038",
        name: "Pieve Torina",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "01103054",
        name: "Pieve Vergonte",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "08036031",
        name: "Pievepelago",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "12060053",
        name: "Piglio",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "07008043",
        name: "Pigna",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "12060054",
        name: "Pignataro Interamna",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15061060",
        name: "Pignataro Maggiore",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "17076062",
        name: "Pignola",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "07011021",
        name: "Pignone",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "03013184",
        name: "Pigra",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01002096",
        name: "Pila",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "20111055",
        name: "Pimentel",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "15063054",
        name: "Pimonte",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03018115",
        name: "Pinarolo Po",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001190",
        name: "Pinasca",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05029036",
        name: "Pincara",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01001191",
        name: "Pinerolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "13067035",
        name: "Pineto",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "01005085",
        name: "Pino d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001192",
        name: "Pino Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "06093030",
        name: "Pinzano al Tagliamento",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04022143",
        name: "Pinzolo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11041049",
        name: "Piobbico",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "01004168",
        name: "Piobesi d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001193",
        name: "Piobesi Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002097",
        name: "Piode",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03015175",
        name: "Pioltello",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "09049012",
        name: "Piombino",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "05028064",
        name: "Piombino Dese",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "11043039",
        name: "Pioraco",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "01001194",
        name: "Piossasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01005086",
        name: "Piovà Massaia",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05028065",
        name: "Piove di Sacco",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05024078",
        name: "Piovene Rocchette",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "08033034",
        name: "Piozzano",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "01004169",
        name: "Piozzo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19083068",
        name: "Piraino",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "09050026",
        name: "Pisa",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01003119",
        name: "Pisano",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01001195",
        name: "Piscina",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20111056",
        name: "Piscinas",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "15065096",
        name: "Pisciotta",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03017143",
        name: "Pisogne",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "12058077",
        name: "Pisoniano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "17077020",
        name: "Pisticci",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "09047014",
        name: "Pistoia",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "09053019",
        name: "Pitigliano",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "03020041",
        name: "Piubega",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03014050",
        name: "Piuro",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01001196",
        name: "Piverone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018116",
        name: "Pizzale",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03019076",
        name: "Pizzighettone",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18102027",
        name: "Pizzo",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "13069066",
        name: "Pizzoferrato",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13066072",
        name: "Pizzoli",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "14094036",
        name: "Pizzone",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "18102028",
        name: "Pizzoni",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "18080059",
        name: "Placanica",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18078100",
        name: "Plataci",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18079099",
        name: "Platania",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18080060",
        name: "Platì",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "04021064",
        name: "Plaus",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03013185",
        name: "Plesio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "20090057",
        name: "Ploaghe",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "07009050",
        name: "Plodio",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01004170",
        name: "Pocapaglia",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "06030075",
        name: "Pocenia",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "09045013",
        name: "Podenzana",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "08033035",
        name: "Podenzano",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "12060055",
        name: "Pofi",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "16075061",
        name: "Poggiardo",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "09052022",
        name: "Poggibonsi",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09100004",
        name: "Poggio a Caiano",
        districtInitials: "PO",
        district: "Prato",
        region: "Toscana"
    },
    {
        code: "12057051",
        name: "Poggio Bustone",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "12057052",
        name: "Poggio Catino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "16071040",
        name: "Poggio Imperiale",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "12057053",
        name: "Poggio Mirteto",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "12057054",
        name: "Poggio Moiano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "12057055",
        name: "Poggio Nativo",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "13066073",
        name: "Poggio Picenze",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "08038018",
        name: "Poggio Renatico",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "03020042",
        name: "Poggio Rusco",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "12057056",
        name: "Poggio San Lorenzo",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "11042037",
        name: "Poggio San Marcello",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "11043040",
        name: "Poggio San Vicino",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "14094037",
        name: "Poggio Sannita",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "08099028",
        name: "Poggio Torriana",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "10054042",
        name: "Poggiodomo",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "13069067",
        name: "Poggiofiorito",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15063055",
        name: "Poggiomarino",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "19081016",
        name: "Poggioreale",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "16072034",
        name: "Poggiorsini",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "03014051",
        name: "Poggiridenti",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03015176",
        name: "Pogliano Milanese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03013186",
        name: "Pognana Lario",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016167",
        name: "Pognano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01003120",
        name: "Pogno",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01001197",
        name: "Poirino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05024079",
        name: "Pojana Maggiore",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03017144",
        name: "Polaveno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "06093031",
        name: "Polcenigo",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05029037",
        name: "Polesella",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "08034050",
        name: "Polesine Zibello",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "12058078",
        name: "Poli",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "18102029",
        name: "Polia",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "17077021",
        name: "Policoro",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "16072035",
        name: "Polignano a Mare",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "08036032",
        name: "Polinago",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "10055027",
        name: "Polino",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "18080061",
        name: "Polistena",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19082058",
        name: "Polizzi Generosa",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15065097",
        name: "Polla",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "02007049",
        name: "Pollein",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "15063056",
        name: "Pollena Trocchia",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "11043041",
        name: "Pollenza",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "15065098",
        name: "Pollica",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19082059",
        name: "Pollina",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "01096046",
        name: "Pollone",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "13069068",
        name: "Pollutri",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01004171",
        name: "Polonghera",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017145",
        name: "Polpenazze del Garda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05028066",
        name: "Polverara",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "11042038",
        name: "Polverigi",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "09050027",
        name: "Pomarance",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01001198",
        name: "Pomaretto",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "17077022",
        name: "Pomarico",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "01006131",
        name: "Pomaro Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "04022144",
        name: "Pomarolo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01003121",
        name: "Pombia",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "12058079",
        name: "Pomezia",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15063057",
        name: "Pomigliano d'Arco",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15063058",
        name: "Pompei",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "07008044",
        name: "Pompeiana",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "03017146",
        name: "Pompiano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03020043",
        name: "Pomponesco",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "20095042",
        name: "Pompu",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "03017147",
        name: "Poncarale",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01096047",
        name: "Ponderano",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03013187",
        name: "Ponna",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "09050028",
        name: "Ponsacco",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "05028067",
        name: "Ponso",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01001199",
        name: "Pont-Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "02007052",
        name: "Pont-Saint-Martin",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "09048033",
        name: "Pontassieve",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "02007050",
        name: "Pontboset",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "15062053",
        name: "Ponte",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "09047016",
        name: "Ponte Buggianese",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "08033036",
        name: "Ponte dell'Olio",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03017148",
        name: "Ponte di Legno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05026058",
        name: "Ponte di Piave",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "04021065",
        name: "Ponte Gardena",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03014052",
        name: "Ponte in Valtellina",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03013188",
        name: "Ponte Lambro",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05025040",
        name: "Ponte nelle Alpi",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03018117",
        name: "Ponte Nizza",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03016168",
        name: "Ponte Nossa",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05028069",
        name: "Ponte San Nicolò",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03016170",
        name: "Ponte San Pietro",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "06030076",
        name: "Pontebba",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15065099",
        name: "Pontecagnano Faiano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05029038",
        name: "Pontecchio Polesine",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01004172",
        name: "Pontechianale",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "12060056",
        name: "Pontecorvo",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01006132",
        name: "Pontecurone",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "07008045",
        name: "Pontedassio",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "09050029",
        name: "Pontedera",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "15062054",
        name: "Pontelandolfo",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15061061",
        name: "Pontelatone",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "05028068",
        name: "Pontelongo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "08033037",
        name: "Pontenure",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03016169",
        name: "Ponteranica",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01006133",
        name: "Pontestura",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03017149",
        name: "Pontevico",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "02007051",
        name: "Pontey",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "01006134",
        name: "Ponti",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03020044",
        name: "Ponti sul Mincio",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03016171",
        name: "Pontida",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12059017",
        name: "Pontinia",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "07009051",
        name: "Pontinvrea",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03016172",
        name: "Pontirolo Nuovo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03017150",
        name: "Pontoglio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "09045014",
        name: "Pontremoli",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "12059018",
        name: "Ponza",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "11109032",
        name: "Ponzano di Fermo",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "01006135",
        name: "Ponzano Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "12058080",
        name: "Ponzano Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05026059",
        name: "Ponzano Veneto",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01006136",
        name: "Ponzone",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "13068033",
        name: "Popoli",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "09051031",
        name: "Poppi",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "10055028",
        name: "Porano",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "09046026",
        name: "Porcari",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "06093032",
        name: "Porcia",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06093033",
        name: "Pordenone",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03013189",
        name: "Porlezza",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "07008046",
        name: "Pornassio",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "06030077",
        name: "Porpetto",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01005087",
        name: "Portacomaro",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03018118",
        name: "Portalbera",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001200",
        name: "Porte",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "04022244",
        name: "Porte di Rendena",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15063059",
        name: "Portici",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15061062",
        name: "Portico di Caserta",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "08040031",
        name: "Portico e San Benedetto",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "18080062",
        name: "Portigliola",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "09049013",
        name: "Porto Azzurro",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "03012113",
        name: "Porto Ceresio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "16075097",
        name: "Porto Cesareo",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "19084028",
        name: "Porto Empedocle",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "03020045",
        name: "Porto Mantovano",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "11043042",
        name: "Porto Recanati",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "11109033",
        name: "Porto San Giorgio",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "11109034",
        name: "Porto Sant'Elpidio",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "05029039",
        name: "Porto Tolle",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "20090058",
        name: "Porto Torres",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03012114",
        name: "Porto Valtravaglia",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05029052",
        name: "Porto Viro",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "05026060",
        name: "Portobuffolè",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "14070055",
        name: "Portocannone",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "09049014",
        name: "Portoferraio",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "07010044",
        name: "Portofino",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "05027029",
        name: "Portogruaro",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "08038019",
        name: "Portomaggiore",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "19089020",
        name: "Portopalo di Capo Passero",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "20111057",
        name: "Portoscuso",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "07011022",
        name: "Portovenere",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "01096048",
        name: "Portula",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "20091073",
        name: "Posada",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "05024080",
        name: "Posina",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "15065100",
        name: "Positano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05026061",
        name: "Possagno",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "12057057",
        name: "Posta",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "12060057",
        name: "Posta Fibreno",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "04021066",
        name: "Postal",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03014053",
        name: "Postalesio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "15065101",
        name: "Postiglione",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01002102",
        name: "Postua",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "17076063",
        name: "Potenza",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "11043043",
        name: "Potenza Picena",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "05024081",
        name: "Pove del Grappa",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05026062",
        name: "Povegliano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "05023060",
        name: "Povegliano Veronese",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "08035029",
        name: "Poviglio",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "06030078",
        name: "Povoletto",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12057058",
        name: "Pozzaglia Sabina",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03019077",
        name: "Pozzaglio ed Uniti",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "19088008",
        name: "Pozzallo",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "14094038",
        name: "Pozzilli",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "03015177",
        name: "Pozzo d'Adda",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01006137",
        name: "Pozzol Groppo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03017151",
        name: "Pozzolengo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05024082",
        name: "Pozzoleone",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01006138",
        name: "Pozzolo Formigaro",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "20090059",
        name: "Pozzomaggiore",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "05028070",
        name: "Pozzonovo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "15063060",
        name: "Pozzuoli",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "06030079",
        name: "Pozzuolo del Friuli",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03015178",
        name: "Pozzuolo Martesana",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03016173",
        name: "Pradalunga",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "06030080",
        name: "Pradamano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01004173",
        name: "Pradleves",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001201",
        name: "Pragelato",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18078101",
        name: "Praia a Mare",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15065102",
        name: "Praiano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03017152",
        name: "Pralboino",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01001202",
        name: "Prali",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001203",
        name: "Pralormo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01096049",
        name: "Pralungo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "05027030",
        name: "Pramaggiore",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "01001204",
        name: "Pramollo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002104",
        name: "Prarolo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01001205",
        name: "Prarostino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01006139",
        name: "Prasco",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01001206",
        name: "Prascorsano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03014054",
        name: "Prata Camportaccio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "13066074",
        name: "Prata d'Ansidonia",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "06093034",
        name: "Prata di Pordenone",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15064074",
        name: "Prata di Principato Ultra",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15061063",
        name: "Prata Sannita",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15061064",
        name: "Pratella",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01001207",
        name: "Pratiglione",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "09100005",
        name: "Prato",
        districtInitials: "PO",
        district: "Prato",
        region: "Toscana"
    },
    {
        code: "04021067",
        name: "Prato allo Stelvio",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06030081",
        name: "Prato Carnico",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01003122",
        name: "Prato Sesia",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "13066075",
        name: "Pratola Peligna",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15064075",
        name: "Pratola Serra",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "09051041",
        name: "Pratovecchio Stia",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "06093035",
        name: "Pravisdomini",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01096050",
        name: "Pray",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01004174",
        name: "Prazzo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "02007053",
        name: "Pré-Saint-Didier",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "06030082",
        name: "Precenicco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "10054043",
        name: "Preci",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "04022230",
        name: "Predaia",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08040032",
        name: "Predappio",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "04022147",
        name: "Predazzo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04021068",
        name: "Predoi",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03016174",
        name: "Predore",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01006140",
        name: "Predosa",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05026063",
        name: "Preganziol",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03015179",
        name: "Pregnana Milanese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "07008047",
        name: "Prelà",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "03097069",
        name: "Premana",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "06030083",
        name: "Premariacco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01103055",
        name: "Premeno",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01103056",
        name: "Premia",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "08040033",
        name: "Premilcuore",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "03016175",
        name: "Premolo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01103057",
        name: "Premosello-Chiovenda",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "06030084",
        name: "Preone",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06030085",
        name: "Prepotto",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03017153",
        name: "Preseglie",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15061065",
        name: "Presenzano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03016176",
        name: "Presezzo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "16075098",
        name: "Presicce-Acquarica",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "05023061",
        name: "Pressana",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "13069069",
        name: "Pretoro",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "03017155",
        name: "Prevalle",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "13066076",
        name: "Prezza",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "01004175",
        name: "Priero",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15065103",
        name: "Prignano Cilento",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "08036033",
        name: "Prignano sulla Secchia",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "03097070",
        name: "Primaluna",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "04022245",
        name: "Primiero San Martino di Castrozza",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004176",
        name: "Priocca",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004177",
        name: "Priola",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19089021",
        name: "Priolo Gargallo",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "12059019",
        name: "Priverno",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "19082060",
        name: "Prizzi",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "12056044",
        name: "Proceno",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "15063061",
        name: "Procida",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "07010045",
        name: "Propata",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03013192",
        name: "Proserpio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "12059020",
        name: "Prossedi",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "03017156",
        name: "Provaglio d'Iseo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017157",
        name: "Provaglio Val Sabbia",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04021069",
        name: "Proves",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "14070056",
        name: "Provvidenti",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01004178",
        name: "Prunetto",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017158",
        name: "Puegnago del Garda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15062055",
        name: "Puglianello",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "20092050",
        name: "Pula",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "06030086",
        name: "Pulfero",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "16073022",
        name: "Pulsano",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "03016177",
        name: "Pumenengo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013193",
        name: "Pusiano",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "20090060",
        name: "Putifigari",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "16072036",
        name: "Putignano",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15064076",
        name: "Quadrelle",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "13069070",
        name: "Quadri",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01001208",
        name: "Quagliuzzo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15063062",
        name: "Qualiano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01005088",
        name: "Quaranti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01096087",
        name: "Quaregna Cerreto",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01006141",
        name: "Quargnento",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01103058",
        name: "Quarna Sopra",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01103059",
        name: "Quarna Sotto",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01002107",
        name: "Quarona",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "09047017",
        name: "Quarrata",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "02007054",
        name: "Quart",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "15063063",
        name: "Quarto",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "05027031",
        name: "Quarto d'Altino",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "20092051",
        name: "Quartu Sant'Elena",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "20092105",
        name: "Quartucciu",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "01001209",
        name: "Quassolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01006142",
        name: "Quattordio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "08035030",
        name: "Quattro Castella",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "05025070",
        name: "Quero Vas",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "07009052",
        name: "Quiliano",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01001210",
        name: "Quincinetto",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15064077",
        name: "Quindici",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03020046",
        name: "Quingentole",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03019078",
        name: "Quintano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05026064",
        name: "Quinto di Treviso",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01002108",
        name: "Quinto Vercellese",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "05024083",
        name: "Quinto Vicentino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03017159",
        name: "Quinzano d'Oglio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03020047",
        name: "Quistello",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "04022150",
        name: "Rabbi",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "16075063",
        name: "Racale",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "19084029",
        name: "Racalmuto",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "01004179",
        name: "Racconigi",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19083069",
        name: "Raccuja",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "04021070",
        name: "Racines",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "09052023",
        name: "Radda in Chianti",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "19087036",
        name: "Raddusa",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "09052024",
        name: "Radicofani",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09052025",
        name: "Radicondoli",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "19084030",
        name: "Raffadali",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "19087058",
        name: "Ragalna",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "06030087",
        name: "Ragogna",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19088009",
        name: "Ragusa",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "13066077",
        name: "Raiano",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "19087037",
        name: "Ramacca",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "03012115",
        name: "Rancio Valcuvia",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012116",
        name: "Ranco",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "19087038",
        name: "Randazzo",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "03016178",
        name: "Ranica",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016179",
        name: "Ranzanico",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "07008048",
        name: "Ranzo",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "11109035",
        name: "Rapagnano",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "07010046",
        name: "Rapallo",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "13069071",
        name: "Rapino",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "09052026",
        name: "Rapolano Terme",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "17076064",
        name: "Rapolla",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "17076065",
        name: "Rapone",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "01002110",
        name: "Rassa",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "04021071",
        name: "Rasun-Anterselva",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03014055",
        name: "Rasura",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "19084031",
        name: "Ravanusa",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "08036034",
        name: "Ravarino",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "06030088",
        name: "Ravascletto",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15065104",
        name: "Ravello",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "08039014",
        name: "Ravenna",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "06030089",
        name: "Raveo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15061066",
        name: "Raviscanina",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01103060",
        name: "Re",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03018119",
        name: "Rea",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19084032",
        name: "Realmonte",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "06030090",
        name: "Reana del Rojale",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001211",
        name: "Reano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15061067",
        name: "Recale",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "11043044",
        name: "Recanati",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "07010047",
        name: "Recco",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01003129",
        name: "Recetto",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "05024084",
        name: "Recoaro Terme",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03018120",
        name: "Redavalle",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03020048",
        name: "Redondesco",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01005089",
        name: "Refrancore",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05026065",
        name: "Refrontolo",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "19086016",
        name: "Regalbuto",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "09048035",
        name: "Reggello",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "18080063",
        name: "Reggio di Calabria",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "08035033",
        name: "Reggio nell'Emilia",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "08035032",
        name: "Reggiolo",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "15062056",
        name: "Reino",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "19083070",
        name: "Reitano",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "06030091",
        name: "Remanzacco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03017160",
        name: "Remedello",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03108037",
        name: "Renate",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "18078102",
        name: "Rende",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "04021072",
        name: "Renon",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05026066",
        name: "Resana",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03015181",
        name: "Rescaldina",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "06030092",
        name: "Resia",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06030093",
        name: "Resiutta",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19085014",
        name: "Resuttano",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "03018121",
        name: "Retorbido",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01004180",
        name: "Revello",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01005090",
        name: "Revigliasco d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05026067",
        name: "Revine Lago",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03013195",
        name: "Rezzago",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03017161",
        name: "Rezzato",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "07008049",
        name: "Rezzo",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "07010048",
        name: "Rezzoaglio",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "02007055",
        name: "Rhêmes-Notre-Dame",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007056",
        name: "Rhêmes-Saint-Georges",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03015182",
        name: "Rho",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "18080064",
        name: "Riace",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "07009053",
        name: "Rialto",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "12058081",
        name: "Riano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15061068",
        name: "Riardo",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "19084033",
        name: "Ribera",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "01001212",
        name: "Ribordone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18102030",
        name: "Ricadi",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "01006143",
        name: "Ricaldone",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "14070057",
        name: "Riccia",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "08099013",
        name: "Riccione",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "07011023",
        name: "Riccò del Golfo di Spezia",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "03019079",
        name: "Ricengo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "15065105",
        name: "Ricigliano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05026068",
        name: "Riese Pio X",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "19085015",
        name: "Riesi",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "12057059",
        name: "Rieti",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "04021073",
        name: "Rifiano",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004181",
        name: "Rifreddo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "12058082",
        name: "Rignano Flaminio",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "16071041",
        name: "Rignano Garganico",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "09048036",
        name: "Rignano sull'Arno",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "06030094",
        name: "Rigolato",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01002113",
        name: "Rimella",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "08099014",
        name: "Rimini",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "09049021",
        name: "Rio",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "04021074",
        name: "Rio di Pusteria",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08035034",
        name: "Rio Saliceto",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "12058083",
        name: "Riofreddo",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "20095043",
        name: "Riola Sardo",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "08039015",
        name: "Riolo Terme",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "08036035",
        name: "Riolunato",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "07011024",
        name: "Riomaggiore",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "17076066",
        name: "Rionero in Vulture",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "14094039",
        name: "Rionero Sannitico",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "13069072",
        name: "Ripa Teatina",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "14070058",
        name: "Ripabottoni",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "17076067",
        name: "Ripacandida",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "14070059",
        name: "Ripalimosani",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03019080",
        name: "Ripalta Arpina",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03019081",
        name: "Ripalta Cremasca",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03019082",
        name: "Ripalta Guerina",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "09050030",
        name: "Riparbella",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "11044063",
        name: "Ripatransone",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "11043045",
        name: "Ripe San Ginesio",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "12060058",
        name: "Ripi",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "19087039",
        name: "Riposto",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "01004182",
        name: "Rittana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "04022153",
        name: "Riva del Garda",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08038029",
        name: "Riva del Po",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "03016180",
        name: "Riva di Solto",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "07008050",
        name: "Riva Ligure",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01001215",
        name: "Riva presso Chieri",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001213",
        name: "Rivalba",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01006144",
        name: "Rivalta Bormida",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01001214",
        name: "Rivalta di Torino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05025043",
        name: "Rivamonte Agordino",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03018122",
        name: "Rivanazzano Terme",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001216",
        name: "Rivara",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001217",
        name: "Rivarolo Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03019083",
        name: "Rivarolo del Re ed Uniti",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03020050",
        name: "Rivarolo Mantovano",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01006145",
        name: "Rivarone",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01001218",
        name: "Rivarossa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002115",
        name: "Rive",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "06030095",
        name: "Rive d'Arcano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "17076068",
        name: "Rivello",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "08033038",
        name: "Rivergaro",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "06030188",
        name: "Rivignano Teor",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "13066078",
        name: "Rivisondoli",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "12057060",
        name: "Rivodutri",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "01001219",
        name: "Rivoli",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05023062",
        name: "Rivoli Veronese",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03019084",
        name: "Rivolta d'Adda",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18080065",
        name: "Rizziconi",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "05024085",
        name: "Roana",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01004183",
        name: "Roaschia",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004184",
        name: "Roascio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01002116",
        name: "Roasio",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01005091",
        name: "Roatto",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001220",
        name: "Robassomero",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03097071",
        name: "Robbiate",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03018123",
        name: "Robbio",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03015183",
        name: "Robecchetto con Induno",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03019085",
        name: "Robecco d'Oglio",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03018124",
        name: "Robecco Pavese",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03015184",
        name: "Robecco sul Naviglio",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01005092",
        name: "Robella",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01004185",
        name: "Robilante",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004186",
        name: "Roburent",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001221",
        name: "Rocca Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12058084",
        name: "Rocca Canterano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01004188",
        name: "Rocca Cigliè",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01005093",
        name: "Rocca d'Arazzo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "12060059",
        name: "Rocca d'Arce",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15061069",
        name: "Rocca d'Evandro",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01004189",
        name: "Rocca de' Baldi",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03018125",
        name: "Rocca de' Giorgi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "13066080",
        name: "Rocca di Botte",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "13066081",
        name: "Rocca di Cambio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "12058085",
        name: "Rocca di Cave",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "13066082",
        name: "Rocca di Mezzo",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "18101019",
        name: "Rocca di Neto",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "12058086",
        name: "Rocca di Papa",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01006147",
        name: "Rocca Grimalda",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18078103",
        name: "Rocca Imperiale",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12059022",
        name: "Rocca Massima",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "13066083",
        name: "Rocca Pia",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "05025044",
        name: "Rocca Pietore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "12058088",
        name: "Rocca Priora",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "08040036",
        name: "Rocca San Casciano",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "15064079",
        name: "Rocca San Felice",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "13069074",
        name: "Rocca San Giovanni",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13067036",
        name: "Rocca Santa Maria",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "12058089",
        name: "Rocca Santo Stefano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "12057062",
        name: "Rocca Sinibalda",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03018126",
        name: "Rocca Susella",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "15064078",
        name: "Roccabascerana",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18101018",
        name: "Roccabernarda",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "08034030",
        name: "Roccabianca",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "01004187",
        name: "Roccabruna",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13066079",
        name: "Roccacasale",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15065106",
        name: "Roccadaspide",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19083071",
        name: "Roccafiorita",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "11044064",
        name: "Roccafluvione",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "18080066",
        name: "Roccaforte del Greco",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "01006146",
        name: "Roccaforte Ligure",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01004190",
        name: "Roccaforte Mondovì",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "16073023",
        name: "Roccaforzata",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "03017162",
        name: "Roccafranca",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "12058087",
        name: "Roccagiovine",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15065107",
        name: "Roccagloriosa",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "12059021",
        name: "Roccagorga",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "09053020",
        name: "Roccalbegna",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "19083072",
        name: "Roccalumera",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "14094040",
        name: "Roccamandolfi",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "19082061",
        name: "Roccamena",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15061070",
        name: "Roccamonfina",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "13069073",
        name: "Roccamontepiano",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13068034",
        name: "Roccamorice",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "17076069",
        name: "Roccanova",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "12057061",
        name: "Roccantica",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "19082062",
        name: "Roccapalumba",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15065108",
        name: "Roccapiemonte",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15063065",
        name: "Roccarainola",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "13066084",
        name: "Roccaraso",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15061071",
        name: "Roccaromana",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "13069075",
        name: "Roccascalegna",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "12060060",
        name: "Roccasecca",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "12059023",
        name: "Roccasecca dei Volsci",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "14094041",
        name: "Roccasicura",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "01004191",
        name: "Roccasparvera",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13069076",
        name: "Roccaspinalveti",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "09053021",
        name: "Roccastrada",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "19083073",
        name: "Roccavaldina",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01005094",
        name: "Roccaverano",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "07009054",
        name: "Roccavignale",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "01004192",
        name: "Roccavione",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "14070060",
        name: "Roccavivara",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "18080067",
        name: "Roccella Ionica",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19083074",
        name: "Roccella Valdemone",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "14094042",
        name: "Rocchetta a Volturno",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "01004193",
        name: "Rocchetta Belbo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "07011025",
        name: "Rocchetta di Vara",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "15061072",
        name: "Rocchetta e Croce",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01006148",
        name: "Rocchetta Ligure",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "07008051",
        name: "Rocchetta Nervina",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01005095",
        name: "Rocchetta Palafea",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "16071042",
        name: "Rocchetta Sant'Antonio",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "01005096",
        name: "Rocchetta Tanaro",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03015185",
        name: "Rodano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01004194",
        name: "Roddi",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004195",
        name: "Roddino",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004196",
        name: "Rodello",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "04021075",
        name: "Rodengo",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03017163",
        name: "Rodengo Saiano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03013197",
        name: "Rodero",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "16071043",
        name: "Rodi Garganico",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "19083075",
        name: "Rodì Milici",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03020051",
        name: "Rodigo",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03017164",
        name: "Roè Volciano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15065109",
        name: "Rofrano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03097072",
        name: "Rogeno",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "18078104",
        name: "Roggiano Gravina",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18080068",
        name: "Roghudi",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18078105",
        name: "Rogliano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03018127",
        name: "Rognano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03016182",
        name: "Rogno",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03014056",
        name: "Rogolo",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "12058090",
        name: "Roiate",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "13069077",
        name: "Roio del Sangro",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "02007057",
        name: "Roisan",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "01001222",
        name: "Roletto",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08035035",
        name: "Rolo",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "12058091",
        name: "Roma",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15065110",
        name: "Romagnano al Monte",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01003130",
        name: "Romagnano Sesia",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03018128",
        name: "Romagnese",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "20090061",
        name: "Romana",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03019086",
        name: "Romanengo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01001223",
        name: "Romano Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05024086",
        name: "Romano d'Ezzelino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03016183",
        name: "Romano di Lombardia",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "06031015",
        name: "Romans d'Isonzo",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "18102031",
        name: "Rombiolo",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "04022155",
        name: "Romeno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01003131",
        name: "Romentino",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "19083076",
        name: "Rometta",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03013199",
        name: "Ronago",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05023063",
        name: "Roncà",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "05026069",
        name: "Roncade",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03017165",
        name: "Roncadelle",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03018129",
        name: "Roncaro",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "04022156",
        name: "Roncegno Terme",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03108055",
        name: "Roncello",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "06031016",
        name: "Ronchi dei Legionari",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04022157",
        name: "Ronchi Valsugana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06030097",
        name: "Ronchis",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12056045",
        name: "Ronciglione",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "05023064",
        name: "Ronco all'Adige",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01096053",
        name: "Ronco Biellese",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03108038",
        name: "Ronco Briantino",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "01001224",
        name: "Ronco Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07010049",
        name: "Ronco Scrivia",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03016184",
        name: "Roncobello",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03020052",
        name: "Roncoferraro",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "08040037",
        name: "Roncofreddo",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "03016185",
        name: "Roncola",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "07010050",
        name: "Rondanina",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01001225",
        name: "Rondissone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002118",
        name: "Ronsecco",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "04022135",
        name: "Ronzo-Chienis",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022159",
        name: "Ronzone",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01096054",
        name: "Roppolo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01001226",
        name: "Rorà",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05024087",
        name: "Rosà",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "18080069",
        name: "Rosarno",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03018130",
        name: "Rosasco",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03015188",
        name: "Rosate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01096055",
        name: "Rosazza",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "13068035",
        name: "Rosciano",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "15065111",
        name: "Roscigno",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "18078106",
        name: "Rose",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13069078",
        name: "Rosello",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "18078107",
        name: "Roseto Capo Spulico",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13067037",
        name: "Roseto degli Abruzzi",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "16071044",
        name: "Roseto Valfortore",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "09049017",
        name: "Rosignano Marittimo",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "01006149",
        name: "Rosignano Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05029040",
        name: "Rosolina",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "19089016",
        name: "Rosolini",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "11042040",
        name: "Rosora",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01002121",
        name: "Rossa",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01004197",
        name: "Rossana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05024088",
        name: "Rossano Veneto",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "07010051",
        name: "Rossiglione",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01001228",
        name: "Rosta",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03016186",
        name: "Rota d'Imagna",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "18078109",
        name: "Rota Greca",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "11044065",
        name: "Rotella",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "14070061",
        name: "Rotello",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "17076070",
        name: "Rotonda",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "17077023",
        name: "Rotondella",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "15064080",
        name: "Rotondi",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "08033039",
        name: "Rottofreno",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "05024089",
        name: "Rotzo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01001227",
        name: "Roure",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002122",
        name: "Rovasenda",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03017166",
        name: "Rovato",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "07010052",
        name: "Rovegno",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03013201",
        name: "Rovellasca",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03013202",
        name: "Rovello Porro",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03020053",
        name: "Roverbella",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "05023065",
        name: "Roverchiara",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04022160",
        name: "Roverè della Luna",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05023067",
        name: "Roverè Veronese",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "05023066",
        name: "Roveredo di Guà",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "06093036",
        name: "Roveredo in Piano",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04022161",
        name: "Rovereto",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03018131",
        name: "Rovescala",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03016187",
        name: "Rovetta",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12058092",
        name: "Roviano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05029041",
        name: "Rovigo",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "18078110",
        name: "Rovito",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "05028071",
        name: "Rovolon",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03015189",
        name: "Rozzano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05028072",
        name: "Rubano",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01001229",
        name: "Rubiana",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08035036",
        name: "Rubiera",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "06030098",
        name: "Ruda",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03017167",
        name: "Rudiano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01001230",
        name: "Rueglio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16075064",
        name: "Ruffano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01004198",
        name: "Ruffia",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "04022162",
        name: "Ruffrè-Mendola",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "09048037",
        name: "Rufina",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "20095044",
        name: "Ruinas",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "04022163",
        name: "Rumo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "17076071",
        name: "Ruoti",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "08039016",
        name: "Russi",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "16072037",
        name: "Rutigliano",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "15065112",
        name: "Rutino",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15061073",
        name: "Ruviano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "17076072",
        name: "Ruvo del Monte",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "16072038",
        name: "Ruvo di Puglia",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "12059024",
        name: "Sabaudia",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "03017168",
        name: "Sabbio Chiese",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03020054",
        name: "Sabbioneta",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "15065113",
        name: "Sacco",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05028073",
        name: "Saccolongo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "06093037",
        name: "Sacile",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12058093",
        name: "Sacrofano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "20111058",
        name: "Sadali",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20095086",
        name: "Sagama",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01096056",
        name: "Sagliano Micca",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "06031017",
        name: "Sagrado",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04022164",
        name: "Sagron Mis",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "02007058",
        name: "Saint-Christophe",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007059",
        name: "Saint-Denis",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007060",
        name: "Saint-Marcel",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007061",
        name: "Saint-Nicolas",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007062",
        name: "Saint-Oyen",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007063",
        name: "Saint-Pierre",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007064",
        name: "Saint-Rhémy-en-Bosses",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007065",
        name: "Saint-Vincent",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "08034031",
        name: "Sala Baganza",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "01096057",
        name: "Sala Biellese",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "08037050",
        name: "Sala Bolognese",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "03013203",
        name: "Sala Comacina",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "15065114",
        name: "Sala Consilina",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01006150",
        name: "Sala Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "17077024",
        name: "Salandra",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "19081017",
        name: "Salaparuta",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "05029042",
        name: "Salara",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01002126",
        name: "Salasco",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01001231",
        name: "Salassa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001232",
        name: "Salbertrand",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05024090",
        name: "Salcedo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "14070062",
        name: "Salcito",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01006151",
        name: "Sale",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01004199",
        name: "Sale delle Langhe",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017169",
        name: "Sale Marasino",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01004200",
        name: "Sale San Giovanni",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19081018",
        name: "Salemi",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "15065115",
        name: "Salento",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01001233",
        name: "Salerano Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03098046",
        name: "Salerano sul Lambro",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "15065116",
        name: "Salerno",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05026070",
        name: "Salgareda",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01002127",
        name: "Sali Vercellese",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "16075065",
        name: "Salice Salentino",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01004201",
        name: "Saliceto",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "12057063",
        name: "Salisano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "05023068",
        name: "Salizzole",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "13068036",
        name: "Salle",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "01004202",
        name: "Salmour",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017170",
        name: "Salò",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04021076",
        name: "Salorno",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08034032",
        name: "Salsomaggiore Terme",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "03012117",
        name: "Saltrio",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "08099015",
        name: "Saludecio",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "01002128",
        name: "Saluggia",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01096058",
        name: "Salussola",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01004203",
        name: "Saluzzo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "16075066",
        name: "Salve",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03019087",
        name: "Salvirola",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "15065117",
        name: "Salvitelle",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01001234",
        name: "Salza di Pinerolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15064081",
        name: "Salza Irpina",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "05027032",
        name: "Salzano",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "03012118",
        name: "Samarate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "20111059",
        name: "Samassi",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111060",
        name: "Samatzai",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "19084034",
        name: "Sambuca di Sicilia",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "09047018",
        name: "Sambuca Pistoiese",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "12058094",
        name: "Sambuci",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01004204",
        name: "Sambuco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "16072039",
        name: "Sammichele di Bari",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "18080070",
        name: "Samo",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03014057",
        name: "Samolaco",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01001235",
        name: "Samone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "04022165",
        name: "Samone",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004205",
        name: "Sampeyre",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20095045",
        name: "Samugheo",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "07008052",
        name: "San Bartolomeo al Mare",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "15062057",
        name: "San Bartolomeo in Galdo",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03013204",
        name: "San Bartolomeo Val Cavargna",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "18078111",
        name: "San Basile",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "20111061",
        name: "San Basilio",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03019088",
        name: "San Bassano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05029043",
        name: "San Bellino",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01004206",
        name: "San Benedetto Belbo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13066085",
        name: "San Benedetto dei Marsi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "11044066",
        name: "San Benedetto del Tronto",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "13066086",
        name: "San Benedetto in Perillis",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03020055",
        name: "San Benedetto Po",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "18078112",
        name: "San Benedetto Ullano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "08037051",
        name: "San Benedetto Val di Sambro",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "01001236",
        name: "San Benigno Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01103061",
        name: "San Bernardino Verbano",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "07008053",
        name: "San Biagio della Cima",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "05026071",
        name: "San Biagio di Callalta",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "19084035",
        name: "San Biagio Platani",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "12060061",
        name: "San Biagio Saracinisco",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "14070063",
        name: "San Biase",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "05023069",
        name: "San Bonifacio",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "13069079",
        name: "San Buono",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "18102032",
        name: "San Calogero",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "04021077",
        name: "San Candido",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06031018",
        name: "San Canzian d'Isonzo",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001237",
        name: "San Carlo Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "09052027",
        name: "San Casciano dei Bagni",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09048038",
        name: "San Casciano in Val di Pesa",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "16075095",
        name: "San Cassiano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "19085016",
        name: "San Cataldo",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "12058119",
        name: "San Cesareo",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "16075068",
        name: "San Cesario di Lecce",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "08036036",
        name: "San Cesario sul Panaro",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "17076073",
        name: "San Chirico Nuovo",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "17076074",
        name: "San Chirico Raparo",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "19082063",
        name: "San Cipirello",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15061074",
        name: "San Cipriano d'Aversa",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15065118",
        name: "San Cipriano Picentino",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03018133",
        name: "San Cipriano Po",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "08099016",
        name: "San Clemente",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "03015191",
        name: "San Colombano al Lambro",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01001238",
        name: "San Colombano Belmonte",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07010053",
        name: "San Colombano Certenoli",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "19087040",
        name: "San Cono",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "18078113",
        name: "San Cosmo Albanese",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "17076075",
        name: "San Costantino Albanese",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "18102033",
        name: "San Costantino Calabro",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "11041051",
        name: "San Costanzo",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "01006152",
        name: "San Cristoforo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018134",
        name: "San Damiano al Colle",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01005097",
        name: "San Damiano d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01004207",
        name: "San Damiano Macra",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "06030099",
        name: "San Daniele del Friuli",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03019089",
        name: "San Daniele Po",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18078114",
        name: "San Demetrio Corone",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13066087",
        name: "San Demetrio ne' Vestini",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "01001239",
        name: "San Didero",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05027033",
        name: "San Donà di Piave",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "16074013",
        name: "San Donaci",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "16075069",
        name: "San Donato di Lecce",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "18078115",
        name: "San Donato di Ninea",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03015192",
        name: "San Donato Milanese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "12060062",
        name: "San Donato Val di Comino",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "06032004",
        name: "San Dorligo della Valle",
        districtInitials: "TS",
        district: "Trieste",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "17076076",
        name: "San Fele",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15061075",
        name: "San Felice a Cancello",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "12059025",
        name: "San Felice Circeo",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "03017171",
        name: "San Felice del Benaco",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "14070064",
        name: "San Felice del Molise",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "08036037",
        name: "San Felice sul Panaro",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "18080097",
        name: "San Ferdinando",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "16110007",
        name: "San Ferdinando di Puglia",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "03013206",
        name: "San Fermo della Battaglia",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "18078116",
        name: "San Fili",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19083077",
        name: "San Filippo del Mela",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "05026072",
        name: "San Fior",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03098047",
        name: "San Fiorano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "06031019",
        name: "San Floriano del Collio",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "18079108",
        name: "San Floro",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "01001240",
        name: "San Francesco al Campo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19083078",
        name: "San Fratello",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "20111062",
        name: "San Gavino Monreale",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "10055029",
        name: "San Gemini",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "04021079",
        name: "San Genesio Atesino",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03018135",
        name: "San Genesio ed Uniti",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "15063066",
        name: "San Gennaro Vesuviano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01001242",
        name: "San Germano Chisone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002131",
        name: "San Germano Vercellese",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03017172",
        name: "San Gervasio Bresciano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "14070065",
        name: "San Giacomo degli Schiavoni",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03020056",
        name: "San Giacomo delle Segnate",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03014058",
        name: "San Giacomo Filippo",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01002035",
        name: "San Giacomo Vercellese",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01001243",
        name: "San Gillio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "09052028",
        name: "San Gimignano",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "11043046",
        name: "San Ginesio",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "15063067",
        name: "San Giorgio a Cremano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "12060063",
        name: "San Giorgio a Liri",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "18078118",
        name: "San Giorgio Albanese",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03020057",
        name: "San Giorgio Bigarello",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01001244",
        name: "San Giorgio Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15062058",
        name: "San Giorgio del Sannio",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "06093038",
        name: "San Giorgio della Richinvelda",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05028075",
        name: "San Giorgio delle Pertiche",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03018136",
        name: "San Giorgio di Lomellina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "06030100",
        name: "San Giorgio di Nogaro",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "08037052",
        name: "San Giorgio di Piano",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "05028076",
        name: "San Giorgio in Bosco",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "16073024",
        name: "San Giorgio Ionico",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "15062059",
        name: "San Giorgio La Molara",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "17077025",
        name: "San Giorgio Lucano",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "01006153",
        name: "San Giorgio Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18080071",
        name: "San Giorgio Morgeto",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "08033040",
        name: "San Giorgio Piacentino",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "01005098",
        name: "San Giorgio Scarampi",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03015194",
        name: "San Giorgio su Legnano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01001245",
        name: "San Giorio di Susa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15065119",
        name: "San Giovanni a Piro",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "06030101",
        name: "San Giovanni al Natisone",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03016188",
        name: "San Giovanni Bianco",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03020058",
        name: "San Giovanni del Dosso",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "04022250",
        name: "San Giovanni di Fassa",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18080072",
        name: "San Giovanni di Gerace",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19084036",
        name: "San Giovanni Gemini",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "05023070",
        name: "San Giovanni Ilarione",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03019090",
        name: "San Giovanni in Croce",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18078119",
        name: "San Giovanni in Fiore",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "14070066",
        name: "San Giovanni in Galdo",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "08099017",
        name: "San Giovanni in Marignano",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "08037053",
        name: "San Giovanni in Persiceto",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "12060064",
        name: "San Giovanni Incarico",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "19087041",
        name: "San Giovanni la Punta",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "13069080",
        name: "San Giovanni Lipioni",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "05023071",
        name: "San Giovanni Lupatoto",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "16071046",
        name: "San Giovanni Rotondo",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "20111063",
        name: "San Giovanni Suergiu",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "13069081",
        name: "San Giovanni Teatino",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "09051033",
        name: "San Giovanni Valdarno",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "14070067",
        name: "San Giuliano del Sannio",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "14070068",
        name: "San Giuliano di Puglia",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03015195",
        name: "San Giuliano Milanese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "09050031",
        name: "San Giuliano Terme",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "19082064",
        name: "San Giuseppe Jato",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15063068",
        name: "San Giuseppe Vesuviano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "10054044",
        name: "San Giustino",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01001246",
        name: "San Giusto Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "09048039",
        name: "San Godenzo",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "18102034",
        name: "San Gregorio d'Ippona",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "12058095",
        name: "San Gregorio da Sassola",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "19087042",
        name: "San Gregorio di Catania",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "15065120",
        name: "San Gregorio Magno",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15061076",
        name: "San Gregorio Matese",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "05025045",
        name: "San Gregorio nelle Alpi",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "08037054",
        name: "San Lazzaro di Savena",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "08099025",
        name: "San Leo",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "06030102",
        name: "San Leonardo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04021080",
        name: "San Leonardo in Passiria",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15062060",
        name: "San Leucio del Sannio",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15062061",
        name: "San Lorenzello",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "18080073",
        name: "San Lorenzo",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "07008054",
        name: "San Lorenzo al Mare",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "18078120",
        name: "San Lorenzo Bellizzi",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18078121",
        name: "San Lorenzo del Vallo",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "04021081",
        name: "San Lorenzo di Sebato",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022231",
        name: "San Lorenzo Dorsino",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11041054",
        name: "San Lorenzo in Campo",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "06031020",
        name: "San Lorenzo Isontino",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15062062",
        name: "San Lorenzo Maggiore",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "12056047",
        name: "San Lorenzo Nuovo",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "18080074",
        name: "San Luca",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18078122",
        name: "San Lucido",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15062063",
        name: "San Lupo",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "18079110",
        name: "San Mango d'Aquino",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "15065121",
        name: "San Mango Piemonte",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15064082",
        name: "San Mango sul Calore",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15061077",
        name: "San Marcellino",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "11042041",
        name: "San Marcello",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "09047024",
        name: "San Marcello Piteglio",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "18078123",
        name: "San Marco Argentano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19083079",
        name: "San Marco d'Alunzio",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "15062064",
        name: "San Marco dei Cavoti",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15061104",
        name: "San Marco Evangelista",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "16071047",
        name: "San Marco in Lamis",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "16071048",
        name: "San Marco la Catola",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "06093039",
        name: "San Martino al Tagliamento",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01005099",
        name: "San Martino Alfieri",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05023073",
        name: "San Martino Buon Albergo",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01001247",
        name: "San Martino Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "17076077",
        name: "San Martino d'Agri",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03020059",
        name: "San Martino dall'Argine",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03019091",
        name: "San Martino del Lago",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18078124",
        name: "San Martino di Finita",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "05028077",
        name: "San Martino di Lupari",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05029044",
        name: "San Martino di Venezze",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "04021082",
        name: "San Martino in Badia",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04021083",
        name: "San Martino in Passiria",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "14070069",
        name: "San Martino in Pensilis",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "08035037",
        name: "San Martino in Rio",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "03098048",
        name: "San Martino in Strada",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "15062065",
        name: "San Martino Sannita",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03018137",
        name: "San Martino Siccomario",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "13069082",
        name: "San Martino sulla Marrucina",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15064083",
        name: "San Martino Valle Caudina",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "16073025",
        name: "San Marzano di San Giuseppe",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "01005100",
        name: "San Marzano Oliveto",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "15065122",
        name: "San Marzano sul Sarno",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "14070070",
        name: "San Massimo",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01001248",
        name: "San Maurizio Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01003133",
        name: "San Maurizio d'Opaglio",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "19082065",
        name: "San Mauro Castelverde",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "15065123",
        name: "San Mauro Cilento",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05023074",
        name: "San Mauro di Saline",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "17077026",
        name: "San Mauro Forte",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "15065124",
        name: "San Mauro la Bruca",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "18101020",
        name: "San Mauro Marchesato",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "08040041",
        name: "San Mauro Pascoli",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "01001249",
        name: "San Mauro Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05027034",
        name: "San Michele al Tagliamento",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "04022167",
        name: "San Michele all'Adige",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "19087043",
        name: "San Michele di Ganzaria",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "15064084",
        name: "San Michele di Serino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01004210",
        name: "San Michele Mondovì",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "16074014",
        name: "San Michele Salentino",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "09050032",
        name: "San Miniato",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "15062066",
        name: "San Nazzaro",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "01003134",
        name: "San Nazzaro Sesia",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03013207",
        name: "San Nazzaro Val Cavargna",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "16071049",
        name: "San Nicandro Garganico",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "18078125",
        name: "San Nicola Arcella",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15064085",
        name: "San Nicola Baronia",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18102035",
        name: "San Nicola da Crissa",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "18101021",
        name: "San Nicola dell'Alto",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "15061078",
        name: "San Nicola la Strada",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15062067",
        name: "San Nicola Manfredi",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "20095046",
        name: "San Nicolò d'Arcidano",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "05025046",
        name: "San Nicolò di Comelico",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "20111064",
        name: "San Nicolò Gerrei",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "04021084",
        name: "San Pancrazio",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "16074015",
        name: "San Pancrazio Salentino",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "03017138",
        name: "San Paolo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "17076020",
        name: "San Paolo Albanese",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15063069",
        name: "San Paolo Bel Sito",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03016189",
        name: "San Paolo d'Argon",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "16071050",
        name: "San Paolo di Civitate",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "11042042",
        name: "San Paolo di Jesi",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01005101",
        name: "San Paolo Solbrito",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03016190",
        name: "San Pellegrino Terme",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "06031021",
        name: "San Pier d'Isonzo",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19083080",
        name: "San Pier Niceto",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19083081",
        name: "San Piero Patti",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "18079114",
        name: "San Pietro a Maida",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "06030103",
        name: "San Pietro al Natisone",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15065125",
        name: "San Pietro al Tanagro",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "18079115",
        name: "San Pietro Apostolo",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "14094043",
        name: "San Pietro Avellana",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "19087044",
        name: "San Pietro Clarenza",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "05025047",
        name: "San Pietro di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "18080075",
        name: "San Pietro di Caridà",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "05026073",
        name: "San Pietro di Feletto",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "05023075",
        name: "San Pietro di Morubio",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "18078126",
        name: "San Pietro in Amantea",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "05023076",
        name: "San Pietro in Cariano",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "08037055",
        name: "San Pietro in Casale",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "08033041",
        name: "San Pietro in Cerro",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "05028078",
        name: "San Pietro in Gu",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "18078127",
        name: "San Pietro in Guarano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "16075071",
        name: "San Pietro in Lama",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "15061079",
        name: "San Pietro Infine",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01003135",
        name: "San Pietro Mosezzo",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "05024094",
        name: "San Pietro Mussolino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01001250",
        name: "San Pietro Val Lemina",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16074016",
        name: "San Pietro Vernotico",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "05028079",
        name: "San Pietro Viminario",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "13066088",
        name: "San Pio delle Camere",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "08035038",
        name: "San Polo d'Enza",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "12058096",
        name: "San Polo dei Cavalieri",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05026074",
        name: "San Polo di Piave",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "14070071",
        name: "San Polo Matese",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01001251",
        name: "San Ponso",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08036038",
        name: "San Possidonio",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "15061080",
        name: "San Potito Sannitico",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15064086",
        name: "San Potito Ultra",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15061081",
        name: "San Prisco",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "18080076",
        name: "San Procopio",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "08036039",
        name: "San Prospero",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "09052030",
        name: "San Quirico d'Orcia",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "06093040",
        name: "San Quirino",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001252",
        name: "San Raffaele Cimena",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18080077",
        name: "San Roberto",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03098049",
        name: "San Rocco al Porto",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "09046027",
        name: "San Romano in Garfagnana",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "15065126",
        name: "San Rufo",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19083082",
        name: "San Salvatore di Fitalia",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01006154",
        name: "San Salvatore Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15062068",
        name: "San Salvatore Telesino",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "13069083",
        name: "San Salvo",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15063070",
        name: "San Sebastiano al Vesuvio",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01006155",
        name: "San Sebastiano Curone",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01001253",
        name: "San Sebastiano da Po",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001254",
        name: "San Secondo di Pinerolo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08034033",
        name: "San Secondo Parmense",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "17076078",
        name: "San Severino Lucano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "11043047",
        name: "San Severino Marche",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "16071051",
        name: "San Severo",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03013248",
        name: "San Siro",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "15064087",
        name: "San Sossio Baronia",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18079116",
        name: "San Sostene",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18078128",
        name: "San Sosti",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "20111065",
        name: "San Sperate",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "05027036",
        name: "San Stino di Livenza",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "15061085",
        name: "San Tammaro",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "19083090",
        name: "San Teodoro",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "20090092",
        name: "San Teodoro",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "05025049",
        name: "San Tomaso Agordino",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "13068038",
        name: "San Valentino in Abruzzo Citeriore",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "15065132",
        name: "San Valentino Torio",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "10055030",
        name: "San Venanzo",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "05026076",
        name: "San Vendemiano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "20095050",
        name: "San Vero Milis",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "09049018",
        name: "San Vincenzo",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "18078135",
        name: "San Vincenzo La Costa",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13066092",
        name: "San Vincenzo Valle Roveto",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "15063075",
        name: "San Vitaliano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "20111066",
        name: "San Vito",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "06093041",
        name: "San Vito al Tagliamento",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06030105",
        name: "San Vito al Torre",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "13069086",
        name: "San Vito Chietino",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "16074017",
        name: "San Vito dei Normanni",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "05025051",
        name: "San Vito di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "06030106",
        name: "San Vito di Fagagna",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05024096",
        name: "San Vito di Leguzzano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "19081020",
        name: "San Vito Lo Capo",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "12058100",
        name: "San Vito Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "18079122",
        name: "San Vito sullo Ionio",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "12060070",
        name: "San Vittore del Lazio",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "03015201",
        name: "San Vittore Olona",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05023079",
        name: "San Zeno di Montagna",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03017173",
        name: "San Zeno Naviglio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03015202",
        name: "San Zenone al Lambro",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03018145",
        name: "San Zenone al Po",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05026077",
        name: "San Zenone degli Ezzelini",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "16075067",
        name: "Sanarica",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01096059",
        name: "Sandigliano",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "05024091",
        name: "Sandrigo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01004208",
        name: "Sanfrè",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004209",
        name: "Sanfront",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001241",
        name: "Sangano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03012141",
        name: "Sangiano",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "18078117",
        name: "Sangineto",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "05023072",
        name: "Sanguinetto",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "20111067",
        name: "Sanluri",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03018138",
        name: "Sannazzaro de' Burgondi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "16072040",
        name: "Sannicandro di Bari",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "16075070",
        name: "Sannicola",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "07008055",
        name: "Sanremo",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "09051034",
        name: "Sansepolcro",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "14094044",
        name: "Sant'Agapito",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "08037056",
        name: "Sant'Agata Bolognese",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "15062070",
        name: "Sant'Agata de' Goti",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "18080079",
        name: "Sant'Agata del Bianco",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18078131",
        name: "Sant'Agata di Esaro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19083084",
        name: "Sant'Agata di Militello",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "16071052",
        name: "Sant'Agata di Puglia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "08099026",
        name: "Sant'Agata Feltria",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "01006156",
        name: "Sant'Agata Fossili",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "19087045",
        name: "Sant'Agata li Battiati",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "08039017",
        name: "Sant'Agata sul Santerno",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "15063071",
        name: "Sant'Agnello",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01004211",
        name: "Sant'Albano Stura",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03018141",
        name: "Sant'Alessio con Vialone",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "18080080",
        name: "Sant'Alessio in Aspromonte",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19083085",
        name: "Sant'Alessio Siculo",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19087046",
        name: "Sant'Alfio",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "01001255",
        name: "Sant'Ambrogio di Torino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05023077",
        name: "Sant'Ambrogio di Valpolicella",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "12060065",
        name: "Sant'Ambrogio sul Garigliano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15063072",
        name: "Sant'Anastasia",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "10054045",
        name: "Sant'Anatolia di Narco",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "18079118",
        name: "Sant'Andrea Apostolo dello Ionio",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "12060066",
        name: "Sant'Andrea del Garigliano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15064089",
        name: "Sant'Andrea di Conza",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "20111069",
        name: "Sant'Andrea Frius",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "15062071",
        name: "Sant'Angelo a Cupolo",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15065128",
        name: "Sant'Angelo a Fasanella",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "15064091",
        name: "Sant'Angelo a Scala",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15064090",
        name: "Sant'Angelo all'Esca",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15061086",
        name: "Sant'Angelo d'Alife",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15064092",
        name: "Sant'Angelo dei Lombardi",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "14094046",
        name: "Sant'Angelo del Pesco",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "19083088",
        name: "Sant'Angelo di Brolo",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "05028082",
        name: "Sant'Angelo di Piove di Sacco",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "11043048",
        name: "Sant'Angelo in Pontano",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "11041057",
        name: "Sant'Angelo in Vado",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "17076079",
        name: "Sant'Angelo Le Fratte",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "14070073",
        name: "Sant'Angelo Limosano",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03098050",
        name: "Sant'Angelo Lodigiano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03018144",
        name: "Sant'Angelo Lomellina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19084039",
        name: "Sant'Angelo Muxaro",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "12058098",
        name: "Sant'Angelo Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "20111070",
        name: "Sant'Anna Arresi",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "05023078",
        name: "Sant'Anna d'Alfaedo",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "15063073",
        name: "Sant'Antimo",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "20111071",
        name: "Sant'Antioco",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01001256",
        name: "Sant'Antonino di Susa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15063074",
        name: "Sant'Antonio Abate",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "20090085",
        name: "Sant'Antonio di Gallura",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "12060067",
        name: "Sant'Apollinare",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "17076080",
        name: "Sant'Arcangelo",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15062078",
        name: "Sant'Arcangelo Trimonte",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15061087",
        name: "Sant'Arpino",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15065129",
        name: "Sant'Arsenio",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13067038",
        name: "Sant'Egidio alla Vibrata",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "15065130",
        name: "Sant'Egidio del Monte Albino",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05028083",
        name: "Sant'Elena",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "14094047",
        name: "Sant'Elena Sannita",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "14070074",
        name: "Sant'Elia a Pianisi",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "12060068",
        name: "Sant'Elia Fiumerapido",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "11109037",
        name: "Sant'Elpidio a Mare",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "13068037",
        name: "Sant'Eufemia a Maiella",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "18080081",
        name: "Sant'Eufemia d'Aspromonte",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "13069085",
        name: "Sant'Eusanio del Sangro",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13066090",
        name: "Sant'Eusanio Forconese",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "08035039",
        name: "Sant'Ilario d'Enza",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "18080082",
        name: "Sant'Ilario dello Ionio",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "11041058",
        name: "Sant'Ippolito",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "07010055",
        name: "Sant'Olcese",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "13067039",
        name: "Sant'Omero",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "03016252",
        name: "Sant'Omobono Terme",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "18102036",
        name: "Sant'Onofrio",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "12058099",
        name: "Sant'Oreste",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "04022168",
        name: "Sant'Orsola Terme",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05028084",
        name: "Sant'Urbano",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03016191",
        name: "Santa Brigida",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "18078129",
        name: "Santa Caterina Albanese",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18079117",
        name: "Santa Caterina dello Ionio",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "19085017",
        name: "Santa Caterina Villarmosa",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "16075072",
        name: "Santa Cesarea Terme",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "18080078",
        name: "Santa Cristina d'Aspromonte",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03018139",
        name: "Santa Cristina e Bissone",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19082066",
        name: "Santa Cristina Gela",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "04021085",
        name: "Santa Cristina Valgardena",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "19088010",
        name: "Santa Croce Camerina",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "15062069",
        name: "Santa Croce del Sannio",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "14070072",
        name: "Santa Croce di Magliano",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "09050033",
        name: "Santa Croce sull'Arno",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "18078130",
        name: "Santa Domenica Talao",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19083083",
        name: "Santa Domenica Vittoria",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19084037",
        name: "Santa Elisabetta",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "09053022",
        name: "Santa Fiora",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "19082067",
        name: "Santa Flavia",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03018140",
        name: "Santa Giuletta",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "20095047",
        name: "Santa Giusta",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "05025048",
        name: "Santa Giustina",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05028080",
        name: "Santa Giustina in Colle",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "09050034",
        name: "Santa Luce",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "19083086",
        name: "Santa Lucia del Mela",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "05026075",
        name: "Santa Lucia di Piave",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "15064088",
        name: "Santa Lucia di Serino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "19084038",
        name: "Santa Margherita di Belice",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "03018142",
        name: "Santa Margherita di Staffora",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "07010054",
        name: "Santa Margherita Ligure",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "09050035",
        name: "Santa Maria a Monte",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "15061082",
        name: "Santa Maria a Vico",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15061083",
        name: "Santa Maria Capua Vetere",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "20090087",
        name: "Santa Maria Coghinas",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "18078132",
        name: "Santa Maria del Cedro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "14094045",
        name: "Santa Maria del Molise",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "03018143",
        name: "Santa Maria della Versa",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "19087047",
        name: "Santa Maria di Licodia",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "05027035",
        name: "Santa Maria di Sala",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "03097074",
        name: "Santa Maria Hoè",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "13069084",
        name: "Santa Maria Imbaro",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15063090",
        name: "Santa Maria la Carità",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15061084",
        name: "Santa Maria la Fossa",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "06030104",
        name: "Santa Maria la Longa",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01103062",
        name: "Santa Maria Maggiore",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "11042043",
        name: "Santa Maria Nuova",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "15065127",
        name: "Santa Marina",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19083087",
        name: "Santa Marina Salina",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "12058097",
        name: "Santa Marinella",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "19081019",
        name: "Santa Ninfa",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "15064093",
        name: "Santa Paolina",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18101022",
        name: "Santa Severina",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "08040043",
        name: "Santa Sofia",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "18078133",
        name: "Santa Sofia d'Epiro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "19083089",
        name: "Santa Teresa di Riva",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "20090063",
        name: "Santa Teresa Gallura",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "19087048",
        name: "Santa Venerina",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "01004212",
        name: "Santa Vittoria d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "11109036",
        name: "Santa Vittoria in Matenano",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "20111068",
        name: "Santadi",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "08099018",
        name: "Santarcangelo di Romagna",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "13066089",
        name: "Sante Marie",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "01001257",
        name: "Santena",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16072041",
        name: "Santeramo in Colle",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "01002133",
        name: "Santhià",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "12059026",
        name: "Santi Cosma e Damiano",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "07008056",
        name: "Santo Stefano al Mare",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "01004213",
        name: "Santo Stefano Belbo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "07010056",
        name: "Santo Stefano d'Aveto",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "15064095",
        name: "Santo Stefano del Sole",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "05025050",
        name: "Santo Stefano di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "19083091",
        name: "Santo Stefano di Camastra",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "07011026",
        name: "Santo Stefano di Magra",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "18078134",
        name: "Santo Stefano di Rogliano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13066091",
        name: "Santo Stefano di Sessanio",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "18080083",
        name: "Santo Stefano in Aspromonte",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03098051",
        name: "Santo Stefano Lodigiano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "19084040",
        name: "Santo Stefano Quisquina",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "01004214",
        name: "Santo Stefano Roero",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03015200",
        name: "Santo Stefano Ticino",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "15065131",
        name: "Santomenna",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "12060069",
        name: "Santopadre",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "05024095",
        name: "Santorso",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "20095049",
        name: "Santu Lussurgiu",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "15065133",
        name: "Sanza",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "04022169",
        name: "Sanzeno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05028085",
        name: "Saonara",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "19083092",
        name: "Saponara",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "06030189",
        name: "Sappada",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "15065134",
        name: "Sapri",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "18078136",
        name: "Saracena",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12058101",
        name: "Saracinesco",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "05024097",
        name: "Sarcedo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "17076081",
        name: "Sarconi",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "20111072",
        name: "Sardara",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01006157",
        name: "Sardigliano",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05024098",
        name: "Sarego",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "04021086",
        name: "Sarentino",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01006158",
        name: "Sarezzano",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03017174",
        name: "Sarezzo",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "08033042",
        name: "Sarmato",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "05026078",
        name: "Sarmede",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "11043049",
        name: "Sarnano",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "03016193",
        name: "Sarnico",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "15065135",
        name: "Sarno",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "04022170",
        name: "Sarnonico",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03012119",
        name: "Saronno",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "02007066",
        name: "Sarre",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "20092066",
        name: "Sarroch",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "08040044",
        name: "Sarsina",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "09052031",
        name: "Sarteano",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "03018146",
        name: "Sartirana Lomellina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "20091077",
        name: "Sarule",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "07011027",
        name: "Sarzana",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "15065136",
        name: "Sassano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "20090064",
        name: "Sassari",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "07009055",
        name: "Sassello",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "09049019",
        name: "Sassetta",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "15062072",
        name: "Sassinoro",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "17076082",
        name: "Sasso di Castalda",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "08037057",
        name: "Sasso Marconi",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "11041071",
        name: "Sassocorvaro Auditore",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11041060",
        name: "Sassofeltrio",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11042044",
        name: "Sassoferrato",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "08036040",
        name: "Sassuolo",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "18079123",
        name: "Satriano",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "17076083",
        name: "Satriano di Lucania",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "06030107",
        name: "Sauris",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001259",
        name: "Sauze d'Oulx",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001258",
        name: "Sauze di Cesana",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16073026",
        name: "Sava",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "18101023",
        name: "Savelli",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "15063076",
        name: "Saviano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01004215",
        name: "Savigliano",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15064096",
        name: "Savignano Irpino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "08036041",
        name: "Savignano sul Panaro",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "08040045",
        name: "Savignano sul Rubicone",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "07010057",
        name: "Savignone",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03017175",
        name: "Saviore dell'Adamello",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "19083093",
        name: "Savoca",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "06030108",
        name: "Savogna",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06031022",
        name: "Savogna d'Isonzo",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "17076084",
        name: "Savoia di Lucania",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "07009056",
        name: "Savona",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "13068039",
        name: "Scafa",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "15065137",
        name: "Scafati",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01004216",
        name: "Scagnello",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15065138",
        name: "Scala",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "18078137",
        name: "Scala Coeli",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03018147",
        name: "Scaldasole",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "18078138",
        name: "Scalea",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "01001260",
        name: "Scalenghe",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19083094",
        name: "Scaletta Zanclea",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "15064097",
        name: "Scampitella",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18101024",
        name: "Scandale",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "08035040",
        name: "Scandiano",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "09048041",
        name: "Scandicci",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "03019092",
        name: "Scandolara Ravara",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03019093",
        name: "Scandolara Ripa d'Oglio",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "12057064",
        name: "Scandriglia",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "13066093",
        name: "Scanno",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "20095051",
        name: "Scano di Montiferro",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "09053023",
        name: "Scansano",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "17077031",
        name: "Scanzano Jonico",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "03016194",
        name: "Scanzorosciate",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "14094048",
        name: "Scapoli",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "09053024",
        name: "Scarlino",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "01001261",
        name: "Scarmagno",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004217",
        name: "Scarnafigi",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "09048053",
        name: "Scarperia e San Piero",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "04021087",
        name: "Scena",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "13069087",
        name: "Scerni",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "10054046",
        name: "Scheggia e Pascelupo",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "10054047",
        name: "Scheggino",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "13069088",
        name: "Schiavi di Abruzzo",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "05024099",
        name: "Schiavon",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03013211",
        name: "Schignano",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016195",
        name: "Schilpario",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05024100",
        name: "Schio",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03020060",
        name: "Schivenoglia",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "19084041",
        name: "Sciacca",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "19082068",
        name: "Sciara",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "19088011",
        name: "Scicli",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "18080084",
        name: "Scido",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18078139",
        name: "Scigliano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18080085",
        name: "Scilla",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19082081",
        name: "Scillato",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "01001262",
        name: "Sciolze",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15063077",
        name: "Scisciano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "19082069",
        name: "Sclafani Bagni",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "13066094",
        name: "Scontrone",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "01002134",
        name: "Scopa",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01002135",
        name: "Scopello",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "13066095",
        name: "Scoppito",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "19087049",
        name: "Scordia",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "16075073",
        name: "Scorrano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "05027037",
        name: "Scorzè",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "13066096",
        name: "Scurcola Marsicana",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "04022171",
        name: "Scurelle",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01005103",
        name: "Scurzolengo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "07008057",
        name: "Seborga",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "13066097",
        name: "Secinaro",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "16075074",
        name: "Seclì",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03098052",
        name: "Secugnago",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "06030109",
        name: "Sedegliano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05025053",
        name: "Sedico",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "20095052",
        name: "Sedilo",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20090065",
        name: "Sedini",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03015204",
        name: "Sedriano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03016196",
        name: "Sedrina",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "11043050",
        name: "Sefro",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "20111073",
        name: "Segariu",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "09053025",
        name: "Seggiano",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "12058102",
        name: "Segni",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "04022172",
        name: "Segonzano",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03015205",
        name: "Segrate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05026079",
        name: "Segusino",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "20092068",
        name: "Selargius",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "12057065",
        name: "Selci",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "20111074",
        name: "Selegas",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "04022246",
        name: "Sella Giudicarie",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "10054048",
        name: "Sellano",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03017176",
        name: "Sellero",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "18079126",
        name: "Sellia",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18079127",
        name: "Sellia Marina",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "04021088",
        name: "Selva dei Molini",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05025054",
        name: "Selva di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05023080",
        name: "Selva di Progno",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04021089",
        name: "Selva di Val Gardena",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05028086",
        name: "Selvazzano Dentro",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03016197",
        name: "Selvino",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "20090066",
        name: "Semestene",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03018148",
        name: "Semiana",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "18080086",
        name: "Seminara",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "09053028",
        name: "Semproniano",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "03015206",
        name: "Senago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "04021118",
        name: "Senale-San Felice",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04021091",
        name: "Senales",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20095053",
        name: "Seneghe",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "15064098",
        name: "Senerchia",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03017177",
        name: "Seniga",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "11042045",
        name: "Senigallia",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "20095054",
        name: "Senis",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "17076085",
        name: "Senise",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03013212",
        name: "Senna Comasco",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03098053",
        name: "Senna Lodigiana",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "20095055",
        name: "Sennariolo",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20090067",
        name: "Sennori",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20111075",
        name: "Senorbì",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "14070075",
        name: "Sepino",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "06093042",
        name: "Sequals",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "09046028",
        name: "Seravezza",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "20111076",
        name: "Serdiana",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03108039",
        name: "Seregno",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "05025055",
        name: "Seren del Grappa",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03019094",
        name: "Sergnano",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03016198",
        name: "Seriate",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016199",
        name: "Serina",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "15064099",
        name: "Serino",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03017178",
        name: "Serle",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03020061",
        name: "Sermide e Felonica",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "12059027",
        name: "Sermoneta",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "05026080",
        name: "Sernaglia della Battaglia",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03014059",
        name: "Sernio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01005104",
        name: "Serole",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "18078140",
        name: "Serra d'Aiello",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "11042046",
        name: "Serra de' Conti",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "07010058",
        name: "Serra Riccò",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "18102037",
        name: "Serra San Bruno",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "11042047",
        name: "Serra San Quirico",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "11041061",
        name: "Serra Sant'Abbondio",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "16071053",
        name: "Serracapriola",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "19085018",
        name: "Serradifalco",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "01004218",
        name: "Serralunga d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01006159",
        name: "Serralunga di Crea",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "20111077",
        name: "Serramanna",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "08036042",
        name: "Serramazzoni",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "15065139",
        name: "Serramezzana",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13068040",
        name: "Serramonacesca",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "11043051",
        name: "Serrapetrona",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "15063078",
        name: "Serrara Fontana",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "18079129",
        name: "Serrastretta",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18080087",
        name: "Serrata",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "03020062",
        name: "Serravalle a Po",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "11043052",
        name: "Serravalle di Chienti",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "01004219",
        name: "Serravalle Langhe",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "09047020",
        name: "Serravalle Pistoiese",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "01006160",
        name: "Serravalle Scrivia",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01002137",
        name: "Serravalle Sesia",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "15065140",
        name: "Serre",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "20111078",
        name: "Serrenti",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111079",
        name: "Serri",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "12060071",
        name: "Serrone",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "18079130",
        name: "Sersale",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "11109038",
        name: "Servigliano",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "15061088",
        name: "Sessa Aurunca",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15065141",
        name: "Sessa Cilento",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "01005105",
        name: "Sessame",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "14094049",
        name: "Sessano del Molise",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "07011028",
        name: "Sesta Godano",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "09051035",
        name: "Sestino",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "04021092",
        name: "Sesto",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06093043",
        name: "Sesto al Reghena",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03012120",
        name: "Sesto Calende",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "14094050",
        name: "Sesto Campano",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "03019095",
        name: "Sesto ed Uniti",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "09048043",
        name: "Sesto Fiorentino",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "03015209",
        name: "Sesto San Giovanni",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "08036043",
        name: "Sestola",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "07010059",
        name: "Sestri Levante",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01001263",
        name: "Sestriere",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20092074",
        name: "Sestu",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "03015210",
        name: "Settala",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "12060072",
        name: "Settefrati",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01005106",
        name: "Settime",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03015211",
        name: "Settimo Milanese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01001264",
        name: "Settimo Rottaro",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "20092075",
        name: "Settimo San Pietro",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "01001265",
        name: "Settimo Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001266",
        name: "Settimo Vittone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18079131",
        name: "Settingiano",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "20111080",
        name: "Setzu",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111081",
        name: "Seui",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111082",
        name: "Seulo",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03108040",
        name: "Seveso",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "01006161",
        name: "Sezzadio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "12059028",
        name: "Sezze",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "04022173",
        name: "Sfruz",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "06032005",
        name: "Sgonico",
        districtInitials: "TS",
        district: "Trieste",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12060073",
        name: "Sgurgola",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "20095056",
        name: "Siamaggiore",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20095057",
        name: "Siamanna",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "15065142",
        name: "Siano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "20095076",
        name: "Siapiccia",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "15065143",
        name: "Sicignano degli Alburni",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "19084042",
        name: "Siculiana",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "20111083",
        name: "Siddi",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "18080088",
        name: "Siderno",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "09052032",
        name: "Siena",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "10054049",
        name: "Sigillo",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "09048044",
        name: "Signa",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "04021093",
        name: "Silandro",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20091083",
        name: "Silanus",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "05026081",
        name: "Silea",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "20090068",
        name: "Siligo",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20111084",
        name: "Siliqua",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111085",
        name: "Silius",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "09046037",
        name: "Sillano Giuncugnano",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "01003138",
        name: "Sillavengo",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01006162",
        name: "Silvano d'Orba",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03018149",
        name: "Silvano Pietra",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "13067040",
        name: "Silvi",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "20095058",
        name: "Simala",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20095059",
        name: "Simaxis",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "18102038",
        name: "Simbario",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "18079133",
        name: "Simeri Crichi",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "19083095",
        name: "Sinagra",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "09052033",
        name: "Sinalunga",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "20091084",
        name: "Sindia",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20095060",
        name: "Sini",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01004220",
        name: "Sinio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20091085",
        name: "Siniscola",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20092080",
        name: "Sinnai",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "18080089",
        name: "Sinopoli",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "19089017",
        name: "Siracusa",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "15064100",
        name: "Sirignano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "20095061",
        name: "Siris",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "03017179",
        name: "Sirmione",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "11042048",
        name: "Sirolo",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "03097075",
        name: "Sirone",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03097076",
        name: "Sirtori",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "08034049",
        name: "Sissa Trecasali",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "20111086",
        name: "Siurgus Donigala",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03018150",
        name: "Siziano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01003139",
        name: "Sizzano",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "04021094",
        name: "Sluderno",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11109039",
        name: "Smerillo",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "05023081",
        name: "Soave",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "06030110",
        name: "Socchieve",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20095078",
        name: "Soddì",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "08040046",
        name: "Sogliano al Rubicone",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "16075075",
        name: "Sogliano Cavour",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01005107",
        name: "Soglio",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03017180",
        name: "Soiano del Lago",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05024101",
        name: "Solagna",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "19089018",
        name: "Solarino",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "03015213",
        name: "Solaro",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "08039018",
        name: "Solarolo",
        districtInitials: "RA",
        district: "Ravenna",
        region: "Emilia-Romagna"
    },
    {
        code: "03019096",
        name: "Solarolo Rainerio",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "20095062",
        name: "Solarussa",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "03012121",
        name: "Solbiate Arno",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03013255",
        name: "Solbiate con Cagno",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03012122",
        name: "Solbiate Olona",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "07008058",
        name: "Soldano",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "20111087",
        name: "Soleminis",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01006163",
        name: "Solero",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05028087",
        name: "Solesino",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "16075076",
        name: "Soleto",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03020063",
        name: "Solferino",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "08036044",
        name: "Soliera",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "08034035",
        name: "Solignano",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "15064101",
        name: "Solofra",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01006164",
        name: "Solonghello",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15062073",
        name: "Solopaca",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03016200",
        name: "Solto Collina",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016251",
        name: "Solza",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03098054",
        name: "Somaglia",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "01004221",
        name: "Somano",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03012123",
        name: "Somma Lombardo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "15063079",
        name: "Somma Vesuviana",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "05023082",
        name: "Sommacampagna",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01004222",
        name: "Sommariva del Bosco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01004223",
        name: "Sommariva Perno",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19085019",
        name: "Sommatino",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "03018151",
        name: "Sommo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05023083",
        name: "Sona",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03019097",
        name: "Soncino",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03014060",
        name: "Sondalo",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03014061",
        name: "Sondrio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03016201",
        name: "Songavazzo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03017181",
        name: "Sonico",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "12059029",
        name: "Sonnino",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "12060074",
        name: "Sora",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "04022176",
        name: "Soraga di Fassa",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08034036",
        name: "Soragna",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "09053026",
        name: "Sorano",
        districtInitials: "GR",
        district: "Grosseto",
        region: "Toscana"
    },
    {
        code: "18079134",
        name: "Sorbo San Basile",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "15064102",
        name: "Sorbo Serpico",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "08034051",
        name: "Sorbolo Mezzani",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "01096063",
        name: "Sordevolo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03098055",
        name: "Sordio",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03019098",
        name: "Soresina",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05023084",
        name: "Sorgà",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "20091086",
        name: "Sorgono",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "07010060",
        name: "Sori",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "18102039",
        name: "Sorianello",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "18102040",
        name: "Soriano Calabro",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "12056048",
        name: "Soriano nel Cimino",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03013216",
        name: "Sorico",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01003140",
        name: "Soriso",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03016202",
        name: "Sorisole",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03013217",
        name: "Sormano",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "20095063",
        name: "Sorradile",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "15063080",
        name: "Sorrento",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "20090069",
        name: "Sorso",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "19089019",
        name: "Sortino",
        districtInitials: "SR",
        district: "Siracusa",
        region: "Sicilia"
    },
    {
        code: "03019099",
        name: "Sospiro",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05025056",
        name: "Sospirolo",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05024102",
        name: "Sossano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01096064",
        name: "Sostegno",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03016203",
        name: "Sotto il Monte Giovanni XXIII",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "04022177",
        name: "Sover",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18079137",
        name: "Soverato",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "03016204",
        name: "Sovere",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "18079138",
        name: "Soveria Mannelli",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "18079139",
        name: "Soveria Simeri",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "05025057",
        name: "Soverzene",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "09052034",
        name: "Sovicille",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "03108041",
        name: "Sovico",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "05024103",
        name: "Sovizzo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05025058",
        name: "Sovramonte",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "01003141",
        name: "Sozzago",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "19083096",
        name: "Spadafora",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "18102041",
        name: "Spadola",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "15061089",
        name: "Sparanise",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01001267",
        name: "Sparone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16075077",
        name: "Specchia",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "10054050",
        name: "Spello",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "19086017",
        name: "Sperlinga",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "12059030",
        name: "Sperlonga",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "15064103",
        name: "Sperone",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03018152",
        name: "Spessa",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "18078142",
        name: "Spezzano Albanese",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "18078143",
        name: "Spezzano della Sila",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "04022179",
        name: "Spiazzo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01006165",
        name: "Spigno Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "12059031",
        name: "Spigno Saturnia",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "08036045",
        name: "Spilamberto",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "06093044",
        name: "Spilimbergo",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "18102042",
        name: "Spilinga",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "03019100",
        name: "Spinadesco",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "16110008",
        name: "Spinazzola",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "05027038",
        name: "Spinea",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "03019101",
        name: "Spineda",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "14070076",
        name: "Spinete",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01006166",
        name: "Spineto Scrivia",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "11044071",
        name: "Spinetoli",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "03019102",
        name: "Spino d'Adda",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03016205",
        name: "Spinone al Lago",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "17076086",
        name: "Spinoso",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03016206",
        name: "Spirano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "10054051",
        name: "Spoleto",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "13068041",
        name: "Spoltore",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "16075078",
        name: "Spongano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "04022180",
        name: "Spormaggiore",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022181",
        name: "Sporminore",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07009057",
        name: "Spotorno",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "05026082",
        name: "Spresiano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03014062",
        name: "Spriana",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "18079142",
        name: "Squillace",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "16075079",
        name: "Squinzano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "11042049",
        name: "Staffolo",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "03019103",
        name: "Stagno Lombardo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "18080090",
        name: "Staiti",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18079143",
        name: "Stalettì",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "05028088",
        name: "Stanghella",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "06031023",
        name: "Staranzano",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "16073029",
        name: "Statte",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "01006167",
        name: "Stazzano",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "09046030",
        name: "Stazzema",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "03013218",
        name: "Stazzona",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "18102043",
        name: "Stefanaconi",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "07009058",
        name: "Stella",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "15065144",
        name: "Stella Cilento",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "07009059",
        name: "Stellanello",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "04021095",
        name: "Stelvio",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022182",
        name: "Stenico",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "16075080",
        name: "Sternatia",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03016207",
        name: "Stezzano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05029045",
        name: "Stienta",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "17077027",
        name: "Stigliano",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "18080091",
        name: "Stignano",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "18080092",
        name: "Stilo",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "12057066",
        name: "Stimigliano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "20090089",
        name: "Stintino",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "15065145",
        name: "Stio",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "16071054",
        name: "Stornara",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "16071055",
        name: "Stornarella",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "04022183",
        name: "Storo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05027039",
        name: "Stra",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "03018153",
        name: "Stradella",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001268",
        name: "Strambinello",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001269",
        name: "Strambino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12060075",
        name: "Strangolagalli",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "06030111",
        name: "Stregna",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04022184",
        name: "Strembo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01103064",
        name: "Stresa",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01006168",
        name: "Strevi",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15063081",
        name: "Striano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01096065",
        name: "Strona",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "10055031",
        name: "Stroncone",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "18101025",
        name: "Strongoli",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "01002142",
        name: "Stroppiana",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01004224",
        name: "Stroppo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03016208",
        name: "Strozza",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "15064104",
        name: "Sturno",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03018154",
        name: "Suardi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "09051037",
        name: "Subbiano",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "12058103",
        name: "Subiaco",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "15061090",
        name: "Succivo",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03097077",
        name: "Sueglio",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "20111088",
        name: "Suelli",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03097078",
        name: "Suello",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03016209",
        name: "Suisio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03108042",
        name: "Sulbiate",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "13066098",
        name: "Sulmona",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03017182",
        name: "Sulzano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03012124",
        name: "Sumirago",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "15064105",
        name: "Summonte",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "20095087",
        name: "Suni",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "01003143",
        name: "Suno",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "16075081",
        name: "Supersano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "12060076",
        name: "Supino",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "16075082",
        name: "Surano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "16075083",
        name: "Surbo",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01001270",
        name: "Susa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05026083",
        name: "Susegana",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03020064",
        name: "Sustinente",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "19085020",
        name: "Sutera",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "12056049",
        name: "Sutri",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "06030112",
        name: "Sutrio",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "09049020",
        name: "Suvereto",
        districtInitials: "LI",
        district: "Livorno",
        region: "Toscana"
    },
    {
        code: "03020065",
        name: "Suzzara",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03097079",
        name: "Taceno",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "20095064",
        name: "Tadasuni",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "07008059",
        name: "Taggia",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "13066099",
        name: "Tagliacozzo",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "05029046",
        name: "Taglio di Po",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01006169",
        name: "Tagliolo Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05025059",
        name: "Taibon Agordino",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03012125",
        name: "Taino",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "06030113",
        name: "Taipana",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "08099027",
        name: "Talamello",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "03014063",
        name: "Talamona",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "20091088",
        name: "Talana",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03016210",
        name: "Taleggio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "09051038",
        name: "Talla",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "06030114",
        name: "Talmassons",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05025060",
        name: "Tambre",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "19083097",
        name: "Taormina",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "12057067",
        name: "Tarano",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "13069089",
        name: "Taranta Peligna",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01004225",
        name: "Tarantasca",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "16073027",
        name: "Taranto",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "06030116",
        name: "Tarcento",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12056050",
        name: "Tarquinia",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "18078145",
        name: "Tarsia",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03014064",
        name: "Tartano",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "06030117",
        name: "Tarvisio",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05026084",
        name: "Tarzo",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01006170",
        name: "Tassarolo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "15064106",
        name: "Taurano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15064107",
        name: "Taurasi",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18080093",
        name: "Taurianova",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "16075084",
        name: "Taurisano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "06030118",
        name: "Tavagnacco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01001271",
        name: "Tavagnasco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03098056",
        name: "Tavazzano con Villavesco",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "14070077",
        name: "Tavenna",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "18079146",
        name: "Taverna",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "03013222",
        name: "Tavernerio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016211",
        name: "Tavernola Bergamasca",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03017183",
        name: "Tavernole sul Mella",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "16075085",
        name: "Taviano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01096066",
        name: "Tavigliano",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "11041064",
        name: "Tavoleto",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11041065",
        name: "Tavullia",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "17076087",
        name: "Teana",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15061091",
        name: "Teano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "15065146",
        name: "Teggiano",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03014065",
        name: "Teglio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "05027040",
        name: "Teglio Veneto",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "15062074",
        name: "Telese Terme",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "03016212",
        name: "Telgate",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "20090080",
        name: "Telti",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "04022188",
        name: "Telve",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022189",
        name: "Telve di Sopra",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20090070",
        name: "Tempio Pausania",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03017184",
        name: "Temù",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04022190",
        name: "Tenna",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022191",
        name: "Tenno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05028089",
        name: "Teolo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "15064108",
        name: "Teora",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "13067041",
        name: "Teramo",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "01003144",
        name: "Terdobbiate",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "12060077",
        name: "Terelle",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "04021096",
        name: "Terento",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08034038",
        name: "Terenzo",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "20090086",
        name: "Tergu",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "04021097",
        name: "Terlano",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "16072043",
        name: "Terlizzi",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "19083106",
        name: "Terme Vigliatore",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "04021098",
        name: "Termeno sulla strada del vino",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "19082070",
        name: "Termini Imerese",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "14070078",
        name: "Termoli",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "03012126",
        name: "Ternate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01096067",
        name: "Ternengo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "10055032",
        name: "Terni",
        districtInitials: "TR",
        district: "Terni",
        region: "Umbria"
    },
    {
        code: "03016213",
        name: "Terno d'Isola",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "12059032",
        name: "Terracina",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "04022193",
        name: "Terragnolo",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20095065",
        name: "Terralba",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "18078146",
        name: "Terranova da Sibari",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03098057",
        name: "Terranova dei Passerini",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "17076088",
        name: "Terranova di Pollino",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "18080094",
        name: "Terranova Sappo Minulio",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "09051039",
        name: "Terranuova Bracciolini",
        districtInitials: "AR",
        district: "Arezzo",
        region: "Toscana"
    },
    {
        code: "19082071",
        name: "Terrasini",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "05028090",
        name: "Terrassa Padovana",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "18078147",
        name: "Terravecchia",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "05023085",
        name: "Terrazzo",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04022251",
        name: "Terre d'Adige",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08038028",
        name: "Terre del Reno",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "11041070",
        name: "Terre Roveresche",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "09050036",
        name: "Terricciola",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "01006171",
        name: "Terruggia",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "20091089",
        name: "Tertenia",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "15063082",
        name: "Terzigno",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01006172",
        name: "Terzo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "06030120",
        name: "Terzo d'Aquileia",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04022195",
        name: "Terzolas",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07008060",
        name: "Terzorio",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "04022196",
        name: "Tesero",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04021099",
        name: "Tesimo",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "12056051",
        name: "Tessennano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "07009060",
        name: "Testico",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "20091090",
        name: "Teti",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "20111089",
        name: "Teulada",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "15061092",
        name: "Teverola",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "05024104",
        name: "Tezze sul Brenta",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05024105",
        name: "Thiene",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "20090071",
        name: "Thiesi",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "20091091",
        name: "Tiana",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "03019104",
        name: "Ticengo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01006173",
        name: "Ticineto",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16075086",
        name: "Tiggiano",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "07010061",
        name: "Tiglieto",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01005108",
        name: "Tigliole",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "03017185",
        name: "Tignale",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20095088",
        name: "Tinnura",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "13066100",
        name: "Tione degli Abruzzi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "04022199",
        name: "Tione di Trento",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03014066",
        name: "Tirano",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "04021100",
        name: "Tires",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18079147",
        name: "Tiriolo",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "04021101",
        name: "Tirolo",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20090072",
        name: "Tissi",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "17076089",
        name: "Tito",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "12058104",
        name: "Tivoli",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "08034039",
        name: "Tizzano Val Parma",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "08035041",
        name: "Toano",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "15062075",
        name: "Tocco Caudio",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "13068042",
        name: "Tocco da Casauria",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "01103065",
        name: "Toceno",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "10054052",
        name: "Todi",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "12057068",
        name: "Toffia",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "07009061",
        name: "Toirano",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "11043053",
        name: "Tolentino",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "12058105",
        name: "Tolfa",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01096068",
        name: "Tollegno",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "13069090",
        name: "Tollo",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "06030121",
        name: "Tolmezzo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "17076090",
        name: "Tolve",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "05028091",
        name: "Tombolo",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "04022200",
        name: "Ton",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "20091093",
        name: "Tonara",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "01005109",
        name: "Tonco",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01005110",
        name: "Tonengo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05024106",
        name: "Tonezza del Cimone",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "15061093",
        name: "Tora e Piccilli",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "18078148",
        name: "Torano Castello",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "13067042",
        name: "Torano Nuovo",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "03017186",
        name: "Torbole Casaglia",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04022202",
        name: "Torcegno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15065147",
        name: "Torchiara",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "16074018",
        name: "Torchiarolo",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "15064109",
        name: "Torella dei Lombardi",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "14070079",
        name: "Torella del Sannio",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "10054053",
        name: "Torgiano",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "02007067",
        name: "Torgnon",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "01001272",
        name: "Torino",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "13069091",
        name: "Torino di Sangro",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "16072044",
        name: "Toritto",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "03019105",
        name: "Torlino Vimercati",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01003146",
        name: "Tornaco",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "13069092",
        name: "Tornareccio",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "03019106",
        name: "Tornata",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "13066101",
        name: "Tornimparte",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03013223",
        name: "Torno",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "08034040",
        name: "Tornolo",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "14070080",
        name: "Toro",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "20091094",
        name: "Torpè",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "15065148",
        name: "Torraca",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "20090073",
        name: "Torralba",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03018155",
        name: "Torrazza Coste",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001273",
        name: "Torrazza Piemonte",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01096069",
        name: "Torrazzo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "15063083",
        name: "Torre Annunziata",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03018156",
        name: "Torre Beretti e Castellaro",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03016214",
        name: "Torre Boldone",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01004226",
        name: "Torre Bormida",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "12060078",
        name: "Torre Cajetani",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01001274",
        name: "Torre Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018157",
        name: "Torre d'Arese",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03018159",
        name: "Torre d'Isola",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03016215",
        name: "Torre de' Busi",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03018158",
        name: "Torre de' Negri",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "13068043",
        name: "Torre de' Passeri",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "03019107",
        name: "Torre de' Picenardi",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "03016216",
        name: "Torre de' Roveri",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "15063084",
        name: "Torre del Greco",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "05027041",
        name: "Torre di Mosto",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "18079148",
        name: "Torre di Ruggiero",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "03014067",
        name: "Torre di Santa Maria",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "15064110",
        name: "Torre Le Nocelle",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "01004227",
        name: "Torre Mondovì",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "15065149",
        name: "Torre Orsaia",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03016217",
        name: "Torre Pallavicina",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001275",
        name: "Torre Pellice",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004228",
        name: "Torre San Giorgio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "11109040",
        name: "Torre San Patrizio",
        districtInitials: "FM",
        district: "Fermo",
        region: "Marche"
    },
    {
        code: "16074019",
        name: "Torre Santa Susanna",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "06030122",
        name: "Torreano",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05024107",
        name: "Torrebelvicino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "13069093",
        name: "Torrebruna",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15062076",
        name: "Torrecuso",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "05028092",
        name: "Torreglia",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "19083098",
        name: "Torregrotta",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "16071056",
        name: "Torremaggiore",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "19083108",
        name: "Torrenova",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01004229",
        name: "Torresina",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19082072",
        name: "Torretta",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03018160",
        name: "Torrevecchia Pia",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "13069094",
        name: "Torrevecchia Teatina",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "05023086",
        name: "Torri del Benaco",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "05024108",
        name: "Torri di Quartesolo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "12057070",
        name: "Torri in Sabina",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "12060079",
        name: "Torrice",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "16073028",
        name: "Torricella",
        districtInitials: "TA",
        district: "Taranto",
        region: "Puglia"
    },
    {
        code: "03019108",
        name: "Torricella del Pizzo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "12057069",
        name: "Torricella in Sabina",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "13069095",
        name: "Torricella Peligna",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "13067043",
        name: "Torricella Sicura",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "03018161",
        name: "Torricella Verzate",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "07010062",
        name: "Torriglia",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "08034041",
        name: "Torrile",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "15064111",
        name: "Torrioni",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "09052035",
        name: "Torrita di Siena",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "12058106",
        name: "Torrita Tiberina",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "20091095",
        name: "Tortolì",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "01006174",
        name: "Tortona",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "18078149",
        name: "Tortora",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15065150",
        name: "Tortorella",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "13067044",
        name: "Tortoreto",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "19083099",
        name: "Tortorici",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "06030123",
        name: "Torviscosa",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03017187",
        name: "Toscolano-Maderno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "13067045",
        name: "Tossicia",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "03014068",
        name: "Tovo di Sant'Agata",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "07009062",
        name: "Tovo San Giacomo",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "19082073",
        name: "Trabia",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03012127",
        name: "Tradate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "20095066",
        name: "Tramatza",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "04022203",
        name: "Trambileno",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15065151",
        name: "Tramonti",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "06093045",
        name: "Tramonti di Sopra",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06093046",
        name: "Tramonti di Sotto",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "17076091",
        name: "Tramutola",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "01001276",
        name: "Trana",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16110009",
        name: "Trani",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "03014069",
        name: "Traona",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "19081021",
        name: "Trapani",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "19082074",
        name: "Trappeto",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "01103066",
        name: "Trarego Viggiona",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "13066102",
        name: "Trasacco",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "06030124",
        name: "Trasaghis",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01103067",
        name: "Trasquera",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "20111090",
        name: "Tratalias",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03018162",
        name: "Travacò Siccomario",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03017188",
        name: "Travagliato",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03012128",
        name: "Travedona-Monate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01001278",
        name: "Traversella",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08034042",
        name: "Traversetolo",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "01001279",
        name: "Traves",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "06093047",
        name: "Travesio",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "08033043",
        name: "Travo",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "04022247",
        name: "Tre Ville",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05028093",
        name: "Trebaseleghe",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "18078150",
        name: "Trebisacce",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15063091",
        name: "Trecase",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "19087050",
        name: "Trecastagni",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "11042050",
        name: "Trecastelli",
        districtInitials: "AN",
        district: "Ancona",
        region: "Marche"
    },
    {
        code: "01003149",
        name: "Trecate",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "17076092",
        name: "Trecchina",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "05029047",
        name: "Trecenta",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "08040049",
        name: "Tredozio",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "13069096",
        name: "Treglio",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "05023087",
        name: "Tregnago",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "11043054",
        name: "Treia",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "01004230",
        name: "Treiso",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "19087051",
        name: "Tremestieri Etneo",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "03013252",
        name: "Tremezzina",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03017189",
        name: "Tremosine sul Garda",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15065152",
        name: "Trentinara",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "04022205",
        name: "Trento",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15061094",
        name: "Trentola Ducenta",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03017190",
        name: "Trenzano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "06030126",
        name: "Treppo Grande",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "06030191",
        name: "Treppo Ligosullo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "16075087",
        name: "Trepuzzi",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "09052036",
        name: "Trequanda",
        districtInitials: "SI",
        district: "Siena",
        region: "Toscana"
    },
    {
        code: "09045015",
        name: "Tresana",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "03016218",
        name: "Trescore Balneario",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03019109",
        name: "Trescore Cremasco",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "08038030",
        name: "Tresignana",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "03014070",
        name: "Tresivio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "20095067",
        name: "Tresnuraghes",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "05023088",
        name: "Trevenzuolo",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "10054054",
        name: "Trevi",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "12060080",
        name: "Trevi nel Lazio",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15064112",
        name: "Trevico",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03016219",
        name: "Treviglio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05026085",
        name: "Trevignano",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "12058107",
        name: "Trevignano Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01006175",
        name: "Treville",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03016220",
        name: "Treviolo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05026086",
        name: "Treviso",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03017191",
        name: "Treviso Bresciano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03015219",
        name: "Trezzano Rosa",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03015220",
        name: "Trezzano sul Naviglio",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03015221",
        name: "Trezzo sull'Adda",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01004231",
        name: "Trezzo Tinella",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03013226",
        name: "Trezzone",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "05028094",
        name: "Tribano",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03015222",
        name: "Tribiano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "07010063",
        name: "Tribogna",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "17077028",
        name: "Tricarico",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "16075088",
        name: "Tricase",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01002147",
        name: "Tricerro",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "06030127",
        name: "Tricesimo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "20091097",
        name: "Triei",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "06032006",
        name: "Trieste",
        districtInitials: "TS",
        district: "Trieste",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "16072046",
        name: "Triggiano",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "03019110",
        name: "Trigolo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01004232",
        name: "Trinità",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "20090074",
        name: "Trinità d'Agultu e Vignola",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "16110010",
        name: "Trinitapoli",
        districtInitials: "BT",
        district: "Barletta-Andria-Trani",
        region: "Puglia"
    },
    {
        code: "01002148",
        name: "Trino",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "07008061",
        name: "Triora",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "19083100",
        name: "Tripi",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "01006176",
        name: "Trisobbio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05024110",
        name: "Trissino",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03108043",
        name: "Triuggio",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "14070081",
        name: "Trivento",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "12060081",
        name: "Trivigliano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "06030128",
        name: "Trivignano Udinese",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "17076093",
        name: "Trivigno",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03018163",
        name: "Trivolzio",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "04021102",
        name: "Trodena nel parco naturale",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001280",
        name: "Trofarello",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16071058",
        name: "Troia",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "19086018",
        name: "Troina",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "03018164",
        name: "Tromello",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01103068",
        name: "Trontano",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03012129",
        name: "Tronzano Lago Maggiore",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01002150",
        name: "Tronzano Vercellese",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "18102044",
        name: "Tropea",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "03018165",
        name: "Trovo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03015224",
        name: "Truccazzano",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "04021103",
        name: "Tubre",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "14070082",
        name: "Tufara",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "13069097",
        name: "Tufillo",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15063085",
        name: "Tufino",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "15064113",
        name: "Tufo",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "16075089",
        name: "Tuglie",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "20111091",
        name: "Tuili",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20090075",
        name: "Tula",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "10054055",
        name: "Tuoro sul Trasimeno",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "12057071",
        name: "Turania",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03098058",
        name: "Turano Lodigiano",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03013227",
        name: "Turate",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03015226",
        name: "Turbigo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "16072047",
        name: "Turi",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "20111092",
        name: "Turri",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "06031024",
        name: "Turriaco",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "13068044",
        name: "Turrivalignani",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "17077029",
        name: "Tursi",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "19083101",
        name: "Tusa",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "12056052",
        name: "Tuscania",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03016221",
        name: "Ubiale Clanezzo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03012130",
        name: "Uboldo",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "19083102",
        name: "Ucria",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "06030129",
        name: "Udine",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "16075090",
        name: "Ugento",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "16075091",
        name: "Uggiano la Chiesa",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03013228",
        name: "Uggiate-Trevano",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "20095068",
        name: "Ulà Tirso",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20091098",
        name: "Ulassai",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "04021104",
        name: "Ultimo",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "10054056",
        name: "Umbertide",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "18101026",
        name: "Umbriatico",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "03017192",
        name: "Urago d'Oglio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20095069",
        name: "Uras",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "05028095",
        name: "Urbana",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "11041066",
        name: "Urbania",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "07009063",
        name: "Urbe",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "11041067",
        name: "Urbino",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "11043055",
        name: "Urbisaglia",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "03016222",
        name: "Urgnano",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "20090076",
        name: "Uri",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "14070083",
        name: "Ururi",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "20091099",
        name: "Urzulei",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "07010064",
        name: "Uscio",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "20095070",
        name: "Usellus",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20090077",
        name: "Usini",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03108044",
        name: "Usmate Velate",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "20111093",
        name: "Ussana",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111094",
        name: "Ussaramanna",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20091100",
        name: "Ussassai",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "01001281",
        name: "Usseaux",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001282",
        name: "Usseglio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "11043056",
        name: "Ussita",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "19082075",
        name: "Ustica",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "20092090",
        name: "Uta",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "09047021",
        name: "Uzzano",
        districtInitials: "PT",
        district: "Pistoia",
        region: "Toscana"
    },
    {
        code: "18078152",
        name: "Vaccarizzo Albanese",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "12057072",
        name: "Vacone",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "13069098",
        name: "Vacri",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "04021105",
        name: "Vadena",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "07009064",
        name: "Vado Ligure",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "09046031",
        name: "Vagli Sotto",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "09048046",
        name: "Vaglia",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "17076094",
        name: "Vaglio Basilicata",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "01005111",
        name: "Vaglio Serra",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "09100006",
        name: "Vaiano",
        districtInitials: "PO",
        district: "Prato",
        region: "Toscana"
    },
    {
        code: "03019111",
        name: "Vaiano Cremasco",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01001283",
        name: "Vaie",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03019112",
        name: "Vailate",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "15061095",
        name: "Vairano Patenora",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "06093052",
        name: "Vajont",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "03016253",
        name: "Val Brembilla",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01001284",
        name: "Val della Torre",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001317",
        name: "Val di Chy",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03018166",
        name: "Val di Nizza",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "04021107",
        name: "Val di Vizze",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05025073",
        name: "Val di Zoldo",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05024123",
        name: "Val Liona",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03014074",
        name: "Val Masino",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03013233",
        name: "Val Rezzo",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016223",
        name: "Valbondione",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016224",
        name: "Valbrembo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05024125",
        name: "Valbrenta",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "07010065",
        name: "Valbrevenna",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "03013229",
        name: "Valbrona",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01001318",
        name: "Valchiusa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05024111",
        name: "Valdagno",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "04022232",
        name: "Valdaone",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04021106",
        name: "Valdaora",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "05024112",
        name: "Valdastico",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01096071",
        name: "Valdengo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "19081022",
        name: "Valderice",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "03014071",
        name: "Valdidentro",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01004233",
        name: "Valdieri",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01096088",
        name: "Valdilana",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "19083103",
        name: "Valdina",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "03014072",
        name: "Valdisotto",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "05026087",
        name: "Valdobbiadene",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01002152",
        name: "Valduggia",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03018167",
        name: "Valeggio",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05023089",
        name: "Valeggio sul Mincio",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "12056053",
        name: "Valentano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "01006177",
        name: "Valenza",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "16072048",
        name: "Valenzano",
        districtInitials: "BA",
        district: "Bari",
        region: "Puglia"
    },
    {
        code: "03098059",
        name: "Valera Fratta",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "10054057",
        name: "Valfabbrica",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01005112",
        name: "Valfenera",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "04022209",
        name: "Valfloriana",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "11043058",
        name: "Valfornace",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "03014073",
        name: "Valfurva",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03012131",
        name: "Valganna",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "01001285",
        name: "Valgioie",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03016225",
        name: "Valgoglio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01004234",
        name: "Valgrana",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03097082",
        name: "Valgreghentino",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "02007068",
        name: "Valgrisenche",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "19086019",
        name: "Valguarnera Caropepe",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "05025062",
        name: "Vallada Agordina",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "01096072",
        name: "Vallanzengo",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "04022210",
        name: "Vallarsa",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15064114",
        name: "Vallata",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "15061096",
        name: "Valle Agricola",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "04021108",
        name: "Valle Aurina",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01103079",
        name: "Valle Cannobina",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "13067046",
        name: "Valle Castellana",
        districtInitials: "TE",
        district: "Teramo",
        region: "Abruzzo"
    },
    {
        code: "15065153",
        name: "Valle dell'Angelo",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "05025063",
        name: "Valle di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "04021109",
        name: "Valle di Casies",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15061097",
        name: "Valle di Maddaloni",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03018168",
        name: "Valle Lomellina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03018169",
        name: "Valle Salimbene",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01096074",
        name: "Valle San Nicolao",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "07008062",
        name: "Vallebona",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "12060082",
        name: "Vallecorsa",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "07008063",
        name: "Vallecrosia",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "19082076",
        name: "Valledolmo",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "20090079",
        name: "Valledoria",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "18079151",
        name: "Vallefiorita",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "11041068",
        name: "Vallefoglia",
        districtInitials: "PU",
        district: "Pesaro e Urbino",
        region: "Marche"
    },
    {
        code: "04022248",
        name: "Vallelaghi",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "18102045",
        name: "Vallelonga",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "19085021",
        name: "Vallelunga Pratameno",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "12060083",
        name: "Vallemaio",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "12058108",
        name: "Vallepietra",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "12056054",
        name: "Vallerano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "20111095",
        name: "Vallermosa",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "12060084",
        name: "Vallerotonda",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15064115",
        name: "Vallesaccarda",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "03016226",
        name: "Valleve",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05024113",
        name: "Valli del Pasubio",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "12058109",
        name: "Vallinfreda",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03017193",
        name: "Vallio Terme",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "15065154",
        name: "Vallo della Lucania",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "10054058",
        name: "Vallo di Nera",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "01001286",
        name: "Vallo Torinese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004235",
        name: "Valloriate",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01006178",
        name: "Valmacca",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "03097083",
        name: "Valmadrera",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "12058110",
        name: "Valmontone",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03013232",
        name: "Valmorea",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "08034044",
        name: "Valmozzola",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "03016227",
        name: "Valnegra",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "02007069",
        name: "Valpelline",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "01001287",
        name: "Valperga",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001288",
        name: "Valprato Soana",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08037061",
        name: "Valsamoggia",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "02007070",
        name: "Valsavarenche",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "17077030",
        name: "Valsinni",
        districtInitials: "MT",
        district: "Matera",
        region: "Basilicata"
    },
    {
        code: "03013234",
        name: "Valsolda",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "01103069",
        name: "Valstrona",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "10054059",
        name: "Valtopina",
        districtInitials: "PG",
        district: "Perugia",
        region: "Umbria"
    },
    {
        code: "03016229",
        name: "Valtorta",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "02007071",
        name: "Valtournenche",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "15065155",
        name: "Valva",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03097093",
        name: "Valvarrone",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "06093053",
        name: "Valvasone Arzene",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "19087052",
        name: "Valverde",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "03017194",
        name: "Valvestino",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04021110",
        name: "Vandoies",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03015249",
        name: "Vanzaghello",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03015229",
        name: "Vanzago",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01103070",
        name: "Vanzone con San Carlo",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03015230",
        name: "Vaprio d'Adda",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01003153",
        name: "Vaprio d'Agogna",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01002156",
        name: "Varallo",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01003154",
        name: "Varallo Pombia",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "03012132",
        name: "Varano Borghi",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "08034045",
        name: "Varano de' Melegari",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "18080095",
        name: "Varapodio",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "07009065",
        name: "Varazze",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "12057073",
        name: "Varco Sabino",
        districtInitials: "RI",
        district: "Rieti",
        region: "Lazio"
    },
    {
        code: "03108045",
        name: "Varedo",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03097084",
        name: "Varenna",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03012133",
        name: "Varese",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "07011029",
        name: "Varese Ligure",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "01001289",
        name: "Varisella",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "06030130",
        name: "Varmo",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04021111",
        name: "Varna",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08034046",
        name: "Varsi",
        districtInitials: "PR",
        district: "Parma",
        region: "Emilia-Romagna"
    },
    {
        code: "03018171",
        name: "Varzi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01103071",
        name: "Varzo",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "12056055",
        name: "Vasanello",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "07008064",
        name: "Vasia",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "13069099",
        name: "Vasto",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "14094051",
        name: "Vastogirardi",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "01001290",
        name: "Vauda Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "18102046",
        name: "Vazzano",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "05026088",
        name: "Vazzola",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "09050037",
        name: "Vecchiano",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "03108046",
        name: "Vedano al Lambro",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03012134",
        name: "Vedano Olona",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05026089",
        name: "Vedelago",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03016230",
        name: "Vedeseta",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03108047",
        name: "Veduggio con Colzano",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "05028096",
        name: "Veggiano",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "16075092",
        name: "Veglie",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "01096075",
        name: "Veglio",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "12056056",
        name: "Vejano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03013236",
        name: "Veleso",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03018172",
        name: "Velezzo Lomellina",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "12058111",
        name: "Velletri",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "03018173",
        name: "Vellezzo Bellini",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05024115",
        name: "Velo d'Astico",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05023090",
        name: "Velo Veronese",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04021116",
        name: "Velturno",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "14094052",
        name: "Venafro",
        districtInitials: "IS",
        district: "Isernia",
        region: "Molise"
    },
    {
        code: "01001292",
        name: "Venaria Reale",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "11044073",
        name: "Venarotta",
        districtInitials: "AP",
        district: "Ascoli Piceno",
        region: "Marche"
    },
    {
        code: "01004237",
        name: "Venasca",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001291",
        name: "Venaus",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07009066",
        name: "Vendone",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03012136",
        name: "Venegono Inferiore",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03012137",
        name: "Venegono Superiore",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "19083104",
        name: "Venetico",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "05027042",
        name: "Venezia",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "03013238",
        name: "Veniano",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "17076095",
        name: "Venosa",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "08035046",
        name: "Ventasso",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "15064116",
        name: "Venticano",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "07008065",
        name: "Ventimiglia",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "19082077",
        name: "Ventimiglia di Sicilia",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "12059033",
        name: "Ventotene",
        districtInitials: "LT",
        district: "Latina",
        region: "Lazio"
    },
    {
        code: "06030131",
        name: "Venzone",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "04021112",
        name: "Verano",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "03108048",
        name: "Verano Brianza",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "01103072",
        name: "Verbania",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "18078153",
        name: "Verbicaro",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "03013239",
        name: "Vercana",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03014075",
        name: "Verceia",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "01002158",
        name: "Vercelli",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "03097086",
        name: "Vercurago",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03016232",
        name: "Verdellino",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016233",
        name: "Verdello",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03097091",
        name: "Verderio",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "01004238",
        name: "Verduno",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08037059",
        name: "Vergato",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "08040050",
        name: "Verghereto",
        districtInitials: "FC",
        district: "Forlì-Cesena",
        region: "Emilia-Romagna"
    },
    {
        code: "03012138",
        name: "Vergiate",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03015251",
        name: "Vermezzo con Zelo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "04022213",
        name: "Vermiglio",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01004239",
        name: "Vernante",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08033044",
        name: "Vernasca",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03015236",
        name: "Vernate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "07011030",
        name: "Vernazza",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "09100007",
        name: "Vernio",
        districtInitials: "PO",
        district: "Prato",
        region: "Toscana"
    },
    {
        code: "16075093",
        name: "Vernole",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03017195",
        name: "Verolanuova",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "03017196",
        name: "Verolavecchia",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01001293",
        name: "Verolengo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "12060085",
        name: "Veroli",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "05023091",
        name: "Verona",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "05023092",
        name: "Veronella",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "02007072",
        name: "Verrayes",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "02007073",
        name: "Verrès",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "03018174",
        name: "Verretto",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01096076",
        name: "Verrone",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03018175",
        name: "Verrua Po",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001294",
        name: "Verrua Savoia",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03013242",
        name: "Vertemate con Minoprio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03016234",
        name: "Vertova",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08099020",
        name: "Verucchio",
        districtInitials: "RN",
        district: "Rimini",
        region: "Emilia-Romagna"
    },
    {
        code: "03014076",
        name: "Vervio",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "06030132",
        name: "Verzegnis",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "18101027",
        name: "Verzino",
        districtInitials: "KR",
        district: "Crotone",
        region: "Calabria"
    },
    {
        code: "01004240",
        name: "Verzuolo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "05028097",
        name: "Vescovana",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03019113",
        name: "Vescovato",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "01005113",
        name: "Vesime",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01003158",
        name: "Vespolate",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "07008066",
        name: "Vessalico",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "05023093",
        name: "Vestenanova",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01001295",
        name: "Vestignè",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03017197",
        name: "Vestone",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "12056057",
        name: "Vetralla",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "08035042",
        name: "Vetto",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "01004241",
        name: "Vezza d'Alba",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017198",
        name: "Vezza d'Oglio",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "07011031",
        name: "Vezzano Ligure",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "08035043",
        name: "Vezzano sul Crostolo",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "07009067",
        name: "Vezzi Portio",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03020066",
        name: "Viadana",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03016235",
        name: "Viadanica",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "19087053",
        name: "Viagrande",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "01005114",
        name: "Viale",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01001296",
        name: "Vialfrè",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "08035044",
        name: "Viano",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "09046033",
        name: "Viareggio",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "01005115",
        name: "Viarigi",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "18102047",
        name: "Vibo Valentia",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "15065156",
        name: "Vibonati",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "12060086",
        name: "Vicalvi",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "19082078",
        name: "Vicari",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "09048049",
        name: "Vicchio",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "05024116",
        name: "Vicenza",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "16071059",
        name: "Vico del Gargano",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "15063086",
        name: "Vico Equense",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "12060087",
        name: "Vico nel Lazio",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "01004242",
        name: "Vicoforte",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "13068045",
        name: "Vicoli",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "01003159",
        name: "Vicolungo",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "09050038",
        name: "Vicopisano",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "12058112",
        name: "Vicovaro",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "20090082",
        name: "Viddalba",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "03018176",
        name: "Vidigulfo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05026090",
        name: "Vidor",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "01001298",
        name: "Vidracco",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "16071060",
        name: "Vieste",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "17076096",
        name: "Vietri di Potenza",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "15065157",
        name: "Vietri sul Mare",
        districtInitials: "SA",
        district: "Salerno",
        region: "Campania"
    },
    {
        code: "03097090",
        name: "Viganò",
        districtInitials: "LC",
        district: "Lecco",
        region: "Lombardia"
    },
    {
        code: "03016236",
        name: "Vigano San Martino",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08038022",
        name: "Vigarano Mainarda",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "05023094",
        name: "Vigasio",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "03018177",
        name: "Vigevano",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "17076097",
        name: "Viggianello",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "17076098",
        name: "Viggiano",
        districtInitials: "PZ",
        district: "Potenza",
        region: "Basilicata"
    },
    {
        code: "03012139",
        name: "Viggiù",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "05028098",
        name: "Vighizzolo d'Este",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01096077",
        name: "Vigliano Biellese",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01005116",
        name: "Vigliano d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "01006179",
        name: "Vignale Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "12056058",
        name: "Vignanello",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "03015237",
        name: "Vignate",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "08036046",
        name: "Vignola",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "04022216",
        name: "Vignola-Falesina",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01006180",
        name: "Vignole Borbera",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01004243",
        name: "Vignolo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01103074",
        name: "Vignone",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "05025065",
        name: "Vigo di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "05028099",
        name: "Vigodarzere",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03016237",
        name: "Vigolo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08033045",
        name: "Vigolzone",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "01001299",
        name: "Vigone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "05027043",
        name: "Vigonovo",
        districtInitials: "VE",
        district: "Venezia",
        region: "Veneto"
    },
    {
        code: "05028100",
        name: "Vigonza",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01006181",
        name: "Viguzzolo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05023095",
        name: "Villa Bartolomea",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "09046034",
        name: "Villa Basilica",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "03018178",
        name: "Villa Biscossi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03017199",
        name: "Villa Carcina",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "16074020",
        name: "Villa Castelli",
        districtInitials: "BR",
        district: "Brindisi",
        region: "Puglia"
    },
    {
        code: "13068046",
        name: "Villa Celiera",
        districtInitials: "PE",
        district: "Pescara",
        region: "Abruzzo"
    },
    {
        code: "09046035",
        name: "Villa Collemandina",
        districtInitials: "LU",
        district: "Lucca",
        region: "Toscana"
    },
    {
        code: "03015248",
        name: "Villa Cortese",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "03016238",
        name: "Villa d'Adda",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016239",
        name: "Villa d'Almè",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03016241",
        name: "Villa d'Ogna",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "01096078",
        name: "Villa del Bosco",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "05028101",
        name: "Villa del Conte",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "15061098",
        name: "Villa di Briano",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "03014077",
        name: "Villa di Chiavenna",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "03016240",
        name: "Villa di Serio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03014078",
        name: "Villa di Tirano",
        districtInitials: "SO",
        district: "Sondrio",
        region: "Lombardia"
    },
    {
        code: "05028102",
        name: "Villa Estense",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "07008067",
        name: "Villa Faraldi",
        districtInitials: "IM",
        district: "Imperia",
        region: "Liguria"
    },
    {
        code: "03013245",
        name: "Villa Guardia",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "04022222",
        name: "Villa Lagarina",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "12060088",
        name: "Villa Latina",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "15061099",
        name: "Villa Literno",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "08035045",
        name: "Villa Minozzo",
        districtInitials: "RE",
        district: "Reggio nell'Emilia",
        region: "Emilia-Romagna"
    },
    {
        code: "18080096",
        name: "Villa San Giovanni",
        districtInitials: "RC",
        district: "Reggio Calabria",
        region: "Calabria"
    },
    {
        code: "12056046",
        name: "Villa San Giovanni in Tuscia",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "20092099",
        name: "Villa San Pietro",
        districtInitials: "CA",
        district: "Cagliari",
        region: "Sardegna"
    },
    {
        code: "01005119",
        name: "Villa San Secondo",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "13066105",
        name: "Villa Sant'Angelo",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "20095048",
        name: "Villa Sant'Antonio",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "12060089",
        name: "Villa Santa Lucia",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "13066104",
        name: "Villa Santa Lucia degli Abruzzi",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "13069102",
        name: "Villa Santa Maria",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "06030133",
        name: "Villa Santina",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12060090",
        name: "Villa Santo Stefano",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "20095073",
        name: "Villa Verde",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "04021113",
        name: "Villabassa",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "19082079",
        name: "Villabate",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "03017200",
        name: "Villachiara",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20111096",
        name: "Villacidro",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01006182",
        name: "Villadeati",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05029048",
        name: "Villadose",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01103075",
        name: "Villadossola",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "01004244",
        name: "Villafalletto",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01005117",
        name: "Villafranca d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "05023096",
        name: "Villafranca di Verona",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "09045016",
        name: "Villafranca in Lunigiana",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "05028103",
        name: "Villafranca Padovana",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "01001300",
        name: "Villafranca Piemonte",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19084043",
        name: "Villafranca Sicula",
        districtInitials: "AG",
        district: "Agrigento",
        region: "Sicilia"
    },
    {
        code: "19083105",
        name: "Villafranca Tirrena",
        districtInitials: "ME",
        district: "Messina",
        region: "Sicilia"
    },
    {
        code: "19082080",
        name: "Villafrati",
        districtInitials: "PA",
        district: "Palermo",
        region: "Sicilia"
    },
    {
        code: "05024117",
        name: "Villaga",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "20091101",
        name: "Villagrande Strisaili",
        districtInitials: "NU",
        district: "Nuoro",
        region: "Sardegna"
    },
    {
        code: "13066103",
        name: "Villalago",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "19085022",
        name: "Villalba",
        districtInitials: "CL",
        district: "Caltanissetta",
        region: "Sicilia"
    },
    {
        code: "13069100",
        name: "Villalfonsina",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "01006183",
        name: "Villalvernia",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "13069101",
        name: "Villamagna",
        districtInitials: "CH",
        district: "Chieti",
        region: "Abruzzo"
    },
    {
        code: "15064117",
        name: "Villamaina",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "20111097",
        name: "Villamar",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "05029049",
        name: "Villamarzana",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "20111098",
        name: "Villamassargia",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01006184",
        name: "Villamiroglio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "04021114",
        name: "Villandro",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01096079",
        name: "Villanova Biellese",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "01001301",
        name: "Villanova Canavese",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "07009068",
        name: "Villanova d'Albenga",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "03018179",
        name: "Villanova d'Ardenghi",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01005118",
        name: "Villanova d'Asti",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "15064118",
        name: "Villanova del Battista",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "05029050",
        name: "Villanova del Ghebbo",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "03098060",
        name: "Villanova del Sillaro",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "05028104",
        name: "Villanova di Camposampiero",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "05029051",
        name: "Villanova Marchesana",
        districtInitials: "RO",
        district: "Rovigo",
        region: "Veneto"
    },
    {
        code: "01004245",
        name: "Villanova Mondovì",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01006185",
        name: "Villanova Monferrato",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "20090078",
        name: "Villanova Monteleone",
        districtInitials: "SS",
        district: "Sassari",
        region: "Sardegna"
    },
    {
        code: "01004246",
        name: "Villanova Solaro",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "08033046",
        name: "Villanova sull'Arda",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "20095071",
        name: "Villanova Truschedu",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "20111099",
        name: "Villanova Tulo",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111100",
        name: "Villanovaforru",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111101",
        name: "Villanovafranca",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03018180",
        name: "Villanterio",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03017201",
        name: "Villanuova sul Clisi",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "20111102",
        name: "Villaperuccio",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "18078154",
        name: "Villapiana",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "20111103",
        name: "Villaputzu",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01001303",
        name: "Villar Dora",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001305",
        name: "Villar Focchiardo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001306",
        name: "Villar Pellice",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01001307",
        name: "Villar Perosa",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004247",
        name: "Villar San Costanzo",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "01001302",
        name: "Villarbasse",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002163",
        name: "Villarboit",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "01001304",
        name: "Villareggia",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15063087",
        name: "Villaricca",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "01006186",
        name: "Villaromagnano",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "19086020",
        name: "Villarosa",
        districtInitials: "EN",
        district: "Enna",
        region: "Sicilia"
    },
    {
        code: "20111104",
        name: "Villasalto",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "03108049",
        name: "Villasanta",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "20111105",
        name: "Villasimius",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111106",
        name: "Villasor",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "20111107",
        name: "Villaspeciosa",
        districtInitials: "SU",
        district: "Sud Sardegna",
        region: "Sardegna"
    },
    {
        code: "01001308",
        name: "Villastellone",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01002164",
        name: "Villata",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "20095072",
        name: "Villaurbana",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "13066106",
        name: "Villavallelonga",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "05024118",
        name: "Villaverla",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "04022249",
        name: "Ville d'Anaunia",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "04022254",
        name: "Ville di Fiemme",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "02007074",
        name: "Villeneuve",
        districtInitials: "AO",
        district: "Valle d'Aosta/Vallée d'Aoste",
        region: "Valle d'Aosta/Vallée d'Aoste"
    },
    {
        code: "06031025",
        name: "Villesse",
        districtInitials: "GO",
        district: "Gorizia",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "13066107",
        name: "Villetta Barrea",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "01103076",
        name: "Villette",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "03020068",
        name: "Villimpenta",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "03016242",
        name: "Villongo",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05026091",
        name: "Villorba",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03016243",
        name: "Vilminore di Scalve",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "03108050",
        name: "Vimercate",
        districtInitials: "MB",
        district: "Monza e della Brianza",
        region: "Lombardia"
    },
    {
        code: "03015242",
        name: "Vimodrone",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "01004248",
        name: "Vinadio",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "14070084",
        name: "Vinchiaturo",
        districtInitials: "CB",
        district: "Campobasso",
        region: "Molise"
    },
    {
        code: "01005120",
        name: "Vinchio",
        districtInitials: "AT",
        district: "Asti",
        region: "Piemonte"
    },
    {
        code: "09048050",
        name: "Vinci",
        districtInitials: "FI",
        district: "Firenze",
        region: "Toscana"
    },
    {
        code: "01001309",
        name: "Vinovo",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01003164",
        name: "Vinzaglio",
        districtInitials: "NO",
        district: "Novara",
        region: "Piemonte"
    },
    {
        code: "01004249",
        name: "Viola",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "03017202",
        name: "Vione",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "04021115",
        name: "Vipiteno",
        districtInitials: "BZ",
        district: "Bolzano/Bozen",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "01001310",
        name: "Virle Piemonte",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03017203",
        name: "Visano",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "01001311",
        name: "Vische",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "15063088",
        name: "Visciano",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "06030135",
        name: "Visco",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01006187",
        name: "Visone",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "11043057",
        name: "Visso",
        districtInitials: "MC",
        district: "Macerata",
        region: "Marche"
    },
    {
        code: "03018181",
        name: "Vistarino",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01001312",
        name: "Vistrorio",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "19081023",
        name: "Vita",
        districtInitials: "TP",
        district: "Trapani",
        region: "Sicilia"
    },
    {
        code: "12056059",
        name: "Viterbo",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "12060091",
        name: "Viticuso",
        districtInitials: "FR",
        district: "Frosinone",
        region: "Lazio"
    },
    {
        code: "06093049",
        name: "Vito d'Asio",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12056060",
        name: "Vitorchiano",
        districtInitials: "VT",
        district: "Viterbo",
        region: "Lazio"
    },
    {
        code: "19088012",
        name: "Vittoria",
        districtInitials: "RG",
        district: "Ragusa",
        region: "Sicilia"
    },
    {
        code: "05026092",
        name: "Vittorio Veneto",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "13066108",
        name: "Vittorito",
        districtInitials: "AQ",
        district: "L'Aquila",
        region: "Abruzzo"
    },
    {
        code: "03015243",
        name: "Vittuone",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "15062077",
        name: "Vitulano",
        districtInitials: "BN",
        district: "Benevento",
        region: "Campania"
    },
    {
        code: "15061100",
        name: "Vitulazio",
        districtInitials: "CE",
        district: "Caserta",
        region: "Campania"
    },
    {
        code: "01001313",
        name: "Viù",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "06093050",
        name: "Vivaro",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "12058113",
        name: "Vivaro Romano",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "01096080",
        name: "Viverone",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "19087054",
        name: "Vizzini",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "03012140",
        name: "Vizzola Ticino",
        districtInitials: "VA",
        district: "Varese",
        region: "Lombardia"
    },
    {
        code: "03015244",
        name: "Vizzolo Predabissi",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "05028105",
        name: "Vo'",
        districtInitials: "PD",
        district: "Padova",
        region: "Veneto"
    },
    {
        code: "03017204",
        name: "Vobarno",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "07010066",
        name: "Vobbia",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "01002166",
        name: "Vocca",
        districtInitials: "VC",
        district: "Vercelli",
        region: "Piemonte"
    },
    {
        code: "05025066",
        name: "Vodo Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "03018182",
        name: "Voghera",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "08038023",
        name: "Voghiera",
        districtInitials: "FE",
        district: "Ferrara",
        region: "Emilia-Romagna"
    },
    {
        code: "01103077",
        name: "Vogogna",
        districtInitials: "VB",
        district: "Verbano-Cusio-Ossola",
        region: "Piemonte"
    },
    {
        code: "04022224",
        name: "Volano",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "15063089",
        name: "Volla",
        districtInitials: "NA",
        district: "Napoli",
        region: "Campania"
    },
    {
        code: "03019114",
        name: "Volongo",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "05026093",
        name: "Volpago del Montello",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "03018183",
        name: "Volpara",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "01006188",
        name: "Volpedo",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01006189",
        name: "Volpeglino",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "01001314",
        name: "Volpiano",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "03020070",
        name: "Volta Mantovana",
        districtInitials: "MN",
        district: "Mantova",
        region: "Lombardia"
    },
    {
        code: "01006190",
        name: "Voltaggio",
        districtInitials: "AL",
        district: "Alessandria",
        region: "Piemonte"
    },
    {
        code: "05025067",
        name: "Voltago Agordino",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "09050039",
        name: "Volterra",
        districtInitials: "PI",
        district: "Pisa",
        region: "Toscana"
    },
    {
        code: "03019115",
        name: "Voltido",
        districtInitials: "CR",
        district: "Cremona",
        region: "Lombardia"
    },
    {
        code: "16071061",
        name: "Volturara Appula",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "15064119",
        name: "Volturara Irpina",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "16071062",
        name: "Volturino",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "01001315",
        name: "Volvera",
        districtInitials: "TO",
        district: "Torino",
        region: "Piemonte"
    },
    {
        code: "01004250",
        name: "Vottignasco",
        districtInitials: "CN",
        district: "Cuneo",
        region: "Piemonte"
    },
    {
        code: "18102048",
        name: "Zaccanopoli",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "19087055",
        name: "Zafferana Etnea",
        districtInitials: "CT",
        district: "Catania",
        region: "Sicilia"
    },
    {
        code: "18079157",
        name: "Zagarise",
        districtInitials: "CZ",
        district: "Catanzaro",
        region: "Calabria"
    },
    {
        code: "12058114",
        name: "Zagarolo",
        districtInitials: "RM",
        district: "Roma",
        region: "Lazio"
    },
    {
        code: "18102049",
        name: "Zambrone",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    },
    {
        code: "03016244",
        name: "Zandobbio",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "05024119",
        name: "Zanè",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "03016245",
        name: "Zanica",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "16071064",
        name: "Zapponeta",
        districtInitials: "FG",
        district: "Foggia",
        region: "Puglia"
    },
    {
        code: "03018184",
        name: "Zavattarello",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03018185",
        name: "Zeccone",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "20095074",
        name: "Zeddiani",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "03013246",
        name: "Zelbio",
        districtInitials: "CO",
        district: "Como",
        region: "Lombardia"
    },
    {
        code: "03098061",
        name: "Zelo Buon Persico",
        districtInitials: "LO",
        district: "Lodi",
        region: "Lombardia"
    },
    {
        code: "03018186",
        name: "Zeme",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03018187",
        name: "Zenevredo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "05026094",
        name: "Zenson di Piave",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "08033047",
        name: "Zerba",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03018188",
        name: "Zerbo",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "03018189",
        name: "Zerbolò",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "20095075",
        name: "Zerfaliu",
        districtInitials: "OR",
        district: "Oristano",
        region: "Sardegna"
    },
    {
        code: "09045017",
        name: "Zeri",
        districtInitials: "MS",
        district: "Massa-Carrara",
        region: "Toscana"
    },
    {
        code: "05024120",
        name: "Zermeghedo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "05026095",
        name: "Zero Branco",
        districtInitials: "TV",
        district: "Treviso",
        region: "Veneto"
    },
    {
        code: "05023097",
        name: "Zevio",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "04022226",
        name: "Ziano di Fiemme",
        districtInitials: "TN",
        district: "Trento",
        region: "Trentino-Alto Adige/Südtirol"
    },
    {
        code: "08033048",
        name: "Ziano Piacentino",
        districtInitials: "PC",
        district: "Piacenza",
        region: "Emilia-Romagna"
    },
    {
        code: "03015247",
        name: "Zibido San Giacomo",
        districtInitials: "MI",
        district: "Milano",
        region: "Lombardia"
    },
    {
        code: "07011032",
        name: "Zignago",
        districtInitials: "SP",
        district: "La Spezia",
        region: "Liguria"
    },
    {
        code: "05023098",
        name: "Zimella",
        districtInitials: "VR",
        district: "Verona",
        region: "Veneto"
    },
    {
        code: "01096081",
        name: "Zimone",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "03018190",
        name: "Zinasco",
        districtInitials: "PV",
        district: "Pavia",
        region: "Lombardia"
    },
    {
        code: "07010067",
        name: "Zoagli",
        districtInitials: "GE",
        district: "Genova",
        region: "Liguria"
    },
    {
        code: "08036047",
        name: "Zocca",
        districtInitials: "MO",
        district: "Modena",
        region: "Emilia-Romagna"
    },
    {
        code: "03016246",
        name: "Zogno",
        districtInitials: "BG",
        district: "Bergamo",
        region: "Lombardia"
    },
    {
        code: "08037060",
        name: "Zola Predosa",
        districtInitials: "BO",
        district: "Bologna",
        region: "Emilia-Romagna"
    },
    {
        code: "16075094",
        name: "Zollino",
        districtInitials: "LE",
        district: "Lecce",
        region: "Puglia"
    },
    {
        code: "03017205",
        name: "Zone",
        districtInitials: "BS",
        district: "Brescia",
        region: "Lombardia"
    },
    {
        code: "05025069",
        name: "Zoppè di Cadore",
        districtInitials: "BL",
        district: "Belluno",
        region: "Veneto"
    },
    {
        code: "06093051",
        name: "Zoppola",
        districtInitials: "PN",
        district: "Pordenone",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "05024121",
        name: "Zovencedo",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "01096082",
        name: "Zubiena",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "07009069",
        name: "Zuccarello",
        districtInitials: "SV",
        district: "Savona",
        region: "Liguria"
    },
    {
        code: "05024122",
        name: "Zugliano",
        districtInitials: "VI",
        district: "Vicenza",
        region: "Veneto"
    },
    {
        code: "06030136",
        name: "Zuglio",
        districtInitials: "UD",
        district: "Udine",
        region: "Friuli-Venezia Giulia"
    },
    {
        code: "01096083",
        name: "Zumaglia",
        districtInitials: "BI",
        district: "Biella",
        region: "Piemonte"
    },
    {
        code: "18078155",
        name: "Zumpano",
        districtInitials: "CS",
        district: "Cosenza",
        region: "Calabria"
    },
    {
        code: "15064120",
        name: "Zungoli",
        districtInitials: "AV",
        district: "Avellino",
        region: "Campania"
    },
    {
        code: "18102050",
        name: "Zungri",
        districtInitials: "VV",
        district: "Vibo Valentia",
        region: "Calabria"
    }
]